import originJsonp from 'jsonp';
import Clipboard from 'clipboard';
import axios from 'axios';
export { default as axios } from 'axios';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { convertObjToUrlSearch } from '@survey/util';

function jsonp(url, data, option) {
    url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);
    return new Promise((resolve, reject) => {
        originJsonp(url, option, (err, data) => {
            if (!err) {
                resolve(data);
            }
            else {
                reject(err);
            }
        });
    });
}
function param(data) {
    let url = '';
    for (const k in data) {
        let value = data[k] !== undefined ? data[k] : '';
        url += '&' + k + '=' + encodeURIComponent(value);
    }
    return url ? url.substring(1) : '';
}

const request = axios.create();
const convertRequest = axios.create({
    baseURL: window.location.origin,
});
convertRequest.interceptors.response.use(res => {
    return res.data;
});
const createReRequest = () => {
    const instance = axios.create({
        baseURL: window.location.origin
    });
    instance.interceptors.response.use(res => {
        return res.data;
    }, error => {
        const config = error.config;
        const is_timeout = error.code === "ECONNABORTED" && (config.reCount || 0) < 3;
        const is_retry = error.response && error.response.status >= 500 && error.isAxiosError && (config.reCount || 0) < 10;
        if (is_timeout || is_retry) {
            config.reCount = (config.reCount || 0) + 1;
            return instance(config);
        }
        return Promise.reject(error);
    });
    return instance;
};
const reRequest = createReRequest();
const setRequestInterceptors = function (transform) {
    request.interceptors.request.use(transform);
    convertRequest.interceptors.request.use(transform);
    reRequest.interceptors.request.use(transform);
};
const setResponseInterceptors = function (...args) {
    request.interceptors.response.use(...args);
    convertRequest.interceptors.response.use(...args);
    reRequest.interceptors.response.use(...args);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const defaultsSurveyAttr = {
    welcome: '感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！'
};
// export const GD_KEY = '7bd1074152ac09c17080952b9ed1aa55'
// export const GD_KEY = '544a0f9cbeaa8989627e8fb101708ad3'
// export const GD_KEY = '58fcd2e537a1da4b577ef5f2d7e2daca'
const GD_KEY = '3b3590d07b87fb4b49c74d0a00dece14';
const SEPARATOR = '|'; // 地理位置答案分割符
const SelectType = {
    Include: 'contain',
    NotInclude: 'not_contain',
    Equal: 'eq',
    NotEqual: 'ne',
    Select: 'contain',
    NotSelect: 'not_contain',
    Null: 'is_null',
    NotNull: 'not_null',
    Show: 'display',
    Hidden: 'hidden',
    GT: 'gt',
    GTEqual: 'ge',
    LT: 'lt',
    LTEqual: 'le',
    Between: 'between',
    NotBetween: 'not_between'
};
/**
 * 北京清研灵智科技有限公司 7
 * 贵州清研灵智信息咨询有限公司 1451012
 * 优数研科环境科技（北京）有限公司 1451011
 * 北京数太奇科技有限公司 32
 * 北京奕捷科技有限责任公司 1450982
 * 北京达洲信息咨询有限公司 1451052
 * 北京清研灵智文化传播有限公司 1451082
 * 现阶段是如上【7】家企业可签署协议，签署人为企业管理员身份可签署，企业签署后，可使用结算
 */
const cost_settlement_available_companyIds = [7, 1451012, 1451011, 32, 1450982, 1451052, 1451082];
const OAUTH_INFO_API_URL = '/award/oauthInfo';

// 双向支持url参数解析（hash和search先后顺序不同都能获取到参数）
function normalizeUrlParamsDouble() {
    const href = window.location.href || '';
    const sIndex = href.indexOf('?');
    if (sIndex === -1)
        return {};
    const hIndex = href.indexOf('#');
    const result = {};
    let kvstr = '';
    if (sIndex < hIndex) {
        // ?在#前面
        const search = window.location.search || '';
        kvstr = search.replace(/^\?|\/$/g, '');
    }
    else {
        // #在?前面
        kvstr = href.split('?')[1] || '';
    }
    kvstr.split('&').forEach(kv => {
        const [k, v] = kv.split('=');
        result[k] = v;
    });
    return result;
}
function normalizeUrlParams(needNull = false, url = '') {
    const result = {};
    url = url || window.location.href.split('#')[0];
    let kvstr = url.split('?')[1];
    if (!kvstr) {
        return result;
    }
    kvstr.split('&').forEach(kv => {
        const [k, v] = kv.split('=');
        if (!needNull) {
            if (['null', 'undefined'].includes(v))
                return;
        }
        result[k] = v;
    });
    return result;
}
function objectToQuery(obj) {
    let params = [];
    Object.keys(obj).forEach(key => {
        params.push(`${key}=${obj[key]}`);
    });
    return params.join('&');
}
function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * 乱序方法
 * @param{Array} arr
 * @return {Array} 乱序之后的数组
 */
function shuffle(arr) {
    let _arr = arr.slice();
    for (let i = 0; i < _arr.length; i++) {
        let j = getRandomInt(0, i);
        let t = _arr[i];
        _arr[i] = _arr[j];
        _arr[j] = t;
    }
    return _arr;
}
function registerMixin(components, mixins) {
    mixins = Array.isArray(mixins) ? mixins : [mixins];
    Object.keys(components).forEach(key => {
        const c = components[key];
        if (!c.mixins) {
            c.mixins = [];
        }
        mixins.forEach((mixin) => {
            let m = typeof mixin === 'function' ? mixin(c) : mixin;
            c.mixins.push(m);
        });
    });
}
function once(handler) {
    let isRun = false;
    return function () {
        if (isRun)
            return;
        handler && handler();
        isRun = true;
    };
}
function addEventListener(dom, event, handler) {
    dom.addEventListener(event, handler);
    return function () {
        dom.removeEventListener(event, handler);
    };
}
function filterParams(data, option) {
    let { needNoopStr, ignoreKeys } = option || {};
    let result = {};
    Object.keys(data).forEach(k => {
        let key = k;
        let val = data[key];
        if (ignoreKeys && ignoreKeys.includes(k))
            return;
        let valType = typeof val;
        if (valType === 'boolean' || valType === 'number' || (needNoopStr && valType === 'string')) {
            result[key] = val;
        }
        else if (val) {
            result[key] = val;
        }
    });
    return result;
}
function copyText(selector, text) {
    let clipboard = new Clipboard(selector, {
        text(elem) {
            return text;
        }
    });
    return new Promise((resolve, reject) => {
        clipboard.on('success', () => {
            clipboard.destroy();
            resolve(true);
        });
        clipboard.on('error', () => {
            clipboard.destroy();
            reject(false);
        });
    });
}
function downloadFileByUrl(url, downloadName) {
    let link = document.createElement('a');
    link.download = downloadName;
    link.href = url;
    link.click();
}
// 表单序列化
const serialize = (data) => {
    const list = [];
    Object.keys(data).forEach(ele => {
        list.push(`${ele}=${data[ele]}`);
    });
    return list.join('&');
};
// dataURL转换成blob
const dataURLToBlob = (dataurl) => {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = window.atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};
function hasValue(val) {
    if (val === 0)
        return true;
    if (typeof val === 'boolean')
        return true;
    return !!val;
}
function padLeft(value, char, num = 2) {
    let val = value.toString();
    let len = val.length;
    if (len < num) {
        val = char.repeat(num - len) + val;
    }
    return val;
}
function formatSeconds(value) {
    let secondTime = parseInt(value.toString()); // 秒
    let minuteTime = 0; // 分
    let hourTime = 0; // 小时
    if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = (secondTime / 60) | 0;
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = secondTime % 60;
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
            //获取小时，获取分钟除以60，得到整数小时
            hourTime = (minuteTime / 60) | 0;
            //获取小时后取佘的分，获取分钟除以60取佘的分
            minuteTime = minuteTime % 60;
        }
    }
    let day = 0;
    if (hourTime >= 24) {
        day = (hourTime / 24) | 0;
        hourTime = hourTime % 24;
    }
    let result = '';
    result = result + '' + padLeft(secondTime, '0');
    result = padLeft(minuteTime, '0') + ':' + result;
    result = padLeft(hourTime, '0') + ':' + result;
    if (day > 0) {
        result = `${day}天` + result;
    }
    return result;
}
function secondToTime(val, splits = []) {
    const result = formatSeconds(val);
    const vals = result.split(':');
    let res = [];
    let tmp = '';
    while ((tmp = vals.pop())) {
        if (tmp === '00')
            continue;
        res.push(tmp + (splits.pop() || ''));
    }
    return res.reverse().join('');
}
function isWeixin() {
    let ua = navigator.userAgent.toLowerCase();
    let res = ua.match(/MicroMessenger/i);
    let work = ua.match(/wxwork/i);
    if (!res)
        return false;
    if (work) {
        if (work[0] === "wxwork") {
            return false;
        }
    }
    return String(res[0]).toUpperCase() == 'micromessenger'.toUpperCase();
}
function getH5Platform() {
    const res = {
        weixin: false,
        alipay: false
    };
    let ua = navigator.userAgent.toLowerCase();
    if (isWeixin()) {
        res.weixin = true;
    }
    else if (ua.includes('alipayclient')) {
        res.alipay = true;
    }
    return res;
}
function isPC() {
    let userAgentInfo = navigator.userAgent;
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}
function merge(source1, source2, mergeOption) {
    const result = {};
    let keys = Object.keys(source1);
    let keys2 = Object.keys(source2);
    for (const key of keys) {
        const handler = mergeOption === null || mergeOption === void 0 ? void 0 : mergeOption[key];
        if (handler) {
            result[key] = handler(source1[key], source2[key]);
        }
        else {
            if (hasValue(source1[key])) {
                result[key] = source1[key];
            }
            else {
                result[key] = source2[key];
            }
        }
    }
    for (const key of keys2) {
        if (!result[key]) {
            result[key] = source2[key];
        }
    }
    return result;
}
function loadScript(url) {
    return new Promise((resolve, reject) => {
        let scriptElement = document.createElement('script');
        scriptElement.src = url;
        scriptElement.onload = function (e) {
            console.log(e);
            resolve(null);
        };
        scriptElement.onerror = function () {
            reject();
        };
        document.body.appendChild(scriptElement);
    });
}
/**
 *
 * @param date1
 * @param date2
 * @param type 年 月 日 时 分 秒 （1 | 2 | 3 | 4 | 5 | 6）
 */
function compareDate(date1, date2, type) {
    const y1 = date1.getFullYear();
    const y2 = date2.getFullYear();
    if (y1 === y2) {
        if (type === 1)
            return 0;
        const M1 = date1.getMonth() + 1;
        const M2 = date2.getMonth() + 1;
        if (M1 === M2) {
            if (type === 2)
                return 0;
            const d1 = date1.getDate();
            const d2 = date2.getDate();
            if (d1 === d2) {
                if (type === 3)
                    return 0;
                const h1 = date1.getHours();
                const h2 = date2.getHours();
                if (h1 === h2) {
                    if (type === 4)
                        return 0;
                    const m1 = date1.getMinutes();
                    const m2 = date2.getMinutes();
                    if (m1 === m2) {
                        if (type === 5)
                            return 0;
                        const s1 = date1.getSeconds();
                        const s2 = date2.getSeconds();
                        return s1 === s2 ? 0 : s1 > s2 ? 1 : -1;
                    }
                    else {
                        return m1 > m2 ? 1 : -1;
                    }
                }
                else {
                    return h1 > h2 ? 1 : -1;
                }
            }
            else {
                return d1 > d2 ? 1 : -1;
            }
        }
        else {
            return M1 > M2 ? 1 : -1;
        }
    }
    else {
        return y1 > y2 ? 1 : -1;
    }
}
function copyProperty(target, source) {
    const keys = Object.keys(target);
    keys.forEach(key => {
        // @ts-ignore
        target[key] = source[key] || target[key];
    });
}
function getComponentFactory(components = {}) {
    return function getComponentName(type) {
        let s = Object.keys(components).find(key => {
            let t = components[key].type;
            if (Array.isArray(t)) {
                return t.includes(type);
            }
            else {
                return t === type;
            }
        });
        if (!s) {
            return null;
        }
        return components[s];
    };
}
/**
 * 简易判断两个对象是否一致
 * @param val1
 * @param val2
 */
function isSameValue(val1, val2) {
    if (val1 === null && val2 === null)
        return true;
    if (val1 === undefined && val2 === undefined)
        return true;
    const val1_type = typeof val1;
    const val2_type = typeof val2;
    if (val1_type !== val2_type)
        return false;
    if (Array.isArray(val1) && Array.isArray(val2)) {
        if (val1.length !== val2.length)
            return false;
        return val1.every((item, index) => {
            return isSameValue(item, val2[index]);
        });
    }
    else if (val1_type === 'object' && val2_type === 'object') {
        const val1_keys = Object.keys(val1);
        const val2_keys = Object.keys(val2);
        const isSame = isSameValue(val1_keys, val2_keys);
        if (!isSame)
            return false;
        return val1_keys.every(key => {
            const v1 = val1[key];
            const v2 = val2[key];
            return isSameValue(v1, v2);
        });
    }
    return val1 === val2;
}

/**
 * 判断是否为空
 */
function validatenull(val) {
    if (typeof val === 'boolean') {
        return false;
    }
    if (typeof val === 'number') {
        return false;
    }
    if (val instanceof Array) {
        if (val.length === 0)
            return true;
    }
    else if (val instanceof Object) {
        if (JSON.stringify(val) === '{}')
            return true;
    }
    else {
        if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '')
            return true;
        return false;
    }
    return false;
}

const keyName = 'wjb' + '-';
/**
 * 存储localStorage
 */
const setStore = (params = {}) => {
    let { name, content, type } = params;
    name = keyName + name;
    const obj = {
        dataType: typeof content,
        content: content,
        type: type,
        datetime: new Date().getTime()
    };
    if (type)
        window.sessionStorage.setItem(name, JSON.stringify(obj));
    else
        window.localStorage.setItem(name, JSON.stringify(obj));
};
/**
 * 获取localStorage
 */
const getStore = (params = {}) => {
    let { name, debug } = params;
    name = keyName + name;
    let obj;
    let content;
    obj = window.sessionStorage.getItem(name);
    if (validatenull(obj))
        obj = window.localStorage.getItem(name);
    if (validatenull(obj))
        return;
    try {
        obj = JSON.parse(obj);
    }
    catch (e) {
        return obj;
    }
    if (debug) {
        return obj;
    }
    if (obj.dataType === 'string') {
        content = obj.content;
    }
    else if (obj.dataType === 'number') {
        content = Number(obj.content);
    }
    else if (obj.dataType === 'boolean') {
        content = obj.content === true;
    }
    else if (obj.dataType === 'object') {
        content = obj.content;
    }
    return content;
};
/**
 * 删除localStorage
 */
const removeStore = (params = {}) => {
    let { name, type } = params;
    name = keyName + name;
    if (type) {
        window.sessionStorage.removeItem(name);
    }
    else {
        window.localStorage.removeItem(name);
    }
};
/**
 * 获取全部localStorage
 */
const getAllStore = (params = {}) => {
    const list = [];
    const { type } = params;
    if (type) {
        for (let i = 0; i <= window.sessionStorage.length; i++) {
            list.push({
                name: window.sessionStorage.key(i),
                content: getStore({
                    name: window.sessionStorage.key(i),
                    type: 'session'
                })
            });
        }
    }
    else {
        for (let i = 0; i <= window.localStorage.length; i++) {
            list.push({
                name: window.localStorage.key(i),
                content: getStore({
                    name: window.localStorage.key(i)
                })
            });
        }
    }
    return list;
};
/**
 * 清空全部localStorage
 */
const clearStore = (params = {}) => {
    const { type } = params;
    if (type) {
        window.sessionStorage.clear();
    }
    else {
        window.localStorage.clear();
    }
};

class PostMessage {
    constructor(targetOrigin) {
        this.targetOrigin = targetOrigin;
        this.targetOrigin = targetOrigin;
    }
    sendMessage(type, data) {
        if (window.top === window)
            return;
        const message = {
            message: type,
            payload: data
        };
        if (window.top) {
            window.top.postMessage(JSON.stringify(message), this.targetOrigin);
        }
    }
}

const imageFiles = ['.gif', '.png', '.jpg', '.jpeg'];
const docFiles = ['.doc', '.docx', '.pdf', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'];
const zipFiles = ['.rar', '.zip', '.gzip'];
const videoFiles = ['.mp4', '.m3u8', '.flv', '.f4v', '.webm', '.mov', '.m4v', '.3gp', '.avi', '.wmv'];
const audioFiles = ['.mp3', '.wma', '.wav', '.amr', '.m4a'];
const MB = 1024 * 1024;
const KB = 1024;
const UploadConfig = {
    SM_SIZE: MB * 5,
    LARGE_SIZE: MB * 20
};
const FileErrorCode = {
    MAX_SIZE: 1,
    NO_ALLOW_TYPE: 2
};
function isOnlyImageType(types) {
    if (!types.length)
        return false;
    if (types.length > imageFiles.length) {
        return false;
    }
    if (types.length === 1 && types[0] === 'img')
        return true;
    return types.every(t => {
        return imageFiles.includes(t);
    });
}
function checkFileType(file, allowTypes = []) {
    if (allowTypes.length === 0)
        return true;
    let fileSuffix = file.name.split('.').pop();
    let [, suffix] = file.type.split('/');
    let types = [fileSuffix === null || fileSuffix === void 0 ? void 0 : fileSuffix.toLowerCase(), suffix === null || suffix === void 0 ? void 0 : suffix.toLowerCase(), '.' + (fileSuffix === null || fileSuffix === void 0 ? void 0 : fileSuffix.toLowerCase())];
    return allowTypes.some(type => types.includes(type));
}
function checkFile(file, opt) {
    let error;
    let maxSize = opt.maxSize || Infinity;
    if (opt.unit === 'MB') {
        maxSize = maxSize * MB;
    }
    else if (opt.unit === 'KB') {
        maxSize = maxSize * KB;
    }
    let allowTypes = opt.allowTypes || [];
    if (!checkFileType(file, allowTypes)) {
        error = {
            code: FileErrorCode.NO_ALLOW_TYPE,
            msg: `不支持的文件类型`
        };
    }
    else if (file.size > maxSize) {
        error = {
            code: FileErrorCode.MAX_SIZE,
            msg: `文件最大不可超过 ${(maxSize / MB) | 0}MB`
        };
    }
    return error;
}
function uploadFile(maxSize = Infinity, allowTypes = [], option) {
    let opt;
    if (typeof maxSize === 'object') {
        opt = maxSize;
    }
    else if (typeof allowTypes === 'object' && !Array.isArray(allowTypes)) {
        opt = allowTypes;
        opt.maxSize = maxSize;
    }
    else {
        let o = (option || {});
        o.maxSize = maxSize;
        o.allowTypes = allowTypes;
        opt = o;
    }
    return new Promise((resolve, reject) => {
        let { success, error } = opt;
        success = success || resolve;
        error = error || reject;
        let inputElement;
        if (opt.el) {
            inputElement = opt.el;
        }
        else {
            inputElement = document.createElement('input');
            if (opt.accept) {
                inputElement.accept = opt.accept;
            }
            else if (isOnlyImageType(allowTypes)) {
                inputElement.accept = 'image/*';
            }
            inputElement.type = 'file';
            inputElement.multiple = !!opt.multiple;
        }
        inputElement.onchange = function (event) {
            if (inputElement.files) {
                if (opt.multiple) {
                    let files = Array.from(inputElement.files);
                    inputElement.value = '';
                    if (files) {
                        let errorRes = null;
                        for (let i = 0, len = files.length; i < len; i++) {
                            let file = files[i];
                            let err = checkFile(file, opt);
                            if (err) {
                                errorRes = err;
                                break;
                            }
                        }
                        if (errorRes) {
                            error(errorRes);
                        }
                        else {
                            success(files);
                        }
                    }
                }
                else {
                    let file = inputElement.files[0];
                    inputElement.value = '';
                    if (file) {
                        let err = checkFile(file, opt);
                        if (err) {
                            error(err);
                        }
                        else {
                            success(file);
                        }
                    }
                }
            }
        };
        if (!opt.el) {
            inputElement.click();
        }
    });
}
function stream2Blob(stream) {
    return new Blob([stream], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
}
function downloadFileByStream(stream, responseHeaders) {
    const blob = stream2Blob(stream);
    let contentDisposition = responseHeaders['content-disposition'];
    let patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*');
    let result = patt.exec(contentDisposition);
    let fileName = result[1];
    const elink = document.createElement('a');
    let reg = /^["](.*)["]$/g;
    elink.download = decodeURI(fileName.replace(reg, '$1'));
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blob);
    elink.click();
    URL.revokeObjectURL(elink.href); //释放掉blob对象
}

function nameRule(val = '') {
    return /^[\u2E80-\u9FFF]{2,4}$/.test(val);
}
function emailRule(val) {
    const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(val);
}
function phoneRule(val) {
    return /^1[3-9]\d{9}$/.test(val);
}
//匹配正整数
function positiveInteger(val) {
    return /^[1-9]\d*$/.test(val);
}
//匹配正整数+小数
function positiveIntegerAndDigit(val) {
    return /^[0-9]\d*\.?\d{0,2}$/.test(val);
}
function isNum(val) {
    return /^\d+$/.test(val);
}
//匹配整数(带负数)
function integer(val) {
    return /^-?[1-9]\d*$/.test(val);
}
//匹配整数(带负数、小数)
function integerAndDigit(val, digit = 2) {
    let reg = new RegExp(`^-?([0-9]\\d*\\.?\\d{0,${digit}})?$`);
    return reg.test(val);
}
/**
 * 是否是中文+字符
 * @param val
 */
function validateChinese(val) {
    // return !/[A-Za-z]/.test(val)
    return /^[\u2E80-\u9FFF]+$/.test(val);
}
/**
 * 是否是英文+字符
 * @param val
 */
function validateChar(val) {
    return /^\w+$/.test(val);
}
function checkYMD(str) {
    let y = Number(str.substr(0, 4));
    let m = Number(str.substr(4, 2));
    let d = Number(str.substr(6, 2));
    let isLeapYear = y % 4 === 0;
    let has_31 = [1, 3, 5, 7, 8, 10, 12];
    if (d > 31)
        return false;
    if (d === 31 && !has_31.includes(m))
        return false;
    if (isLeapYear) {
        if (m === 2 && d > 29)
            return false;
    }
    else {
        if (m === 2 && d > 28)
            return false;
    }
    let date = new Date();
    if (y > date.getFullYear())
        return false;
    if (y === date.getFullYear() && m > date.getMonth() + 1)
        return false;
    if (y === date.getFullYear() && m === date.getMonth() + 1 && d > date.getDate())
        return false;
    if (date.getFullYear() - y > 300)
        return false;
    return true;
}
function cardid(code) {
    let result = true;
    let msg = '';
    var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
    };
    if (!validatenull(code)) {
        if (code.length === 18) {
            if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
                msg = '证件号码格式错误';
            }
            else if (!city[Number(code.substr(0, 2))]) {
                msg = '地址编码错误';
            }
            else if (!checkYMD(code.substr(6, 8))) {
                msg = '证件号码校验位错误';
            }
            else {
                // 18位身份证需要验证最后一位校验位
                let codes = code.split('');
                // ∑(ai×Wi)(mod 11)
                // 加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                // 校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x'];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++) {
                    ai = Number(codes[i]);
                    wi = factor[i];
                    sum += ai * wi;
                }
                if (parity[sum % 11] != codes[17]) {
                    msg = '证件号码校验位错误';
                }
                else {
                    result = false;
                }
            }
        }
        else {
            msg = '证件号码长度不为18位';
        }
    }
    else {
        msg = '证件号码不能为空';
    }
    return { result, msg };
}
function isURL(s) {
    return /^http[s]?:\/\/.*/.test(s);
}
const ValidateRule = {
    name: nameRule,
    email: emailRule,
    phone: phoneRule,
    positiveInteger: positiveInteger,
    integer: integer,
    positiveIntegerAndDigit,
    integerAndDigit,
    validateChar,
    validateChinese,
    validateIdNumber: cardid,
    isURL,
    isNum
};

function runQueue(queue = [], cb) {
    const step = (index, data) => {
        let result = data;
        // index === queue.length
        if (!queue.length) {
            cb && cb();
            return;
        }
        // let fn = queue[index]
        let fn = queue.shift();
        if (fn) {
            result = fn(result, (data) => {
                step(index + 1, data);
            });
            if (result instanceof Promise) {
                result.then(r => {
                    result = r;
                    step(index + 1, r);
                }).catch(() => {
                    step(index + 1, null);
                });
            }
        }
        else {
            step(index + 1, data);
        }
    };
    step(0, undefined);
}
function convertQueueFn(fn) {
    return function (params, cb) {
        let f1 = fn(params);
        if (!(f1 instanceof Promise)) {
            cb && cb(f1);
        }
        return f1;
    };
}
class Queue {
    constructor() {
        this.handleList = [];
        this.start = false;
    }
    use(fn) {
        this.handleList.push(convertQueueFn(fn));
        return this.handleList.length - 1;
    }
    forEach(fn) {
        this.handleList.forEach(f => {
            if (f) {
                fn(f);
            }
        });
    }
    run(cb) {
        if (this.start)
            return;
        this.start = true;
        runQueue(this.handleList, () => {
            this.start = false;
            this.clear();
            cb && cb();
        });
    }
    clear() {
        this.start = false;
        this.handleList.length = 0;
    }
    getIsRunning() {
        return this.start;
    }
}

const defaultOpt = {
    max: 5
};
function batchProcess(opt = defaultOpt) {
    // const taskList: Array<TaskHandler> = []
    // const cacheList: Array<TaskHandler> = []
    // let isRunning = false
    return function (cb) { };
}

function html2text(html) {
    let divElement = document.createElement('div');
    divElement.innerHTML = html;
    return divElement.innerText;
}

function createStyle(option = {}) {
    const { themeColor, themeTextColor, themeBtnColor, themeBtnTextColor, coverImage, background = {}, buttonOption = {} } = option;
    let styleElement = document.createElement('style');
    const bodyStyles = [
        ['--theme-color', themeColor],
        ['--theme-text-color', themeTextColor],
        ['--btn-theme-color', themeBtnColor],
        ['--btn-theme-text-color', themeBtnTextColor]
    ];
    const coverStyles = [['background-image', coverImage ? `url("${convertUrl(coverImage)}")` : 'none']];
    const bgStyles = [['background-image', background.image ? `url("${convertUrl(background.image)}")` : 'none']];
    const startButtonStyles = [
        ['background-image', buttonOption.bgImage ? `url("${convertUrl(buttonOption.bgImage)}")` : 'none'],
        ['background-size', 'cover']
    ];
    if (buttonOption.bgImage) {
        startButtonStyles.push(['border', 'none']);
    }
    switch (background.position) {
        case 'center':
            bgStyles.push(['background-size', 'auto']);
            bgStyles.push(['background-position', 'center']);
            bgStyles.push(['background-repeat', 'no-repeat']);
            break;
        case 'repeat':
            bgStyles.push(['background-size', 'auto']);
            bgStyles.push(['background-position', 'left']);
            bgStyles.push(['background-repeat', 'repeat']);
            break;
        case 'stretch':
            bgStyles.push(['background-size', 'cover']);
            bgStyles.push(['background-position', 'left']);
            bgStyles.push(['background-repeat', 'no-repeat']);
            break;
    }
    styleElement.innerHTML = `
            ${createStyleBlock('body', bodyStyles)}
            ${createStyleBlock('.cover-box', coverStyles)}
            ${createStyleBlock('.background-box', bgStyles)}
            ${createStyleBlock('.start-button', startButtonStyles)}
          `;
    let headEl = document.documentElement.getElementsByTagName('head')[0];
    headEl.append(styleElement);
}
function createStyleBlock(name, styles = []) {
    let text = `${name} { \n`;
    for (const [styleName, value] of styles) {
        if (hasValue(value)) {
            text += `${styleName}: ${value};`;
        }
    }
    text += '}';
    return text;
}

const jsapiShareList = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'];
const weixin = {
    init: function (success) {
        loadScript('https://res2.wx.qq.com/open/js/jweixin-1.6.0.js').then(() => {
            const url = location.href.split('#')[0];
            getJsSDKSignature(url).then(res => {
                if (!res || !res.data)
                    return;
                let data = res.data;
                wx.config({
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: [
                        // 必填，需要使用的JS接口列表
                        'getLocation',
                        'showMenuItems',
                        'uploadImage',
                        'downloadImage',
                        'hideMenuItems',
                        'hideAllNonBaseMenuItem',
                        ...jsapiShareList
                    ]
                });
                wx.ready(() => {
                    success();
                });
            });
        });
    },
    getLocation() {
        return new Promise((resolve, reject) => {
            wx.ready(() => {
                wx.getLocation({
                    success: res => {
                        resolve({
                            lng: res.longitude,
                            lat: res.latitude
                        });
                    },
                    error: (err) => {
                        reject(err);
                    },
                    fail(err) {
                        reject({
                            message: '接口调用失败',
                            err
                        });
                    },
                    cancel(info) {
                        reject({
                            message: '用户取消',
                            err: info,
                            userRefuse: true
                        });
                    }
                });
            });
        });
    }
};

let isLoad = false;
let resolveFns = [];
const alipay = {
    init: function (success) {
        loadScript('https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.inc.min.js').then(() => {
            success();
            isLoad = true;
            // alert('alipay load')
            resolveFns.forEach(h => h());
        });
    },
    getLocation() {
        return new Promise((resolve, reject) => {
            const handler = () => {
                // alert('开始')
                try {
                    // @ts-ignore
                    ap.getLocation((res) => {
                        if (res.error) {
                            switch (res.error) {
                                case 12:
                                case 13:
                                    reject({
                                        message: '定位失败',
                                        err: res
                                    });
                                    break;
                                case 14:
                                    reject({
                                        message: '定位超时',
                                        err: res
                                    });
                                    break;
                                case 15:
                                    reject({
                                        message: '网络错误',
                                        err: res
                                    });
                                    break;
                                case 16:
                                case 20001:
                                case 2001:
                                    reject({
                                        message: '用户未授权',
                                        err: res
                                    });
                                    break;
                                default:
                            }
                        }
                        else {
                            resolve({
                                lng: res.longitude,
                                lat: res.latitude
                            });
                        }
                    });
                }
                catch (e) {
                    alert('出错了');
                    alert(JSON.stringify(e));
                }
            };
            if (!isLoad) {
                resolveFns.push(() => {
                    handler();
                });
            }
            else {
                handler();
            }
        });
    }
};

const H5Platforms = {
    weixin,
    alipay
};
function H5PlatformInit(success) {
    let platformSdk = getPlatformSdk();
    if (platformSdk) {
        platformSdk.init(success);
    }
    else {
        success();
    }
}
function getPlatformSdk() {
    let platform = getH5Platform();
    if (platform.weixin) {
        return weixin;
    }
    else if (platform.alipay) {
        return alipay;
    }
    else {
        return null;
    }
}

const logoSrc = '/assets/img/logo.png';
const linkLogoSrc = '/assets/img/link-logo.png';

function getSurveyById(id, versionId) {
    return reRequest.get(`/wenjuan/wjsurvey/info/${id}`, {
        params: {
            versionId
        }
    });
}
function getJsSDKSignature(url) {
    return reRequest({
        method: 'get',
        url: '/award/jsapi?url=' + encodeURIComponent(url).replace('-', '%2D')
    });
}
function getChannelById(id) {
    if (!id)
        return Promise.resolve({ data: {} });
    return reRequest.get(`/award/wjchannel/open/${id}`);
}
function getAwardBySurveyId(surveyId, answerChannelId) {
    return reRequest.get(`/award/wjaward/open/${surveyId}`, {
        params: {
            share: 1,
            answerChannelId
        }
    });
}
function getAwardV2BySurveyId(surveyId, answerChannelId) {
    return convertRequest.get('/award/wjaward/openV2', {
        params: { surveyId, answerChannelId }
    });
}
function getAwardInfoByAnswerId(answerId) {
    return convertRequest.get('/award/wjaward/getAwardInfo', { params: { answerId } });
}
function getAwardCountBySurveyId(surveyId) {
    return convertRequest.post(`award/wjawardsend/selectAwardInfosByInnerForSurveyId?surveyId=${surveyId}`);
}
// 计算第三方问卷的答题时间
function answeringThirdSurvey(params = {}) {
    return convertRequest.get(`wjsample/thirdAnswer/answeringThirdSurvey`, { params });
}
function startAnswering(data, params = {}) {
    return reRequest.post('/answering/answer/startAnswering', data, { params });
}
function startTestAnswering(data, params) {
    return reRequest.post('/answering/answer/startAnsweringTest', data, { params });
}
function getGeocode(point) {
    let url = `https://restapi.amap.com/v3/geocode/regeo?output=JSON&location=${point}&key=${GD_KEY}&radius=1000&extensions=all`;
    return jsonp(url, null, {});
}
function transFormPoint(lon, lat) {
    let url = `https://restapi.amap.com/v3/assistant/coordinate/convert?locations=${lon},${lat}&coordsys=gps&output=JSON&key=${GD_KEY}`;
    return jsonp(url, null, {});
}
function getPositionList(str) {
    let url = `https://restapi.amap.com/v3/place/text?keywords=${str}&key=${GD_KEY}&types=&city=&children=1&offset=20&page=1&extensions=all`;
    return jsonp(url, null, {});
}
function refreshAnswerAddress(data) {
    return convertRequest.post('/answer/answer/refreshAddress', data);
}
function checkPassword(data) {
    return convertRequest({
        url: '/wenjuan/wjsurveyPassword/checkPassword',
        method: 'POST',
        data
    });
}
function bindingPassword(data) {
    return reRequest({
        url: '/wenjuan/wjsurveyPassword/bindingPassword',
        method: 'POST',
        data
    });
}
function checkAnswer(params) {
    return convertRequest.get('/answering/answer/checkFirstTimeAnswering', {
        params
    });
}
/**
 * 获取下一页的数据或结束答题
 * @param answerId 答卷ID
 * @param {Array} answerContent 提交的答案,
 * @param  currentPageNum 第几页
 * @param overtime 分页是否超时处理
 * @param overallOvertime 答题总时长是否超时
 * @param onlySave 仅保存
 * @return {Promise}
 * @private
 */
function submitAnswer(answerId, answerContent, currentPageNum, overtime, overallOvertime, onlySave) {
    let data = {
        method: 'post',
        url: '/answering/answer/submitAnswer',
        data: {
            id: answerId,
            answerContent,
            overtime,
            overallOvertime,
            onlySave
        },
        timeout: 1000 * 10
    };
    if (hasValue(currentPageNum) && !isNaN(currentPageNum)) {
        data.data.currentPageNum = currentPageNum;
    }
    return reRequest(data);
}
function editAnswer(data) {
    return convertRequest.post('/answer/answer/editAnswerOpen', data);
}
// 编辑调查员后再调用
function addorUpdateWjInvestigator(data) {
    return convertRequest.post('/quota/wjInvestigator/addorUpdateWjInvestigator', data);
}
function editAnswerByAgent(data) {
    return convertRequest.post('/answer/answer/editAnswerByAgent', data);
}
function getAnswerIdByPhone(params) {
    return convertRequest.get('/quota/wjInvestigator/getAnswerIdByPhone', { params });
}
function updateById(params) {
    return convertRequest.post(`/quota/wjInvestigator/updateById?id=${params.id}&investigatorPhone=${params.investigatorPhone}`);
}
/**
 * 短信验证
 */
function sendSmsCode(data) {
    return convertRequest.post('/answer/answerPhone/sendVerificationCode', data);
}
function validateCode(data) {
    return convertRequest.post('/answer/answerPhone/checkVerificationCode', data);
}
function getImgCode(phoneNumber, t) {
    return `${window.origin}/api/customer/fetchShortMessagePreCode?phoneNumber=${phoneNumber}&t=${t}`;
}
function upload(data) {
    return reRequest({
        url: '/fill/api/v1/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    }).then(res => {
        res.data.url = encodeURIComponent(res.data.url);
        return res;
    });
}
function convertDownloadUrl(url) {
    if (url.startsWith("http"))
        return url;
    if (url.includes('/fill/api/v1/download?fileName='))
        return url;
    return window.origin + '/fill/api/v1/download?fileName=' + url;
}
function getCascaderRegion(parentId) {
    return convertRequest({
        url: '/fill/wjsurveyquestion/region',
        params: {
            pid: parentId
        }
    });
}
function getAnswerHistory(params) {
    return convertRequest.get('/answer/answer/getAnswerHistoryPage', { params });
}
function getAnswerRes(answerId) {
    return convertRequest.get('/answer/answer/getAnswerRes', { params: { answerId } });
}
function getViewAnswer(answerId, currentPageNum = 0, data = {}) {
    // let instance = axios.create({})
    const restData = __rest(data
    // if (token && tenantId) {
    //   instance.interceptors.request.use(config => {
    //     config.headers!['TENANT-ID'] = tenantId
    //     config.headers!['Authorization'] = 'Bearer ' + token
    //     return config
    //   })
    // }
    , ["token", "tenantId"]);
    // if (token && tenantId) {
    //   instance.interceptors.request.use(config => {
    //     config.headers!['TENANT-ID'] = tenantId
    //     config.headers!['Authorization'] = 'Bearer ' + token
    //     return config
    //   })
    // }
    return convertRequest.post('/answering/answer/viewAnswer', Object.assign({ id: answerId, currentPageNum }, restData));
}
function getAnswerScore(answerId, ids) {
    return convertRequest.post('/answering/answer/getScore', {
        answerId,
        questionIds: ids
    });
}
function addErrorLog(data) {
    return axios.post('/answer/answer/addErrLog', data);
}
function convertUrl(url) {
    return convertDownloadUrl(url);
}
function getCanLuck() {
    return convertRequest.get('/wjluck/global_config/query');
}
function getHistoryQuestionAnswer(data) {
    return convertRequest.get('/answer/answer/es/getHistoryQuestionAnswer', { params: data });
}
function getMoreSurveyList(params) {
    return convertRequest.get('/wenjuan/recommend/displaySurvey', { params });
}
function getMoreSurveyStatus() {
    return convertRequest.get('/wenjuan/recommend/getOpenStatus').then(res => {
        return res.data.moreSurvey.toString();
    });
}
function getShareAnswer(shareAnswerId) {
    return convertRequest.get('/answer/answer/getAwardSendStatusLogBySurveyId', { params: { shareAnswerId } });
}
function bingAnswerAndGetUser(code, accountUserId, surveyId, answerId) {
    return convertRequest.get('/award/updateAnswerByCode', {
        params: {
            wxCode: code,
            accountUserId,
            surveyId,
            answerId
        }
    });
}
function showReportAfterAnswer(surveyId) {
    return convertRequest.get(`/wenjuan/surveyDimension/getDimension/${surveyId}`).then(res => {
        return res.data;
    });
}
function getAnswerDimensionScore(answerId) {
    return convertRequest.get('/answer/answer/getAnswerDimensionScore', { params: { answerId } });
}
function bindExtraAward(answerId) {
    return convertRequest.post(`/award/wjaward/bindExtraAward?answerId=${answerId}`);
}
function checkUrl(key) {
    return convertRequest.get(`/award/checkMpKey?checkMpKey=${key}`);
}
function getUserById(id) {
    return convertRequest.get(`/api/customer/getUserInfosByIdsIn?ids=${id}`).then((res) => {
        return res[0];
    });
}
function getFileStream(file, downloadName) {
    return window.origin + `/fill/api/v1/downloadWithName?fileName=${file}&downLoadName=${downloadName}`;
}
function updateUserByWxCode(code) {
    return convertRequest.get(`/api/customer/updateHeadUrlByOpenId?code=${code}`);
}
function getOfficialAccountQrcode(answerId) {
    return convertRequest.get('/answering/answer/checkAnswerWxFan', { params: { id: answerId } });
}
function getMiniProgramScheme(path, query) {
    return convertRequest.get('/wenjuan/app/getAppScheme', { params: { path, query } });
}
function invalidMine(data) {
    return convertRequest.post('/answering/answer/invalidMine', data);
}
function getSurveyPoint(surveyId) {
    return convertRequest.post('/award/awardcommunity/pointMall/surveyPoints', [surveyId]).then(res => {
        if (res.data) {
            return res.data[0] || null;
        }
        else {
            return null;
        }
    });
}
function getAnswerPoint(answerId) {
    return convertRequest.post('/award/awardcommunity/pointMall/surveyAnswerPoints', [answerId]).then(res => {
        if (res.data) {
            return res.data[0] || null;
        }
        else {
            return null;
        }
    });
}
function receiveAward(data) {
    /**
     * 领取奖励
     */
    return reRequest.post('award/wjaward/answerBindInfo', data);
}
function answerGetAward(answerId) {
    /**
     * 领取红包 或者 抽取奖励
     */
    return reRequest.get('/award/wjaward/answerGetAward', { params: { answerId } });
}
function getAnswerChatGPT(answerId) {
    return convertRequest.get('/answer/answer/openai/chatgpt', { params: { answerId } });
    // return new Promise((resolve, reject) => {
    //   setTimeout(()=>{
    //     resolve(null)
    //   },3000)
    // })
}
function getUserStoryByAnswerId(answerId, change = false) {
    // return new Promise((resolve, reject) => {
    //   setTimeout(()=>{
    //     resolve(null)
    //   },200)
    // })
    return convertRequest.get('/answer/answer/lanternfestival', {
        params: {
            answerId: answerId,
            change
        }
    });
}
function addLogStory(data) {
    return convertRequest.post('/answer/answer/addLanternfestival', data);
}
// 获取企业是否开启企业定制(权限开放)
function getSpecialSettingStatus(companyId) {
    return convertRequest.get('/api/company/infoReplace/' + companyId);
}
function getPageConfigByKeys(data) {
    return convertRequest.post('/admin/sysConfig/getSysConfig', data);
}
function getSurveyInformedConsent(surveyId) {
    return convertRequest.get('/wenjuanLogic/informedConsent/querySurveyInformedConsent', {
        params: { surveyId }
    });
}
function getUserInformedConsentSign(params) {
    return convertRequest.get('/answer/informedConsentSign/queryUserInformedConsentSign', { params });
}

function getSurvey(params) {
    if (params.pure) {
        return getSurveyById(params.surveyId, params.versionId).then(survey => {
            return {
                survey: survey.data ? survey.data : survey,
                lottery: {},
                channel: {}
            };
        });
    }
    return Promise.all([
        getSurveyById(params.surveyId, params.versionId),
        params.answerChannelId ? getChannelById(params.answerChannelId) : Promise.resolve({ data: {} }),
        getAwardV2BySurveyId(params.surveyId, params.answerChannelId),
        getSurveyInformedConsent(params.surveyId)
    ]).then((res) => {
        const [survey, channel, award, informedConsent] = res;
        if (survey.code !== 0 || !channel.data) {
            return Promise.reject(Object.assign(Object.assign({ survey: survey.data ? survey.data : survey, channel: channel === null || channel === void 0 ? void 0 : channel.data }, award.data), { lottery: award.data }));
        }
        return Object.assign(Object.assign({ survey: survey.data, channel: channel.data }, award.data), { lottery: award.data, informedConsent: informedConsent.data });
    });
}
// 获取答题换壳状态
function getStatusConfig(companyId, configKeys) {
    if (!companyId || companyId === 'null' || companyId === 'undefined') {
        return Promise.reject({});
    }
    return Promise.all([
        getSpecialSettingStatus(companyId),
        getPageConfigByKeys({ companyId, configKeys })
    ]).then((res) => {
        if (res[0].replacementStatus) {
            return res[1];
        }
        return undefined;
    });
}

// // @ts-ignore
function getFinger() {
    return FingerprintJS.load().then((fp) => {
        return fp.get().then(result => {
            return result.visitorId;
        });
    });
}

function normalMax(max) {
    let val;
    if (!max) {
        val = Infinity;
    }
    else if (typeof max === 'string') {
        val = parseFloat(max);
    }
    else {
        val = max;
    }
    if (val === -1) {
        val = Infinity;
    }
    return val;
}
function normalMin(min) {
    let val;
    if (!min) {
        val = -Infinity;
    }
    else if (typeof min === 'string') {
        val = parseFloat(min);
    }
    else {
        val = min;
    }
    if (val === -1) {
        val = -Infinity;
    }
    return val;
}
function checkValidateValue(value, option) {
    const { validate, min, max, required, message = {}, allowOtherValue = false } = option;
    if (required && !value) {
        if (message.required) {
            return message.required;
        }
        else {
            return '是必填项';
        }
    }
    else if (!value) {
        return;
    }
    if (option.regexpRules) {
        const item = option.regexpRules.find(item => {
            const rule = item.rule.trim();
            if (!rule)
                return false;
            return !new RegExp(rule).test(value);
        });
        if (item) {
            return item.message;
        }
    }
    let minLen = normalMin(min);
    let maxLen = normalMax(max);
    if (validate === ValidateType.NULL || validate === ValidateType.TEXT || validate === ValidateType.PASSWORD || !validate) {
        if (value.length < minLen) {
            return `不能小于${minLen}字符`;
        }
        if (value.length > maxLen) {
            return `不能大于${maxLen}字符`;
        }
    }
    else if (validate === ValidateType.CHAR) {
        if (!ValidateRule.validateChar(value)) {
            return `请输入英文字符`;
        }
        if (value.length < minLen) {
            return `不能小于${minLen}字符`;
        }
        if (value.length > maxLen) {
            return `不能大于${maxLen}字符`;
        }
    }
    else if (validate === ValidateType.CHINESE) {
        if (!ValidateRule.validateChinese(value)) {
            return `请输入中文字符`;
        }
        if (value.length < minLen) {
            return `不能小于${minLen}字符`;
        }
        if (value.length > maxLen) {
            return `不能大于${maxLen}字符`;
        }
    }
    else if (validate === ValidateType.PHONE) {
        if (!ValidateRule.phone(value)) {
            return `手机号码格式不正确`;
        }
    }
    else if (validate === ValidateType.EMAIL) {
        if (!ValidateRule.email(value)) {
            return `邮箱格式不正确`;
        }
    }
    else if (validate === ValidateType.ID_NUMBER) {
        if (allowOtherValue) {
            if (!/^\d/.test(value)) {
                return null;
            }
        }
        let err = ValidateRule.validateIdNumber(value);
        if (err.result) {
            return err.msg;
        }
    }
    else if (validate === ValidateType.WEBSITE) {
        if (!ValidateRule.isURL(value)) {
            return `网址格式不正确`;
        }
    }
    else if (validate === ValidateType.NUM) {
        if (value === '-' || !ValidateRule.integerAndDigit(value, 100)) {
            return `请输入数字`;
        }
        let digitLen = (value.split('.')[1] || '').length;
        if (option.digit !== -1) {
            if (option.digit) {
                if (option.digit < digitLen) {
                    return `仅支持保留${option.digit}位小数`;
                }
            }
            else if (digitLen) {
                return '不支持小数';
            }
        }
        let v = parseFloat(value);
        if (v > maxLen) {
            return `不能大于${max}`;
        }
        if (v < minLen) {
            return `不能小于${min}`;
        }
    }
}
function initDefaultsTip(option) {
    let { validate, min, max } = option;
    max = normalMax(max);
    min = normalMin(min);
    if (validate === ValidateType.PHONE) {
        return '请输入手机号';
    }
    else if (validate === ValidateType.EMAIL) {
        return '请输入邮箱';
    }
    else if (validate === ValidateType.ID_NUMBER) {
        return '请输入身份证号';
    }
    else if (validate === ValidateType.WEBSITE) {
        return '请输入网址';
    }
    else if (validate === ValidateType.PASSWORD) {
        return '请输入密码';
    }
    else if (validate === ValidateType.NUM) {
        if (min !== -Infinity && max !== Infinity) {
            return `请输入${option.min}~${option.max}的数值`;
        }
        else if (min !== -Infinity) {
            return `最小值需≥${option.min}`;
        }
        else if (max !== Infinity) {
            return `最大值需≤${option.max}`;
        }
        return '请输入数字';
    }
    else {
        let suffixText = '字';
        if (validate === ValidateType.CHAR) {
            suffixText = '字符';
        }
        else if (validate === ValidateType.CHINESE) {
            suffixText = '中文';
        }
        if (min !== -Infinity && max !== Infinity) {
            if (option.min === option.max) {
                return `请输入${option.max}个${suffixText}`;
            }
            else {
                return `请输入${option.min}~${option.max}个${suffixText}`;
            }
        }
        else if (min !== -Infinity) {
            return `最少输入${option.min}个${suffixText}`;
        }
        else if (max !== Infinity) {
            return `最多输入${option.max}个${suffixText}`;
        }
        return '';
    }
}
function initContent(content) {
    if (content.allowFileTypes) {
        content.allowFileTypes = content.allowFileTypes.reduce((res, type) => {
            if (type === 'img') {
                res.push(...imageFiles);
            }
            else {
                res.push(type);
            }
            return res;
        }, []);
    }
    return Object.assign({}, content, {
        fileList: []
    });
}
function checkContent(content) {
    const result = {
        success: true,
        message: ''
    };
    if (content.allowPhotoNum && content.allowPhotoNum > 0) {
        let min = content.allowMinPhotoNum;
        if (content.fileList.length < min) {
            result.success = false;
            result.message = `至少上传${min}个附件`;
            return result;
        }
    }
    return result;
}
function convertInputType(data) {
    let type = 'text';
    let validate = (data && data.validate) || data || '';
    if (validate === ValidateType.PASSWORD)
        type = 'password';
    if (validate === ValidateType.PHONE)
        type = 'number';
    if (typeof data === 'object' && data) {
        data.inputType = type;
        return data;
    }
    else {
        return type;
    }
}
function rand(items, ids, key) {
    const results = items.slice();
    const list = [];
    const idIndexList = [];
    ids.forEach(id => {
        const index = results.findIndex(item => item[key] === id);
        if (index > -1) {
            list.push(results[index]);
            idIndexList.push(index);
        }
    });
    const _list = shuffle(list);
    for (const idx of idIndexList) {
        results[idx] = _list.shift();
    }
    return results;
}
function randList(items, ids) {
    let finalIds = ids.filter(id => {
        return items.find(r => r.id === id);
    });
    if (finalIds.length) {
        return rand(items, finalIds, 'id');
    }
    else {
        return shuffle(items);
    }
}
function rowRandList(rows, ids) {
    let finalIds = ids.filter(id => {
        return rows.find(r => r.row_id === id);
    });
    if (finalIds.length) {
        return rand(rows, finalIds, 'row_id');
    }
    else {
        return shuffle(rows);
    }
}
function getTextFillErrorTip(value = '', opt) {
    const { maxLength, minLength, validate } = opt;
    if (maxLength <= 0 && minLength <= 0)
        return '';
    const currentLen = value.length;
    if (currentLen === 0)
        return '';
    if (validate === ValidateType.NUM) {
        let val = Number(value);
        if (isNaN(Number(val))) {
            return `请输入数字`;
        }
        if (maxLength >= 0 && val > maxLength) {
            return `最大值不能超过${maxLength}`;
        }
        if (minLength >= 0 && val < minLength) {
            return `最小值不能小于${minLength}`;
        }
    }
    else {
        if (maxLength >= 0 && currentLen > maxLength) {
            return `您的输入已超过最大输入字数${maxLength}，当前字数为${currentLen}`;
        }
        if (minLength >= 0 && currentLen < minLength) {
            return `您的输入小于最小输入字数${minLength}，当前字数为${currentLen}`;
        }
    }
    return '';
}
function valueByCalc(target, rule, getCache, Vue) {
    const expression = rule.expression.map((item) => {
        if (item === 'X')
            return '*';
        if (item === '&')
            return '';
        return item;
    }).filter(Boolean);
    const exprToValue = (expr) => {
        const operate = ['+', '-', '*', '/', '(', ')'];
        const cache = getCache();
        const res = expr.map((item) => {
            if (operate.includes(item))
                return item;
            const [questionId, optionId, colId] = item.split('.');
            let content = cache.find((item) => item.questonId === questionId);
            if (!content) {
                if (rule.calcMethod !== 4 && rule.getCurrentItems) {
                    const items = rule.getCurrentItems(item);
                    if (!items)
                        return '';
                    content = {
                        items
                    };
                }
                else {
                    return '';
                }
            }
            if (rule.calcMethod === 4) {
                // 选中项个数
                return content.items.length;
            }
            const c = content.items.find((i) => i.optionId === optionId || i.rowId === optionId && i.colId === colId || (!i.optionId && !i.rowId && !i.colId));
            if (!c)
                return '';
            return `${c.value}`;
        });
        let val = null;
        try {
            const v = res.join('');
            if (operate.find(o => v.includes(o)) && res.length > 1) {
                val = eval(res.join(' '));
                // + - * / 计算
                if (rule.calcMethod === 2) {
                    val = val.toFixed(rule.scale || 0);
                }
            }
            else {
                val = res.join('');
            }
        }
        catch (e) {
            // console.log(e)
        }
        return val || '';
    };
    let instance = new Vue({
        data() {
            return {
                value: ''
            };
        }
    });
    let isUserChange = false;
    Object.defineProperty(target, 'value', {
        get() {
            if (!isUserChange) {
                instance.value = exprToValue(expression);
            }
            return instance.value;
        },
        set(v) {
            if (!rule.autoFillEditable) {
                return;
            }
            isUserChange = true;
            instance.value = v;
        },
        enumerable: true,
        configurable: true
    });
}
function getAnswerItemByExpr(content, expr) {
    const [qid, rid, cid] = expr.split('.');
    const c = content.find(c => {
        return c.questonId === qid;
    });
    if (!c)
        return null;
    if (!rid)
        return c.items[0];
    return c.items.find((i) => {
        if (cid) {
            return i.colId === cid && i.rowId === rid;
        }
        else {
            return i.optionId === rid;
        }
    });
}
function getExprValueByAnswer(expr, content) {
    const getDigitLength = (val) => {
        const [, digit] = String(val).split('.');
        return digit ? digit.length : 0;
    };
    const operate = ['+', '-', '*', '/', '(', ')'];
    let maxDigitLen = 0;
    const finalExpr = expr.map(e => {
        if (e === 'X')
            return '*';
        return e;
    }).map(e => {
        if (operate.includes(e))
            return e;
        if (typeof e === 'number') {
            maxDigitLen = Math.max(getDigitLength(e), maxDigitLen);
            return e;
        }
        const item = getAnswerItemByExpr(content, e);
        if (!item)
            return 0;
        if (isNaN(item.value))
            return 0;
        maxDigitLen = Math.max(getDigitLength(item.value), maxDigitLen);
        return Number(item.value);
    }).map(e => {
        if (typeof e !== 'number')
            return e;
        if (maxDigitLen === 0)
            return e;
        const val = Number('1' + '0'.repeat(maxDigitLen));
        return e * val;
    }).join(" ");
    const fn = Function(`
    "use strict";
    return (${finalExpr}) / (${Number('1' + '0'.repeat(maxDigitLen))})
  `);
    try {
        return fn();
    }
    catch (e) {
        return 0;
    }
}
function defineFillValue(target) {
    let value = '';
    let isUserChange = false;
    Object.defineProperty(target, 'value', {
        get() {
            return value;
        },
        set(v) {
            // @ts-ignore
            if (target.isCalc) {
                if (isUserChange) {
                    return;
                }
            }
            else {
                isUserChange = true;
            }
            value = v;
        },
        enumerable: true,
        configurable: true
    });
}
function getInputPrefixIcon(validate) {
    switch (validate) {
        case ValidateType.EMAIL:
            return 'icon-p-info-email';
        case ValidateType.NUM:
            return 'icon-p-info-number';
        case ValidateType.CHINESE:
            return 'icon-p-info-chinese';
        case ValidateType.WEBSITE:
            return 'icon-p-info-website';
        case ValidateType.CHAR:
            return 'icon-p-info-word';
        case ValidateType.ID_NUMBER:
            return 'icon-p-info-idcard';
        case ValidateType.PHONE:
            return 'icon-p-info-phone';
        case ValidateType.PASSWORD:
            return 'icon-p-info-password';
    }
    return '';
}

let q_id = 0;
function buildMessageToObj(question, msg, enableQuestionIndex) {
    return {
        title: `${enableQuestionIndex ? `第${question.num}题 ` : ''}${question.content.text}`,
        message: msg
    };
}
class Question {
    constructor(id, content, note, question_type, is_required, type, issue) {
        this.required = true;
        this.type = 1;
        this.duration = 0;
        this.q_id = q_id++;
        this.isNoopAnswer = false;
        this.hasValue = false;
        this.hook = {
            created: [],
            mounted: [],
            updated: [],
            submitError: [],
            submitSuccess: [],
            confirm: []
        };
        this.questionErrorList = [];
        this.answerWatchers = [];
        this.vote = null;
        this.showVote = false;
        this.id = id;
        this.content = initContent(content);
        this.note = note;
        this.questionType = question_type;
        this.required = is_required;
        this.type = type;
        this.issue = issue;
        this.groupQuestionKey = '';
        this.groupQuestionId = '';
        this.hasValue = false;
        this.answerWatchers = [];
        this.uploadFileMaxSize = 30;
    }
    setGroupInfo(id, key) {
        this.groupQuestionKey = key;
        this.groupQuestionId = id;
    }
    setValue(value) {
        this.duration = value.duration;
        this.issue.setValue(value.items || []);
        this.content.fileList = (value.activePhotoFiles || []).map((url) => {
            return {
                name: url,
                url
            };
        });
    }
    getIssueValue(type) {
        return this.issue.getValue(type);
    }
    clearHook() {
        this.hook.created = [];
        this.hook.updated = [];
        this.hook.mounted = [];
        this.hook.submitError = [];
        this.hook.submitSuccess = [];
    }
    setHook(key, handler) {
        let handlers = this.hook[key];
        if (!handlers) {
            throw new Error(`${key} 错误 支持 created、mounted、updated、submitError、submitSuccess`);
        }
        if (!handlers.includes(handler)) {
            handlers.push(handler);
        }
    }
    runHooks(key, type) {
        let handlers = this.hook[key];
        handlers.forEach(h => h(type));
    }
    getAnswerContent(type) {
        let items;
        if (this.isNoopAnswer) {
            items = [
                {
                    rowId: '',
                    colId: '',
                    optionId: '',
                    value: ''
                }
            ];
        }
        else {
            items = this.getIssueValue(type);
        }
        return filterParams({
            groupQuestionId: this.groupQuestionId,
            groupQuestionKey: this.groupQuestionKey,
            activePhotoFiles: this.content.fileList.map((res) => res.url),
            questonId: this.id,
            questionType: this.questionType,
            duration: this.duration,
            items
        });
    }
    checkAnswer(value, opt = {}) {
        let result = {
            success: true,
            message: ''
        };
        if (this.required && !(value.items instanceof Promise) && !value.items.length) {
            result.success = false;
            if (checkQuotaIsFull(this)) {
                result.message = buildMessageToObj(this, '配额已满，无法继续作答，请联系发布者', opt.enableQuestionIndex);
            }
            else {
                // result.message = `第${this.num}题 为必答题`
                result.message = buildMessageToObj(this, '为必答题', opt.enableQuestionIndex);
            }
            return result;
        }
        let res = checkContent(this.content);
        if (!res.success) {
            if (res.message) {
                res.message = buildMessageToObj(this, res.message, opt.enableQuestionIndex);
            }
            return res;
        }
        const requiredType = this.setting.requiredType;
        // (requiredType === RequiredType.All) 普通题肯定为 true requiredType 目前只有矩阵题才有可能 为RequiredType.Any
        const required = this.required && requiredType === RequiredType.All;
        let issueCheckResult = this.issue.checkValue(required, Object.assign({ required: this.required }, opt, this.setting || {}));
        if (issueCheckResult) {
            if (issueCheckResult.message) {
                issueCheckResult.message = buildMessageToObj(this, issueCheckResult.message, opt.enableQuestionIndex);
            }
            return issueCheckResult;
        }
        return result;
    }
    convertPrevData() {
        if (this.issue.convertPrevData) {
            this.issue.convertPrevData();
        }
    }
    getCorrectAnswerList() {
        if (!this.setting.enableAnswerScore)
            return [];
        const issue = this.issue;
        return issue.getCorrectAnswerList(this.answerScore);
    }
    setVote(data) {
        if (this.issue.transformVote) {
            this.issue.transformVote(data);
        }
        this.vote = data;
    }
    pushAnswerWatcher(watcher) {
        this.answerWatchers.push(watcher);
    }
    triggerAnswerWatcher(AnswerContent) {
        this.answerWatchers.forEach(watcher => watcher(AnswerContent));
    }
}

var questionType;
(function (questionType) {
    questionType[questionType["SINGLE_CHOICE"] = 1] = "SINGLE_CHOICE";
    questionType[questionType["MULTIPLE_CHOICE"] = 2] = "MULTIPLE_CHOICE";
    questionType[questionType["LINKAGE"] = 3] = "LINKAGE";
    questionType[questionType["BLANKS"] = 4] = "BLANKS";
    questionType[questionType["MATRIX_SINGLE_CHOICE"] = 5] = "MATRIX_SINGLE_CHOICE";
    questionType[questionType["MATRIX_MULTIPLE_CHOICE"] = 6] = "MATRIX_MULTIPLE_CHOICE";
    questionType[questionType["SINGLE_TEXT_FILL"] = 7] = "SINGLE_TEXT_FILL";
    questionType[questionType["MULTIPLE_TEXT_FILL"] = 8] = "MULTIPLE_TEXT_FILL";
    questionType[questionType["SINGLE_SELECT"] = 12] = "SINGLE_SELECT";
    questionType[questionType["MULTIPLE_SELECT"] = 13] = "MULTIPLE_SELECT";
    questionType[questionType["ONLY_TEXT"] = 20] = "ONLY_TEXT";
    questionType[questionType["SORT"] = 11] = "SORT";
    questionType[questionType["SCALE"] = 21] = "SCALE";
    questionType[questionType["MATRIX_SCALE"] = 9] = "MATRIX_SCALE";
    questionType[questionType["NPS_SCALE"] = 10] = "NPS_SCALE";
    questionType[questionType["CUSTOM_SINGLE_SCALE"] = 15] = "CUSTOM_SINGLE_SCALE";
    questionType[questionType["CUSTOM_MULTIPLE_SCALE"] = 16] = "CUSTOM_MULTIPLE_SCALE";
    questionType[questionType["DATE"] = 17] = "DATE";
    questionType[questionType["UPLOAD_FILE"] = 18] = "UPLOAD_FILE";
    questionType[questionType["HANDWRITING"] = 14] = "HANDWRITING";
    questionType[questionType["CITY_ADDRESS"] = 19] = "CITY_ADDRESS";
    questionType[questionType["MAP"] = 100] = "MAP";
    questionType[questionType["DOWNLOADABLE"] = 112] = "DOWNLOADABLE";
    questionType[questionType["PHONE_VALIDATE"] = 109] = "PHONE_VALIDATE";
    questionType[questionType["CASCADE_REGION"] = 114] = "CASCADE_REGION";
    questionType[questionType["TOTAL"] = 119] = "TOTAL";
    questionType[questionType["MATRIX_AUTO"] = 102] = "MATRIX_AUTO";
    questionType[questionType["MATRIX_SCROLL"] = 103] = "MATRIX_SCROLL";
    questionType[questionType["MATRIX_GRAVITY"] = 104] = "MATRIX_GRAVITY";
    questionType[questionType["MULTIPLE_BLANKS"] = 105] = "MULTIPLE_BLANKS";
    questionType[questionType["MATRIX_COMPOSE"] = 110] = "MATRIX_COMPOSE";
    questionType[questionType["MATRIX_FILL"] = 107] = "MATRIX_FILL";
    questionType[questionType["IMAGE_CHOICE"] = 113] = "IMAGE_CHOICE";
    questionType[questionType["IMAGE_MULTIPLE_CHOICE"] = 117] = "IMAGE_MULTIPLE_CHOICE";
    questionType[questionType["MATRIX_SELECT_CHOICE"] = 106] = "MATRIX_SELECT_CHOICE";
    questionType[questionType["QUESTION_GROUP"] = 115] = "QUESTION_GROUP";
    questionType[questionType["CLASSIFICATION"] = 111] = "CLASSIFICATION";
    questionType[questionType["PAGE_BREAK"] = 108] = "PAGE_BREAK";
    questionType[questionType["NAME"] = 22] = "NAME";
    questionType[questionType["CELLPHONE"] = 23] = "CELLPHONE";
    questionType[questionType["EMAIL"] = 24] = "EMAIL";
    questionType[questionType["REAL_NAME"] = 26] = "REAL_NAME";
    questionType[questionType["GENDER"] = 27] = "GENDER";
    questionType[questionType["PERMANENT_ADDRESS"] = 28] = "PERMANENT_ADDRESS";
    questionType[questionType["DATE_OF_BIRTH"] = 29] = "DATE_OF_BIRTH";
    questionType[questionType["ID_NUMBER"] = 31] = "ID_NUMBER";
    questionType[questionType["AGE_RANGE"] = 32] = "AGE_RANGE";
    questionType[questionType["DOMICILE"] = 33] = "DOMICILE";
    questionType[questionType["EDUCATIONAL_ATTAINMENT"] = 34] = "EDUCATIONAL_ATTAINMENT";
    questionType[questionType["SPECIALITY"] = 35] = "SPECIALITY";
    questionType[questionType["SCHOOL"] = 36] = "SCHOOL";
    questionType[questionType["INDUSTRY"] = 37] = "INDUSTRY";
    questionType[questionType["JOB"] = 38] = "JOB";
    questionType[questionType["MARITAL_STATUS"] = 39] = "MARITAL_STATUS";
    questionType[questionType["MONTHLY_INCOME_RANGE"] = 40] = "MONTHLY_INCOME_RANGE";
    questionType[questionType["POINT_POSITION"] = 42] = "POINT_POSITION";
    questionType[questionType["REPEAT"] = 120] = "REPEAT";
    questionType[questionType["SINGLE_CONTROL"] = -10000] = "SINGLE_CONTROL";
    questionType[questionType["MAX_DIFF"] = 124] = "MAX_DIFF";
})(questionType || (questionType = {}));
const ValidateType = {
    NUM: 'num',
    NULL: null,
    PHONE: 'phone',
    EMAIL: 'email',
    CHAR: 'char',
    CHINESE: 'chinese',
    ID_NUMBER: 'idNumber',
    WEBSITE: 'website',
    TEXT: 'text',
    PASSWORD: 'password' // 密码样式
};
const CascaderStyleType = {
    One: 1,
    Many: 2
};
const RequiredType = {
    All: 0,
    Any: 1
};
var questionSubType;
(function (questionSubType) {
    questionSubType[questionSubType["JUDGE"] = 1] = "JUDGE";
    questionSubType[questionSubType["SHORT_ANSWER"] = 2] = "SHORT_ANSWER";
    questionSubType[questionSubType["NOTICE"] = 3] = "NOTICE";
    questionSubType[questionSubType["STUDENT_ID"] = 4] = "STUDENT_ID";
    questionSubType[questionSubType["JOB_NO"] = 5] = "JOB_NO";
    questionSubType[questionSubType["CLASS"] = 6] = "CLASS";
    questionSubType[questionSubType["DEPARTMENT"] = 7] = "DEPARTMENT";
    questionSubType[questionSubType["VOTE_TEXT"] = 8] = "VOTE_TEXT";
    questionSubType[questionSubType["VOTE_IMAGE"] = 9] = "VOTE_IMAGE";
    questionSubType[questionSubType["WECHAT"] = 10] = "WECHAT";
    questionSubType[questionSubType["GRADE"] = 11] = "GRADE";
    questionSubType[questionSubType["COMPANY"] = 12] = "COMPANY";
    questionSubType[questionSubType["NUMBER_FILL"] = 13] = "NUMBER_FILL";
    questionSubType[questionSubType["SINGLE_FILL"] = 14] = "SINGLE_FILL";
    questionSubType[questionSubType["COUNTRY_REGION"] = 15] = "COUNTRY_REGION";
    questionSubType[questionSubType["PROVINCE_CITY"] = 16] = "PROVINCE_CITY";
    questionSubType[questionSubType["PROVINCE_CITY_AREA"] = 17] = "PROVINCE_CITY_AREA";
    questionSubType[questionSubType["BASE_INFO"] = 18] = "BASE_INFO";
    questionSubType[questionSubType["WORKING_YEARS"] = 19] = "WORKING_YEARS";
    questionSubType[questionSubType["SCORE_SINGLE_CHOICE"] = 20] = "SCORE_SINGLE_CHOICE";
    questionSubType[questionSubType["BASE_INFO_SATISFACTION"] = 21] = "BASE_INFO_SATISFACTION";
})(questionSubType || (questionSubType = {}));

const typeMapping = new Map();
function mapGen(types = [], text, typeMapping) {
    types.forEach(t => {
        typeMapping.set(t, text);
    });
}
const singleTypes = [
    questionType.SINGLE_CHOICE,
    questionType.GENDER,
    questionType.MARITAL_STATUS,
    questionType.INDUSTRY,
    questionType.MONTHLY_INCOME_RANGE,
    questionType.EDUCATIONAL_ATTAINMENT,
    questionType.AGE_RANGE,
    questionType.JOB
];
const dateTypes = [questionType.DATE, questionType.DATE_OF_BIRTH];
const textTypes = [
    questionType.SINGLE_TEXT_FILL,
    questionType.MULTIPLE_TEXT_FILL,
    questionType.NAME,
    questionType.EMAIL,
    questionType.CELLPHONE,
    questionType.ID_NUMBER,
    questionType.POINT_POSITION
];
const cascaderTypes = [
    questionType.LINKAGE,
    questionType.PERMANENT_ADDRESS,
    questionType.SCHOOL,
    questionType.DOMICILE,
    questionType.SPECIALITY
];
mapGen(singleTypes, '单选题', typeMapping);
mapGen(dateTypes, '日期题', typeMapping);
mapGen(textTypes, '填空题', typeMapping);
mapGen(cascaderTypes, '级联题', typeMapping);
typeMapping.set(questionType.MULTIPLE_CHOICE, '多选题');
typeMapping.set(questionType.SINGLE_SELECT, '下拉题');
typeMapping.set(questionType.MULTIPLE_SELECT, '下拉题');
typeMapping.set(questionType.MATRIX_SINGLE_CHOICE, '矩阵选择');
typeMapping.set(questionType.MATRIX_MULTIPLE_CHOICE, '矩阵选择');
typeMapping.set(questionType.SORT, '排序题');
typeMapping.set(questionType.SCALE, '量表题');
typeMapping.set(questionType.MATRIX_SCALE, '矩阵量表题');
typeMapping.set(questionType.BLANKS, '横向填空');
typeMapping.set(questionType.ONLY_TEXT, '描述');
typeMapping.set(questionType.NPS_SCALE, 'NPS量表题');
typeMapping.set(questionType.HANDWRITING, '手写签名');
typeMapping.set(questionType.CUSTOM_SINGLE_SCALE, '自定义量表');
typeMapping.set(questionType.CUSTOM_MULTIPLE_SCALE, '自定义量表');
typeMapping.set(questionType.UPLOAD_FILE, '文件上传');
typeMapping.set(questionType.MAP, '地理位置');
typeMapping.set(questionType.MATRIX_SCROLL, '矩阵滑动条');
typeMapping.set(questionType.MATRIX_GRAVITY, '比重题');
typeMapping.set(questionType.MATRIX_AUTO, '自增表格题');
typeMapping.set(questionType.MULTIPLE_BLANKS, '多项填空');
typeMapping.set(questionType.MATRIX_COMPOSE, '表格组合');
typeMapping.set(questionType.IMAGE_CHOICE, '图片选择');
typeMapping.set(questionType.IMAGE_MULTIPLE_CHOICE, '图片选择');
typeMapping.set(questionType.CLASSIFICATION, '分类题');
typeMapping.set(questionType.DOWNLOADABLE, '可下载附件');
typeMapping.set(questionType.PHONE_VALIDATE, '手机验证');
typeMapping.set(questionType.CASCADE_REGION, '行政区划');
typeMapping.set(questionType.QUESTION_GROUP, '问题组');
typeMapping.set(questionType.MATRIX_SELECT_CHOICE, '矩阵下拉');
typeMapping.set(questionType.MATRIX_FILL, '矩阵填空');
typeMapping.set(questionType.PAGE_BREAK, '分页');
typeMapping.set(questionType.CITY_ADDRESS, '城市/地址');
typeMapping.set(questionType.TOTAL, '加总题');
typeMapping.set(questionType.MAX_DIFF, 'MaxDiff');

function transformRichText2Text(html = '', opt = {}) {
    const { img = '[图片]', video = '[视频]', audio = '[音频]' } = opt;
    let div = document.createElement('div');
    div.innerHTML = html;
    const data = [
        ['img', img],
        ['video', video],
        ['audio', audio],
        ['iframe', '[音/视频]']
    ];
    for (const [tagName, text] of data) {
        let els = Array.from(div.getElementsByTagName(tagName)).slice();
        for (const el of els) {
            let replaceNode = document.createTextNode(text);
            try {
                el.parentElement.replaceChild(replaceNode, el);
                // div.replaceChild(replaceNode, el)
            }
            catch (e) {
                console.log(el);
                console.log(replaceNode);
                console.log(tagName, text);
                console.log(e);
            }
        }
    }
    return div.innerText;
}

class Choice {
    constructor(data) {
        this.exclusiveList = []; // 排他项数组
        this.mutex = [];
        this.can_append_item = true;
        this.raw_items = [];
        this.items = []; // 选项数组
        this.is_rand = data.is_rand;
        this.randList = (data.randList || []).filter(Boolean);
        this.min_choice = data.min_choice || -1;
        this.max_choice = data.max_choice || -1;
        this.choice_num_per_row = Math.min(data.choice_num_per_row || 1, 3);
        this.append_items = data.append_items || [];
        this.init(data);
        this.item_groups = this.transformGroups(data.item_groups || []);
        this.mutex = data.enableMutex ? (data.mutex || []) : [];
        this.defaultTip = this.initDefaultTip();
        this.enableFilter = data.enableFilter || false;
        this.placeholder = data.placeholder || '';
        this.voteAnswer = [];
        this.autoFillEnable = data.autoFillEnable || false;
        this.autoFillEditable = data.autoFillEditable || false;
        this.autoFill = data.autoFill || [];
        this.readonly = false;
        this.ignoreItems = [];
    }
    initDefaultTip() {
        const min = this.min_choice;
        const max = this.max_choice;
        if (min > 0 && max > 0) {
            if (min === max) {
                return `请选择${min}项`;
            }
            return `请选择${min}~${max}项`;
        }
        else if (min > 0) {
            return `至少选择${min}项`;
        }
        else if (max > 0) {
            return `最多选择${max}项`;
        }
    }
    init(data) {
        const items = data.items;
        if (data.other_item && Object.keys(data.other_item).length) {
            items.push(data.other_item);
        }
        this.items = this.normalizeItems(items || []);
        this.raw_items = this.items.slice();
    }
    normalizeItems(items) {
        // let others: any[] = []
        let normal = [];
        let exclusiveList = [];
        items.forEach(item => {
            // 其他项 填空的 value（普通选项没有作用）
            item.value = item.defaultValue || "";
            item.content = initContent(item.content);
            // 用于互斥选项
            item.disabled = false;
            normal.push(item);
            // if (item.is_other_item) {
            //   others.push(item)
            // } else {
            //
            // }
            if (item.is_exclusive) {
                exclusiveList.push(item.id);
            }
            item.inputType = convertInputType(item.validate);
            if (!item.setting) {
                item.setting = {
                    enableRelation: false
                };
            }
            // item.errorText = normalizeTips({
            //   validate: item.validate,
            //   min_length: item.minLength, max_length: item.maxLength
            // })
        });
        let results = normal;
        this.exclusiveList = exclusiveList;
        // 选项乱序 其他项保证在最后
        if (this.is_rand) {
            results = randList(results, this.randList);
        }
        return results;
    }
    transformGroups(groups = []) {
        const results = [];
        const ids = [];
        for (let i = 0, len = groups.length; i < len; i++) {
            const group = groups[i];
            const options = [];
            group.item_ids.forEach((id) => {
                let item = this.items.find(it => it.id === id);
                if (item) {
                    options.push(item);
                    ids.push(id);
                }
            });
            if (options.length) {
                let finalOptions = options.slice();
                let item_ids = group.item_ids.slice();
                if (this.is_rand) {
                    if (this.randList.length) {
                        let finalIds = this.randList.filter(id => {
                            return finalOptions.find(r => r.id === id);
                        });
                        if (finalIds.length) {
                            finalOptions = randList(finalOptions, finalIds);
                            item_ids = finalOptions.map(item => item.id);
                        }
                    }
                    else {
                        finalOptions = randList(finalOptions, []);
                        item_ids = finalOptions.map(item => item.id);
                    }
                }
                results.push({
                    title: group.title,
                    options: finalOptions,
                    item_ids: item_ids
                });
            }
        }
        const otherOptions = [];
        this.items.forEach((item) => {
            if (!ids.includes(item.id)) {
                otherOptions.push(item);
            }
        });
        if (otherOptions.length) {
            results.push({
                title: '',
                options: otherOptions,
                item_ids: otherOptions.map(item => item.id)
            });
        }
        return results;
    }
    getAnswerContent(id) {
        let item = this.getItemById(id);
        if (!item)
            return null;
        let value = item.content.text;
        if (item.is_other_item) {
            value = value + '|' + item.value;
        }
        return {
            colId: '',
            optionId: id,
            rowId: '',
            value,
            photos: item.content.fileList.map((s) => s.url)
        };
    }
    getItemById(id) {
        return this.items.find(i => i.id === id);
    }
    checkItemValue(id) {
        let item = this.getItemById(id);
        if (!item)
            return;
        if (this.ignoreItems.find(i => i.id === id))
            return;
        let res = checkContent(item.content);
        if (!res.success) {
            return res;
        }
        if (!item.is_other_item)
            return;
        let err;
        if (item.required || item.value) {
            const allowErrorList = item.allowErrorList || [];
            if (allowErrorList.includes(item.value.toString())) {
                return;
            }
            err = checkValidateValue(item.value, {
                validate: item.validate,
                required: item.required,
                min: item.minLength,
                max: item.maxLength,
                digit: item.digit === -1 ? Infinity : item.digit,
                message: {
                    required: '请填写填空内容'
                }
            });
        }
        if (!err)
            return;
        return {
            message: err,
            success: false,
            item
        };
    }
    getCorrectAnswerList(answerScore) {
        // let ids = (answerScore.optionScoreItems || []).map((i: any) => i.optionId)
        // return this.items.filter(item => {
        //   return ids.includes(item.id)
        // })
        const items = answerScore.optionScoreItems || [];
        const results = [];
        items.forEach((item) => {
            let find = this.items.find(i => i.id === item.optionId);
            if (find) {
                const result = {
                    id: find.id,
                    score: null
                };
                if (answerScore.matchType !== 0) {
                    result.score = item.score;
                }
                results.push(result);
            }
        });
        return results;
    }
    transformVote(vote) {
        this.items.forEach(item => {
            vote.oidCountMap[item.id] = vote.oidCountMap[item.id] || 0;
        });
    }
    convertVoteAnswer() {
        const values = this.getValue();
        this.voteAnswer = values.map(item => item.optionId);
    }
    hasVoteFilter() {
        return !!this.voteAnswer.length;
    }
    getVoteAnswerValueText() {
        return this.voteAnswer.map(id => {
            var _a, _b;
            return (_b = (_a = this.items.find(item => item.id === id)) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.text;
        }).join(',');
    }
}
class SingleChoice extends Choice {
    constructor(data) {
        super(data);
        this.select = '';
    }
    getValue() {
        let answerContent = this.getAnswerContent(this.select);
        if (!answerContent)
            return [];
        return [answerContent];
    }
    setValue(data) {
        if (data.length) {
            let item = data[0];
            this.select = item.optionId;
            if (this.select && this.autoFillEnable && !this.autoFillEditable) {
                this.readonly = true;
                this.items.forEach(item => {
                    item.disabled = true;
                });
            }
            let i = this.getItemById(item.optionId);
            if (i) {
                if (i.is_other_item) {
                    i.value = item.value.split('|')[1];
                }
                i.content.fileList = (item.photos || []).map((url) => {
                    return {
                        name: url,
                        url
                    };
                });
            }
        }
    }
    checkValue() {
        return this.checkItemValue(this.select);
    }
    isCorrectAnswer(answerScore) {
        let ids = (answerScore.optionScoreItems || []).map((i) => i.optionId);
        let matchType = answerScore.matchType || 0;
        function diff(arr1 = [], arr2 = []) {
            if (matchType === 1) {
                return arr1.some(arr => {
                    return arr2.includes(arr);
                });
            }
            else {
                return arr1.every(arr => {
                    return arr2.includes(arr);
                });
            }
        }
        return diff(ids, [this.select]);
    }
    getScore(answerScore) {
        if (answerScore.matchType === 0) {
            if (this.isCorrectAnswer(answerScore)) {
                return answerScore.totalScore;
            }
            else {
                return 0;
            }
        }
        else {
            const items = answerScore.optionScoreItems || [];
            const find = items.find((i) => i.optionId === this.select);
            if (find) {
                return find.score;
            }
            else {
                return 0;
            }
        }
    }
    getTotalScore(answerScore) {
        if (answerScore.matchType === 0) {
            return answerScore.totalScore;
        }
        else {
            return Math.max.apply(Math, answerScore.optionScoreItems.map((item) => item.score));
        }
    }
    getValueConfirm() {
        const item = this.getItemById(this.select);
        if (!item)
            return;
        if (!item.is_other_item)
            return;
        if (item.outOfRange !== 1)
            return;
        const allowErrorList = item.allowErrorList || [];
        if (allowErrorList.includes(item.value.toString())) {
            return;
        }
        const err = checkValidateValue(item.value, {
            validate: item.validate,
            required: item.required,
            min: item.minLength,
            max: item.maxLength,
            digit: item.digit === -1 ? Infinity : item.digit,
        });
        if (!err)
            return null;
        if (!err.includes('不能')) {
            return null;
        }
        return {
            message: item.outOfRangeMessage
        };
    }
}
class MutChoice extends Choice {
    constructor(data) {
        super(data);
        this.select = [];
        this.conflictValidator = data.conflictValidator || false;
    }
    getValue() {
        return this.items.reduce((res, item) => {
            if (this.select.includes(item.id)) {
                const answerContent = this.getAnswerContent(item.id);
                if (answerContent) {
                    res.push(answerContent);
                }
            }
            return res;
        }, []);
        // return this.select.reduce<AnswerContentItem[]>((res, id: string) => {
        //   let answerContent = this.getAnswerContent(id)
        //   if (answerContent) {
        //     res.push(answerContent)
        //   }
        //   return res
        // }, [])
    }
    setValue(data) {
        this.select = data.map(({ optionId, value, photos }) => {
            let item = this.getItemById(optionId);
            if (item) {
                if (item.is_other_item) {
                    item.value = value.split('|')[1];
                }
                item.content.fileList = (photos || []).map((url) => {
                    return {
                        name: url,
                        url
                    };
                });
                return item.id;
            }
        }).filter(Boolean);
        if (this.select.length && this.autoFillEnable && !this.autoFillEditable) {
            this.readonly = true;
            this.items.forEach(item => {
                item.disabled = true;
            });
        }
    }
    getIsMutex() {
        const ids = this.select;
        return this.mutex.some(item => {
            return ((item.mutex_group1.length === ids.length && ids.every(id => item.mutex_group1.includes(id))) ||
                (item.mutex_group2.length === ids.length && ids.every(id => item.mutex_group2.includes(id))));
            // 任一
            // if (item.mutex_type === 2) {
            //   return ids.some(id => item.mutex_group1.includes(id)) || ids.some(id => item.mutex_group2.includes(id))
            // } else {
            //   return (
            //     (item.mutex_group1.length === ids.length && ids.every(id => item.mutex_group1.includes(id))) ||
            //     (item.mutex_group2.length === ids.length && ids.every(id => item.mutex_group2.includes(id)))
            //   )
            // }
        });
    }
    checkValue() {
        let min = normalMin(this.min_choice);
        let max = normalMax(this.max_choice);
        let len = this.select.length;
        if (len > max) {
            return {
                success: false,
                message: `最多选择${max}项`
            };
        }
        // 如果没有选择 最少则不校验 （必答题在外层已经校验了）
        if (len) {
            if (len < min) {
                if (!this.conflictValidator) {
                    return {
                        success: false,
                        message: `最少选择${min}项`
                    };
                }
                const items = this.select.map(id => {
                    return this.items.find(item => item.id === id);
                });
                const is_exclusive = items.every(item => item.is_exclusive);
                if (!is_exclusive && !this.getIsMutex()) {
                    return {
                        success: false,
                        message: `最少选择${min}项`
                    };
                }
            }
        }
        for (let i = 0; i < len; i++) {
            let id = this.select[i];
            let err = this.checkItemValue(id);
            if (err && !err.success) {
                return err;
            }
        }
    }
    isCorrectAnswer(answerScore) {
        let ids = (answerScore.optionScoreItems || []).map((i) => i.optionId);
        let matchType = answerScore.matchType || 0;
        function diff(arr1 = [], arr2 = []) {
            if (matchType === 1) {
                return arr1.some(arr => {
                    return arr2.includes(arr);
                });
            }
            else {
                return (arr1.every(arr => {
                    return arr2.includes(arr);
                }) && arr1.length === arr2.length);
            }
        }
        return diff(ids, this.select);
    }
    getScore(answerScore) {
        if (answerScore.matchType === 0) {
            if (this.isCorrectAnswer(answerScore)) {
                return answerScore.totalScore;
            }
            else {
                return 0;
            }
        }
        else {
            return this.select.reduce((res, id) => {
                const items = answerScore.optionScoreItems || [];
                const find = items.find((i) => i.optionId === id);
                if (find) {
                    res += find.score;
                }
                return res;
            }, 0);
        }
    }
    getTotalScore(answerScore) {
        if (answerScore.matchType === 0) {
            return answerScore.totalScore;
        }
        else {
            return answerScore.optionScoreItems.reduce((res, item) => {
                return res + item.score;
            }, 0);
        }
    }
    getValueConfirm() {
        let len = this.select.length;
        for (let i = 0; i < len; i++) {
            let id = this.select[i];
            const item = this.getItemById(id);
            if (!item)
                continue;
            if (!item.is_other_item)
                continue;
            if (item.outOfRange !== 1)
                continue;
            const allowErrorList = item.allowErrorList || [];
            if (allowErrorList.includes(item.value.toString())) {
                continue;
            }
            const err = checkValidateValue(item.value, {
                validate: item.validate,
                required: item.required,
                min: item.minLength,
                max: item.maxLength,
                digit: item.digit === -1 ? Infinity : item.digit,
            });
            if (!err)
                continue;
            if (!err.includes('不能')) {
                continue;
            }
            return {
                message: item.outOfRangeMessage
            };
        }
    }
}

function normalGroups(groups = [], level, currentLevel = 1) {
    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        if (currentLevel < level) {
            if (group.nextLevelOptions && group.nextLevelOptions.length) {
                normalGroups(group.nextLevelOptions, level, currentLevel + 1);
            }
        }
        else {
            group.nextLevelOptions = null;
        }
    }
    return groups;
}
class Cascader {
    constructor(data) {
        this.value = [];
        this.inputValue = '';
        this.levels = data.levels || [];
        this.groups = normalGroups(data.groups || [], data.requiredNum || data.levelsNum || 0);
        this.placeholder = this.convertPlaceholder(data.levels);
        this.levelsNum = data.levelsNum || 0;
        this.requiredNum = data.requiredNum || null;
        this.items = this.initFillContext(data.fillContext || []);
        this.styleType = data.styleType || CascaderStyleType.One;
        this.voteAnswer = [];
    }
    initFillContext(items = []) {
        return items.map(item => {
            return Object.assign({}, item, { value: null });
        });
    }
    convertPlaceholder(levels) {
        return Array.isArray(levels) ? levels.join('/') : levels;
    }
    getValue() {
        const results = [];
        let ids = this.value.slice();
        let groups = this.groups;
        while (ids.length) {
            const id = ids.shift();
            let group = groups.find(item => item.id === id);
            if (group) {
                results.push({
                    optionId: group.id,
                    value: group.content,
                    colId: '',
                    rowId: ''
                });
                groups = group.nextLevelOptions || [];
            }
        }
        if (this.items.length && this.requiredNum > results.length) {
            this.items.forEach(item => {
                if (!item.value)
                    return;
                results.push({
                    rowId: '',
                    colId: '',
                    optionId: item.id,
                    value: item.value
                });
            });
        }
        return results;
    }
    setValue(data) {
        let value = [];
        let inputs = [];
        data.forEach(item => {
            let find = this.items.find(i => i.id === item.optionId);
            if (find) {
                find.value = item.value;
            }
            else {
                inputs.push(item.value);
                value.push(item.optionId);
            }
        });
        this.value = value;
        this.inputValue = inputs.join('/');
    }
    checkValue(required) {
        if (!required)
            return;
        let num = Math.min(this.levelsNum, this.requiredNum);
        let value = this.value.slice();
        let groups = this.groups;
        while (value.length && groups) {
            const id = value.shift();
            let group = groups.find(g => g.id === id);
            if (group) {
                groups = group.nextLevelOptions || [];
            }
        }
        if (this.value.length < num && groups.length) {
            return {
                success: false,
                message: '请填写所有选项'
            };
        }
        let len = this.requiredNum - this.levelsNum;
        if (len > 0) {
            if (!this.items.every(i => i.value)) {
                return {
                    success: false,
                    message: '输入框不能为空'
                };
            }
        }
    }
    getComponentType() {
        switch (this.styleType) {
            case CascaderStyleType.One:
                return 'Cascader';
            case CascaderStyleType.Many:
                return 'CityAddress';
        }
    }
    convertVoteAnswer() {
        const values = this.getValue();
        this.voteAnswer = values.map(item => item.optionId);
    }
    hasVoteFilter() {
        return !!this.voteAnswer.length;
    }
    toOneArray() {
        return this.getItems(this.groups);
    }
    getItems(groups = []) {
        const results = [];
        for (let i = 0; i < groups.length; i++) {
            let g = groups[i];
            if (g.nextLevelOptions && g.nextLevelOptions.length) {
                const items = this.getItems(g.nextLevelOptions);
                items.forEach(item => {
                    results.push({
                        text: `${g.content}/${item.text}`,
                        id: `${g.id}/${item.id}`
                    });
                });
            }
            else {
                results.push({
                    text: g.content,
                    id: g.id
                });
            }
        }
        return results;
    }
    getVoteAnswerValueText() {
        const list = this.toOneArray();
        console.log(this.voteAnswer);
        return list.reduce((res, item) => {
            const lastId = item.id.split('/').pop();
            if (this.voteAnswer.includes(lastId)) {
                res += item.text;
            }
            return res;
        }, '');
    }
}

class MatrixChoice {
    constructor(data) {
        this.items = this.normalCols(data.items, data.is_col_rand, data.colRandList || []);
        this.rows = this.normalizeRows(data.rows, data.initRowValue, data.is_row_rand, data.rowRandList || []);
        this.mutex = data.enableMutex ? (data.mutex || []) : [];
        this.rowDesc = data.rowDesc || null;
        this.widths = data.widths || [];
    }
    normalCols(items, is_rand, list) {
        let results = items.map(col => {
            col.disabled = false;
            return col;
        });
        if (is_rand) {
            results = randList(results, list);
        }
        return results;
    }
    normalizeRows(rows, defaultsValue, is_rand, list) {
        let results = rows.map(item => {
            let val = typeof defaultsValue === 'function' ? defaultsValue() : defaultsValue;
            return Object.assign({}, item, {
                value: val,
                selected: false,
                cols: this.items.map(i => Object.assign({}, i))
            });
        });
        if (is_rand) {
            results = rowRandList(results, list);
        }
        return results;
    }
}
class MatrixSingleChoice extends MatrixChoice {
    constructor(data) {
        super(Object.assign({}, data, { initRowValue: '' }));
    }
    getValue() {
        return this.rows.reduce((res, row) => {
            const colId = row.value;
            if (colId) {
                let col = this.items.find(col => col.id === colId);
                let value = row.content.text + ' ' + col.content.text;
                res.push({
                    optionId: '',
                    rowId: row.row_id,
                    colId,
                    value
                });
            }
            return res;
        }, []);
    }
    setValue(data) {
        data.forEach(({ colId, rowId }) => {
            let row = this.rows.find(row => row.row_id === rowId);
            if (row) {
                row.value = colId;
            }
        });
    }
    checkValue(required) {
        if (required) {
            if (this.getValue().length !== this.rows.length) {
                return {
                    success: false,
                    message: '每个子项都为必选项'
                };
            }
        }
    }
}
class MatrixMultipleChoice extends MatrixChoice {
    constructor(data) {
        super(Object.assign({}, data, { initRowValue: () => [] }));
    }
    getValue() {
        const results = [];
        this.rows.forEach(row => {
            const colIds = row.value;
            let rowText = row.content.text;
            colIds.forEach((colId) => {
                let col = this.items.find(col => col.id === colId);
                if (col) {
                    results.push({
                        optionId: '',
                        rowId: row.row_id,
                        colId,
                        value: rowText + ' ' + col.content.text
                    });
                }
            });
        });
        return results;
    }
    setValue(data) {
        data.forEach(({ colId, rowId }) => {
            let row = this.rows.find(row => row.row_id === rowId);
            if (row) {
                row.value.push(colId);
            }
        });
    }
    checkValue(required) {
        if (!required)
            return;
        let items = this.getValue();
        let set = new Set();
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            set.add(item.rowId);
        }
        if (set.size !== this.rows.length) {
            return {
                success: false,
                message: '每个子项都为必选项'
            };
        }
    }
}
class MatrixSelectChoice extends MatrixChoice {
    constructor(data) {
        super(data);
        this.options = this.normalOptions(data.cells || []);
    }
    getValue() {
        return this.options.reduce((results, option) => {
            let item = option.items.find((i) => i.id === option.value);
            if (item) {
                results.push({
                    colId: option.col_id,
                    rowId: option.row_id,
                    value: item.content.text,
                    optionId: option.value
                });
            }
            return results;
        }, []);
    }
    setValue(data) {
        data.forEach(item => {
            let option = this.options.find(o => o.row_id === item.rowId && o.col_id === item.colId);
            if (option) {
                option.value = item.optionId;
            }
        });
    }
    normalOptions(options = []) {
        return options.map((option) => {
            option.value = '';
            return option;
        });
    }
    getCellByRowAndCol(row, col) {
        return this.options.find(o => o.row_id === row.row_id && o.col_id === col.id);
    }
    checkValue(required) {
        if (!required)
            return;
        if (this.getValue().length !== this.options.length) {
            return {
                success: false,
                message: '每个子项都为必选项'
            };
        }
    }
}
class MatrixFill extends MatrixChoice {
    constructor(data, option) {
        super(data);
        this.autoFillEnable = data.autoFillEnable || false;
        this.autoFillEditable = data.autoFillEditable || false;
        this.autoFill = data.autoFill || [];
        this.complexValidateEnable = data.complexValidateEnable || false;
        this.complexValidate = data.complexValidate || [];
        this.cells = this.normalCells(data.cells || [], option);
        this.setting = data.setting || {
            enableRelation: false
        };
        this.disableCopy = data.disableCopy || false;
    }
    normalCells(cells, option) {
        var _a;
        const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
        return cells.map(c => {
            let rule = rules.find(item => item.rowId === c.row_id && item.colId === c.col_id);
            const res = Object.assign({}, c, { readonly: false, rowId: c.row_id, colId: c.col_id });
            if (this.autoFillEnable && rule && option.autoFill) {
                // option.autoFill(res,
                //   Object.assign(
                //     {},
                //     rule,
                //     {
                //       autoFillEditable: this.autoFillEditable,
                //       getCurrentItems: (item: string) => {
                //         const [qid, rowId,colId] = item.split('.')
                //         const q_id = (this as any).catchData?.id
                //         if(qid !== q_id) return null
                //         return this.cells.filter(cell=>{
                //           return cell.rowId ===rowId && cell.colId === colId
                //         })
                //       }
                //     })
                // )
                res.readonly = !this.autoFillEditable;
            }
            // } else {
            //   Object.defineProperty(res, 'value', {
            //     writable: true,
            //     value: '',
            //     enumerable: true,
            //     configurable: true
            //   })
            // }
            defineFillValue(res);
            return res;
        });
    }
    setValueByRule(rule, value) {
        const cell = this.cells.find(cell => {
            return cell.rowId === rule.rowId && cell.colId === rule.colId;
        });
        if (!cell)
            return;
        cell.isCalc = true;
        cell.value = value;
        cell.isCalc = false;
    }
    getCellByRowAndCol(row, col) {
        return this.cells.find(o => o.row_id === row.row_id && o.col_id === col.id);
    }
    getValue() {
        return this.cells.reduce((res, cell) => {
            var _a;
            const val = cell.value;
            if (val) {
                res.push({
                    rowId: cell.row_id,
                    colId: cell.col_id,
                    optionId: (_a = cell.fillContext[0]) === null || _a === void 0 ? void 0 : _a.id,
                    value: val
                });
            }
            return res;
        }, []);
    }
    setValue(data) {
        var _a;
        const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
        this.cells.forEach(cell => {
            let item = data.find(o => o.colId === cell.col_id && o.rowId === cell.row_id);
            if (item) {
                if (this.autoFillEnable && item.value) {
                    const colId = item.colId;
                    const rowId = item.rowId;
                    const rule = rules.find((rule) => rule.colId === colId && rule.rowId === rowId);
                    if (rule && !this.autoFillEditable) {
                        cell.readonly = true;
                    }
                }
                cell.isCalc = true;
                cell.value = item.value;
                cell.isCalc = false;
            }
        });
    }
    checkValue(required) {
        if (!required)
            return;
        let items = this.getValue();
        const finalCells = this.cells.filter(cell => !cell.readonly);
        if (items.length < finalCells.length) {
            return {
                success: false,
                message: '每个子项都为必填项'
            };
        }
    }
    runComplexValidate(answerContent, currentContent) {
        const item = this.complexValidate.find(item => {
            return item.conditions.some((c) => {
                const [rid, cid] = c.subCode.split('.');
                const currentValue = currentContent.items.find((i) => i.rowId === rid && i.colId === cid);
                if (!currentValue)
                    return false;
                return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentValue.value), c.operator);
            });
        });
        if (!item)
            return { success: true, message: null };
        return { success: false, message: item.alert, rule: item };
    }
}

class Blanks {
    constructor(data, option) {
        this.autoFillEnable = data.autoFillEnable || false;
        this.autoFillEditable = data.autoFillEditable || false;
        this.autoFill = data.autoFill || [];
        this.items = this.convertFillContent(data.fillContext, data.fillText, option);
        this.numCompareRule = data.numCompareRule;
        this.disableCopy = data.disableCopy || false;
        this.complexValidateEnable = data.complexValidateEnable || false;
        this.complexValidate = data.complexValidate || [];
    }
    convertFillContent(fillContext = [], text = '', option) {
        var _a;
        const FillTextRegExp = /([^_]*)+(_*)/g;
        let contents = fillContext.slice();
        let results = [];
        let execArray;
        let t = text;
        const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
        while ((execArray = FillTextRegExp.exec(text)) && contents.length) {
            let val = execArray[0];
            let str = execArray[1];
            let separator = execArray[2];
            t = t.replace(val, '');
            const content = contents.shift();
            let rule = rules.find(item => item.optionId === content.id);
            let res = {
                text: str,
                length: separator.length,
                content: convertInputType(content),
                placeholder: content.placeholder,
                readonly: false,
            };
            if (this.autoFillEnable && rule && option.autoFill) {
                res.readonly = !this.autoFillEditable;
            }
            defineFillValue(res);
            results.push(res);
        }
        if (t) {
            results.push({
                text: t,
                length: 0,
                content: null,
                value: ''
            });
        }
        return results;
    }
    getValue() {
        let items = this.items.filter(item => {
            return item.length && item.content;
        });
        return items.reduce((res, item) => {
            if (item.value) {
                res.push({
                    colId: '',
                    rowId: '',
                    optionId: item.content.id,
                    value: item.value
                });
            }
            return res;
        }, []);
    }
    setValue(data) {
        var _a;
        const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
        this.items.forEach(item => {
            if (item.content) {
                let answerContentItem = data.find(d => d.optionId === item.content.id);
                if (answerContentItem) {
                    let rule = rules.find((rule) => rule.optionId === answerContentItem.optionId);
                    item.readonly = !!(rule && answerContentItem.value && this.autoFillEnable && !this.autoFillEditable);
                    item.isCalc = true;
                    item.value = answerContentItem.value;
                    item.isCalc = false;
                }
            }
        });
    }
    checkValue() {
        for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i];
            let content = item.content;
            if (!item.length || !item.content)
                continue;
            if (item.readonly)
                continue;
            let err = checkValidateValue(item.value, {
                validate: content.validate,
                min: content.minLength,
                max: content.maxLength,
                required: content.required,
                digit: content.digit
            });
            if (err) {
                return {
                    message: `第${i + 1}项 ${err}`,
                    success: false,
                    item
                };
            }
        }
    }
    runComplexValidate(answerContent, currentContent) {
        const item = this.complexValidate.find(item => {
            return item.conditions.some((c) => {
                const currentValue = currentContent.items.find((i) => i.optionId === c.subCode);
                if (!currentValue)
                    return false;
                return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentValue.value), c.operator);
            });
        });
        if (!item)
            return { success: true, message: null };
        return { success: false, message: item.alert, rule: item };
    }
    setValueByRule(rule, value) {
        const cell = this.items.find(cell => {
            return cell.content.id === rule.optionId;
        });
        if (!cell)
            return;
        cell.isCalc = true;
        cell.value = value;
        cell.isCalc = false;
    }
}
class MultipleBlanks {
    constructor(data, option) {
        this.autoFillEnable = data.autoFillEnable || false;
        this.autoFillEditable = data.autoFillEditable || false;
        this.autoFill = data.autoFill || [];
        this.complexValidateEnable = data.complexValidateEnable || false;
        this.complexValidate = data.complexValidate || [];
        this.fillContext = this.initFillContext(data.fillContext || [], data.is_rand, data.randList || [], option);
        this.setting = data.setting || {
            enableRelation: false
        };
        this.disableCopy = data.disableCopy || false;
        this.ignoreItems = [];
    }
    initFillContext(items, isRand, list, option) {
        var _a;
        const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
        let results = items.map(i => {
            i.content = initContent(i.content);
            const res = Object.assign({}, convertInputType(i));
            let rule = rules.find(item => item.optionId === i.id);
            res.prefixIcon = getInputPrefixIcon(res.validate);
            if (this.autoFillEnable && rule) {
                res.readonly = !this.autoFillEditable;
            }
            defineFillValue(res);
            return res;
        });
        if (isRand) {
            results = randList(results, list);
        }
        return results;
    }
    getValue() {
        return this.fillContext
            .map(item => {
            return {
                rowId: '',
                colId: '',
                optionId: item.id,
                value: item.value,
                photos: item.content.fileList.map((s) => s.url)
            };
        })
            .filter(i => i.value);
    }
    setValue(data) {
        var _a;
        const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
        if (!data)
            data = [];
        this.fillContext.forEach(item => {
            let find = data.find(d => d.optionId === item.id);
            if (find) {
                let rule = rules.find((rule) => rule.optionId === find.optionId);
                item.readonly = !!(rule && find.value && this.autoFillEnable && !this.autoFillEditable);
                item.isCalc = true;
                item.value = find.value;
                item.isCalc = false;
                if (find.photos) {
                    item.content.fileList = find.photos.map(i => ({ name: i, url: i }));
                }
            }
        });
    }
    checkValue(required) {
        for (let i = 0; i < this.fillContext.length; i++) {
            let item = this.fillContext[i];
            let content = item;
            if (item.readonly)
                continue;
            if (this.ignoreItems.some(i => i.id === item.id))
                continue;
            const allowErrorList = item.allowErrorList || [];
            if (allowErrorList.includes(item.value.toString())) {
                continue;
            }
            let err = checkValidateValue(item.value, {
                validate: content.validate,
                min: content.minLength,
                max: content.maxLength,
                required: item.required,
                digit: content.digit === -1 ? Infinity : content.digit
            });
            if (err) {
                return {
                    message: `第${i + 1}项 ${err}`,
                    success: false,
                    item
                };
            }
            let res = checkContent(content.content);
            if (!res.success) {
                return res;
            }
        }
    }
    setValueByRule(rule, value) {
        const cell = this.fillContext.find(cell => {
            return cell.id === rule.optionId;
        });
        if (!cell)
            return;
        cell.isCalc = true;
        cell.value = value;
        cell.isCalc = false;
    }
    runComplexValidate(answerContent, currentContent) {
        const item = this.complexValidate.find(item => {
            return item.conditions.some((c) => {
                const currentValue = currentContent.items.find((i) => i.optionId === c.subCode);
                if (!currentValue)
                    return false;
                return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentValue.value), c.operator);
            });
        });
        if (!item)
            return { success: true, message: null };
        return { success: false, message: item.alert, rule: item };
    }
    getValueConfirm(item) {
        // for (let i = 0; i < this.fillContext.length; i++) {
        //   let item = this.fillContext[i]
        let content = item;
        if (item.readonly)
            return;
        if (item.outOfRange !== 1)
            return;
        if (this.ignoreItems.some(i => i.id === item.id))
            return;
        if (item.validate !== ValidateType.NUM)
            return;
        const allowErrorList = item.allowErrorList || [];
        if (allowErrorList.includes(item.value.toString())) {
            return;
        }
        let err = checkValidateValue(item.value, {
            validate: content.validate,
            min: content.minLength,
            max: content.maxLength,
            digit: content.digit === -1 ? Infinity : content.digit
        });
        if (!err)
            return null;
        if (!err.includes('不能')) {
            return null;
        }
        return {
            message: item.outOfRangeMessage
        };
        // }
    }
}

class TextFill {
    constructor(data) {
        this.value = '';
        this.placeholder = '';
        this.min_length = data.min_length || -Infinity;
        this.max_length = data.max_length || Infinity;
        this.value = data.default_text || '';
        this.digit = hasValue(data.digit) ? parseInt(data.digit) : 2;
        this.rows = data.rows || 1;
        this.validate = data.validate || ValidateType.NULL;
        this.messageValidate = !!data.message_validate;
        this.data_unique = data.data_unique;
        this.inputType = TextFill.convertInputType(data);
        this.isValidateCode = false;
        this.setting = data.setting || {
            enableRelation: false
        };
        this.placeholder = data.placeholder || '';
        this.defaultTip = data.outOfRange !== 1 ? initDefaultsTip({
            validate: this.validate,
            max: this.max_length,
            min: this.min_length,
            digit: this.digit,
            regexpRules: data.enableRegexpValidate ? (data.regexpRules || []) : []
        }) : '';
        this.disableCopy = data.disableCopy || false;
        this.allowOtherValue = data.allowOtherValue || false;
        this.autoFillEnable = data.autoFillEnable || false;
        this.autoFillEditable = data.autoFillEditable || false;
        this.outOfRange = data.outOfRange || 0;
        this.outOfRangeMessage = data.outOfRangeMessage || '输入值可能有问题，请再次确认';
        this.autoFill = data.autoFill || [];
        this.complexValidateEnable = data.complexValidateEnable || false;
        this.complexValidate = data.complexValidate || [];
        this.allowErrorList = data.allowErrorList || [];
        this.readonly = false;
        this.regexpRules = data.regexpRules || [];
        this.enableRegexpValidate = data.enableRegexpValidate || false;
    }
    static convertInputType(data) {
        if (data.validate === ValidateType.PASSWORD)
            return 'password';
        if (data.validate === ValidateType.PHONE)
            return 'number';
        return data.rows === 1 ? 'input' : 'textarea';
    }
    getValue() {
        if (!this.value)
            return [];
        return [
            {
                rowId: '',
                colId: '',
                optionId: '',
                value: this.value
            }
        ];
    }
    setValue(data) {
        var _a, _b;
        if (data.length) {
            const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
            const expression = (((_b = rules[0]) === null || _b === void 0 ? void 0 : _b.expression) || []).filter(Boolean);
            if (expression.length && this.autoFillEnable && !this.autoFillEditable) {
                this.readonly = true;
            }
            this.value = data[0].value;
        }
    }
    check(required) {
        let value = this.value;
        let validate = this.validate;
        if (!value) {
            if (required) {
                throw new Error('内容不能为空');
            }
            else {
                return true;
            }
        }
        if (validate === ValidateType.PHONE) {
            if (!ValidateRule.phone(value.trim())) {
                throw new Error('手机号不正确');
            }
        }
        else if (validate === ValidateType.EMAIL) {
            if (ValidateRule.email(value.trim())) {
                throw new Error('邮箱不正确');
            }
        }
    }
    checkValue() {
        if (!this.value)
            return;
        if (this.allowErrorList.includes(this.value.trim()))
            return;
        let errormsg = checkValidateValue(this.value, {
            validate: this.validate,
            max: this.max_length,
            min: this.min_length,
            digit: this.digit,
            allowOtherValue: this.allowOtherValue,
            regexpRules: this.enableRegexpValidate ? this.regexpRules : []
        });
        if (errormsg) {
            return {
                success: false,
                message: errormsg
            };
        }
        if (this.messageValidate) {
            if (!this.isValidateCode) {
                return {
                    success: false,
                    message: '手机号未验证'
                };
            }
        }
    }
    runComplexValidate(answerContent, currentContent) {
        const v = this.complexValidate.find(item => {
            return item.conditions.some((c) => {
                if (!currentContent.items.length)
                    return false;
                return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentContent.items[0].value), c.operator);
            });
        });
        if (!v)
            return { success: true, message: '' };
        return { success: false, message: v.alert, rule: v };
    }
    getValueConfirm() {
        if (this.validate !== ValidateType.NUM)
            return null;
        if (this.outOfRange !== 1)
            return null;
        if (this.allowErrorList.includes(this.value.trim()))
            return null;
        let errormsg = checkValidateValue(this.value, {
            validate: this.validate,
            max: this.max_length,
            min: this.min_length,
            digit: this.digit,
            allowOtherValue: this.allowOtherValue
        });
        if (!errormsg)
            return null;
        if (!errormsg.includes('不能')) {
            return null;
        }
        return {
            message: this.outOfRangeMessage
        };
    }
    setValueByRule(rule, value) {
        this.value = value.toString();
    }
}
class OnlyText {
    checkValue(required) {
    }
    getValue() {
        return [];
    }
    setValue(data) {
    }
}

class Scale {
    constructor(data) {
        this.labels = this.initLabels(data.labels || []);
        this.value = null;
        this.items = data.items || [];
        this.firstLabel = this.labels[0];
        this.lastLabel = this.labels[this.labels.length - 1];
        this.show_unknown = data.showUnknown || false;
        this.unknown_text = data.unknownText || '';
        this.show_option_desc = typeof data.show_option_desc === 'boolean' ? data.show_option_desc : true;
        this.show_option_value = typeof data.show_option_value === 'boolean' ? data.show_option_value : true;
        this.activeColor = data.activeColor || 'rgb(39, 117, 232)';
        this.styleType = data.styleType || 1;
    }
    initLabels(labels = []) {
        return labels.map((l, index) => {
            let id = l.id;
            if (!id) {
                id = index + 1;
            }
            l.id = id;
            return l;
        });
    }
    getValue() {
        var _a;
        const str1 = this.labels[0].text;
        const str2 = this.labels[this.labels.length - 1].text;
        if (!this.value)
            return [];
        const num = (_a = this.labels.find(i => i.id === this.value)) === null || _a === void 0 ? void 0 : _a.num;
        let value = this.value === 'unknown' ? '' : `${num}(${str1}-${str2})`;
        return [
            {
                optionId: this.items[0].id,
                value,
                colId: '',
                rowId: ''
            }
        ];
    }
    setValue(data) {
        if (!data.length)
            return;
        const m = data[0].value.match(/(-?\d+)/);
        let value = m ? m[0] : '';
        // let value = parseInt(num) || ''
        let l = this.labels.find(l => l.num.toString() === value.toString());
        if (!l)
            return;
        this.value = l.id;
    }
    checkValue(required) {
    }
    getRgbColor(opacity) {
        const color = this.activeColor;
        const reg = /\((.*)\)/;
        let result = color.match(reg);
        if (!result)
            return color;
        const [r, g, b] = result[1].split(',');
        return `rgba(${r},${g},${b},${opacity})`;
    }
    getActiveColor(activeValue, idx) {
        console.log(activeValue);
        const labels = this.labels;
        const isSelectStyle = this.styleType === 1;
        let findIndex = labels.findIndex(label => label.id === activeValue);
        if (findIndex < idx)
            return {};
        if (isSelectStyle && findIndex !== idx)
            return {};
        if (isSelectStyle) {
            return {
                backgroundColor: 'rgb(39, 117, 232)'
            };
        }
        const len = isSelectStyle ? 1 : labels.length;
        return {
            backgroundColor: this.getRgbColor((idx + 1) / len)
        };
    }
    getTotalScore(answerScore) {
        const optionScoreItems = answerScore.optionScoreItems;
        return (Math.max.apply(Math, optionScoreItems.map((o) => o.score)));
    }
    getScore(answerScore) {
        var _a;
        const optionScoreItems = answerScore.optionScoreItems;
        const value = ((_a = this.labels.find(item => item.id === this.value)) === null || _a === void 0 ? void 0 : _a.num) || '';
        const item = optionScoreItems.find(item => String(item.value) === String(value));
        return (item === null || item === void 0 ? void 0 : item.score) || '';
    }
}
class NPSScale extends Scale {
}
class CustomScale extends Scale {
}
function normalAuxiliaryColumns(cols, items) {
    const results = [];
    items.forEach(item => {
        const col = cols.find(col => col.rowId === item.id);
        if (col) {
            results.push(col);
        }
        else {
            results.push({
                content: {
                    text: '',
                    richText: ''
                },
                id: '',
                rowId: item.id
            });
        }
    });
    return results;
}
class MatrixScale extends Scale {
    constructor(data) {
        super(data);
        this.items = this.convertItems(data.items || [], data.is_rand, data.randList || []);
        this.rowDesc = data.rowDesc;
        this.enabledAuxiliaryColumn = data.enabledAuxiliaryColumn || false;
        this.auxiliaryColumns = normalAuxiliaryColumns(data.auxiliaryColumns || [], this.items);
    }
    convertItems(items = [], isRand, list) {
        let results = items.map(item => {
            return Object.assign({}, item, { value: null });
        });
        if (isRand) {
            results = randList(results, list);
        }
        return results;
    }
    getValue() {
        const str1 = this.labels[0].text;
        const str2 = this.labels[this.labels.length - 1].text;
        return this.items.reduce((res, item) => {
            var _a;
            if (hasValue(item.value)) {
                const num = (_a = this.labels.find(i => i.id === item.value)) === null || _a === void 0 ? void 0 : _a.num;
                const value = item.value === 'unknown' ? '' : `${num}(${str1}-${str2})`;
                res.push({
                    colId: '',
                    rowId: '',
                    optionId: item.id,
                    value
                });
            }
            return res;
        }, []);
    }
    setValue(data) {
        this.items.forEach(item => {
            let find = data.find(i => i.optionId === item.id);
            if (find) {
                if (find.value === '') {
                    item.value = 'unknown';
                }
                else {
                    const val = find.value || "";
                    const m = val.match(/(-?\d+)/);
                    let num = m ? m[0] : '';
                    // let value = parseInt(num) || ''
                    let l = this.labels.find(l => l.num.toString() === num.toString());
                    item.value = l === null || l === void 0 ? void 0 : l.id;
                }
            }
        });
    }
    checkValue(required) {
        if (required) {
            if (this.getValue().length !== this.items.length) {
                return {
                    success: false,
                    message: '每个子项都为必选项'
                };
            }
        }
    }
    getTotalScore(answerScore) {
        const optionScoreItems = answerScore.optionScoreItems;
        const len = this.items.length;
        return (Math.max.apply(Math, optionScoreItems.map((o) => o.score)) * len);
    }
    getScore(answerScore) {
        const optionScoreItems = answerScore.optionScoreItems;
        return this.items.reduce((score, item) => {
            if (!item.value)
                return score;
            const label = this.labels.find(l => l.id === item.value);
            if (!label)
                return score;
            const opt = optionScoreItems.find((opt) => (opt.value || '').toString() === label.num.toString());
            if (opt) {
                score = score + opt.score;
            }
            return score;
        }, 0);
    }
}
class MatrixCustomScale extends MatrixScale {
}

class UploadFile {
    // public min: number
    constructor(data) {
        this.uploadFiles = [];
        this.allowFileTypes = [];
        this.uploadFiles = [];
        this.checkFileType = data.checkFileType || false;
        this.allowFileTypes = data.allowFileTypes || [];
        this.max = normalMax(data.max);
        // this.min = normalMin(data.min)
    }
    getValue() {
        return this.uploadFiles.map(item => {
            return {
                colId: '',
                rowId: '',
                optionId: '',
                value: item.url
            };
        });
    }
    setValue(data) {
        this.uploadFiles = data.map(d => {
            return {
                name: d.value,
                url: d.value
            };
        });
    }
    checkValue() { }
}

class DateTime {
    constructor(data) {
        this.value = '';
        let issue = (this.data = data.fillContext[0]);
        this.dateType = issue.dateType;
        this.max = issue.maxLength;
        this.range = issue.rangeLength;
        this.min = issue.minLength;
        this.optionId = issue.id;
        this.validateType = issue.validate;
        this.datetimeValue = [];
    }
    getValue() {
        if (this.value) {
            return [
                {
                    optionId: this.optionId,
                    rowId: '',
                    colId: '',
                    value: this.value
                }
            ];
        }
        else {
            return [];
        }
    }
    setValue(data) {
        if (data.length) {
            let d = data[0];
            this.value = d.value;
        }
    }
    checkValue() { }
}

class Gravity {
    constructor(data) {
        let labels = data.labels;
        this.items = this.transformItems(data.items, data.is_rand);
        this.totalValue = data.total_value || 0;
        this.min = labels[0].num;
        this.max = labels[1].num;
    }
    transformItems(items, isRand) {
        let results = items.map(item => {
            return Object.assign(item, { value: 0 });
        });
        if (isRand) {
            results = shuffle(results);
        }
        return results;
    }
    getValue() {
        return this.items.map(item => {
            return {
                colId: '',
                rowId: '',
                optionId: item.id,
                value: item.value
            };
        });
    }
    setValue(data) {
        data.forEach(item => {
            let find = this.items.find(i => i.id === item.optionId);
            if (find) {
                find.value = item.value;
            }
        });
    }
    checkValue(required) {
        const total = this.items.reduce((res, item) => {
            res += Number(item.value);
            return res;
        }, 0);
        if (!required && total === 0) {
            return;
        }
        if (total < this.totalValue) {
            return {
                success: false,
                message: `总和不到${this.totalValue}`
            };
        }
        else if (total > this.totalValue) {
            return {
                success: false,
                message: `总和为${this.totalValue}`
            };
        }
    }
}

class Classification {
    constructor(data) {
        this.rows = this.initRows(data.rows, data.is_rand, data.randList || []);
        this.items = this.initItems(data.items);
        this.max = data.max_choice || -1;
        this.min = data.min_choice || -1;
        this.defaultTip = this.initDefaultTip();
    }
    initDefaultTip() {
        const min = this.min;
        const max = this.max;
        if (min > 0 && max > 0) {
            if (min === max) {
                return `请选择${min}项`;
            }
            return `请选择${min}~${max}项`;
        }
        else if (min > 0) {
            return `至少选择${min}项`;
        }
        else if (max > 0) {
            return `最多选择${max}项`;
        }
    }
    initItems(items) {
        return items.map(item => {
            return Object.assign({}, item, { selects: [] });
        });
    }
    initRows(rows, isRand, list) {
        let res = rows.map(r => Object.assign({}, r, { colId: '', checked: false }));
        if (isRand) {
            res = rowRandList(res, list);
        }
        return res;
    }
    getValue() {
        return this.items.reduce((res, item) => {
            let colId = item.id;
            let colText = item.content.text;
            item.selects.forEach((row) => {
                res.push({
                    colId: colId,
                    rowId: row.row_id,
                    optionId: '',
                    value: `${row.content.text} ${colText}`
                });
            });
            return res;
        }, []);
    }
    setValue(data) {
        const selects = [];
        data.forEach(({ rowId, colId }) => {
            let item = this.items.find(i => i.id === colId);
            let row = this.rows.find(r => r.row_id === rowId);
            if (item && row) {
                row.colId = item.id;
                selects.push(row.row_id);
                item.selects.push(row);
            }
        });
        this.rows = this.rows.filter(r => !selects.includes(r.row_id));
    }
    checkValue(required, opt) {
        let min = normalMin(this.min);
        let max = normalMax(this.max);
        if (min === -Infinity && max === Infinity)
            return;
        for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i];
            let len = item.selects.length;
            if (max !== Infinity) {
                if (len > max) {
                    return {
                        success: false,
                        message: `每个分类最多${max}选项`
                    };
                }
            }
            if (min !== -Infinity) {
                if (len < min) {
                    return {
                        success: false,
                        message: `每个分类至少${min}选项`
                    };
                }
            }
        }
        // let rows = this.rows
        // if (opt.browserInfo?.isPc) {
        //   if (rows.length) {
        //     return {
        //       message: '请对所有选项进行分类',
        //       success: false
        //     }
        //   }
        // } else {
        //   let rs = rows.filter(i => i.colId)
        //   if (rows.length === rs.length || !rs.length) return
        //   return {
        //     message: '请对所有选项进行分类',
        //     success: false
        //   }
        // }
    }
}

class ImageChoice {
    constructor(data) {
        this.items = this.initItems(data.items, data.is_rand, data.randList || []);
        this.voteAnswer = [];
    }
    initItems(items, isRand, list) {
        let res = items.map(item => {
            item.content.image = (item.content.image || []).map((item) => {
                return {
                    url: convertDownloadUrl(item.url)
                };
            });
            return Object.assign({}, item, {});
        });
        if (isRand) {
            res = randList(res, list);
        }
        return res;
    }
    transformVote(vote) {
        this.items.forEach(item => {
            vote.oidCountMap[item.id] = vote.oidCountMap[item.id] || 0;
        });
    }
    hasVoteFilter() {
        return !!this.voteAnswer.length;
    }
    getVoteAnswerValueText() {
        return this.voteAnswer.map(id => {
            var _a, _b;
            return (_b = (_a = this.items.find(item => item.id === id)) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.text;
        }).join(',');
    }
}
class SingleImageChoice extends ImageChoice {
    constructor(data) {
        super(data);
        this.select = '';
    }
    getValue() {
        let item = this.items.find(i => i.id === this.select);
        if (!item)
            return [];
        return [
            {
                optionId: this.select,
                colId: '',
                rowId: '',
                value: item.content.text
            }
        ];
    }
    setValue(data) {
        if (data.length) {
            this.select = data[0].optionId;
        }
    }
    checkValue() { }
    convertVoteAnswer() {
        const values = this.getValue();
        this.voteAnswer = values.map(item => item.optionId);
    }
}
class MultipleImageChoice extends ImageChoice {
    constructor(data) {
        super(data);
        this.select = [];
        this.min_choice = data.min_choice || -1;
        this.max_choice = data.max_choice || -1;
        this.defaultTip = this.initDefaultTip();
    }
    initDefaultTip() {
        const min = this.min_choice;
        const max = this.max_choice;
        if (min > 0 && max > 0) {
            if (min === max) {
                return `请选择${min}项`;
            }
            return `请选择${min}~${max}项`;
        }
        else if (min > 0) {
            return `至少选择${min}项`;
        }
        else if (max > 0) {
            return `最多选择${max}项`;
        }
    }
    getValue() {
        return this.select.reduce((res, id) => {
            let item = this.items.find(i => i.id === id);
            if (item) {
                res.push({
                    optionId: id,
                    colId: '',
                    rowId: '',
                    value: item.content.text
                });
            }
            return res;
        }, []);
    }
    setValue(data) {
        this.select = data.map(i => i.optionId);
    }
    checkValue(required) {
        let min = normalMin(this.min_choice);
        let max = normalMax(this.max_choice);
        let len = this.select.length;
        if (len > max) {
            return {
                success: false,
                message: `最多选择${max}项`
            };
        }
        if (len < min) {
            return {
                success: false,
                message: `最少选择${min}项`
            };
        }
    }
    convertVoteAnswer() {
        const values = this.getValue();
        this.voteAnswer = values.map(item => item.optionId);
    }
}

// import { isPC } from '@dygc/shared'
function convertItems(items) {
    return items.map(item => {
        return Object.assign({
            value: '',
            inputType: convertInputType(item.validate),
            setting: { enableRelation: false }
        }, item);
    });
}
class Sort {
    constructor(data) {
        this.min_choice = normalMin(data.min_choice || -1);
        this.max_choice = normalMax(data.max_choice || -1);
        this.is_rand = data.is_rand || false;
        this.randList = data.randList || [];
        this.items = this.initItems(convertItems(data.items || []), data.is_rand);
        this.value = this.initValue(this.items);
        this.defaultTip = this.initDefaultTip();
        this.ignoreItems = [];
        this.disableChangePosition = data.disableChangePosition || false;
    }
    initValue(items = []) {
        return items.map((item, index) => {
            return Object.assign({}, item, { select: false, originPosition: index });
        });
    }
    initItems(items = [], isRand = false) {
        if (isRand) {
            return randList(items, this.randList);
        }
        else {
            return items;
        }
    }
    getValue() {
        return this.value.reduce((res, item) => {
            let value = item.content.text;
            if (item.is_other_item) {
                value = `${value}|${item.value}`;
            }
            if (item.select) {
                res.push({
                    colId: '',
                    rowId: '',
                    optionId: item.id,
                    value
                });
            }
            return res;
        }, []);
    }
    setValue(data) {
        // if (isPC()) {
        //   this.value = data.map(i => {
        //     let item = this.items.find(item => item.id === i.optionId)
        //     if (item.is_other_item) {
        //       item.value = i.value.split('|')[1]
        //     }
        //     return item
        //   })
        //   this.value.forEach(i => (i.select = true))
        //   this.items = this.items.filter(item => !data.find(i => i.optionId === item.id))
        // } else {
        let value = this.value.slice();
        let v1 = value.filter(i => !data.find(d => d.optionId === i.id));
        let v2 = data
            .map(d => {
            let item = value.find(i => i.id === d.optionId);
            if (item.is_other_item) {
                item.value = d.value.split('|')[1];
            }
            return item;
        })
            .filter(Boolean);
        v2.forEach(item => (item.select = true));
        this.value = v2.concat(v1);
        // }
    }
    initDefaultTip() {
        if (this.max_choice > 0 && this.max_choice !== Infinity) {
            return `仅选出${this.max_choice}项`;
        }
    }
    checkValue(required) {
        for (let i = 0; i < this.value.length; i++) {
            const item = this.value[i];
            if (!item.select)
                continue;
            if (!item || !item.is_other_item)
                continue;
            if (!item.required && !item.value)
                continue;
            if (this.ignoreItems.find(i => i.id === item.id))
                return;
            const allowErrorList = item.allowErrorList || [];
            if (allowErrorList.includes(item.value.toString())) {
                continue;
            }
            const err = checkValidateValue(item.value, {
                validate: item.validate,
                required: item.required,
                min: item.minLength,
                max: item.maxLength,
                digit: item.digit === -1 ? Infinity : item.digit,
                message: {
                    required: '请填写填空内容'
                }
            });
            if (!err)
                continue;
            return {
                message: err,
                success: false,
                item
            };
        }
        let max = this.max_choice;
        if (max === Infinity)
            return;
        const length = this.getValue().length;
        if (length === 0 && !required)
            return;
        if (length !== max) {
            return {
                success: false,
                message: `请选出${max}个选项`
            };
        }
    }
    getValueConfirm() {
        for (let i = 0; i < this.value.length; i++) {
            const item = this.value[i];
            if (!item.select)
                continue;
            if (!item || !item.is_other_item)
                continue;
            if (!item.required && !item.value)
                continue;
            if (item.outOfRange !== 1)
                return;
            const allowErrorList = item.allowErrorList || [];
            if (allowErrorList.includes(item.value.toString())) {
                continue;
            }
            const err = checkValidateValue(item.value, {
                validate: item.validate,
                required: item.required,
                min: item.minLength,
                max: item.maxLength,
                digit: item.digit === -1 ? Infinity : item.digit,
                message: {
                    required: '请填写填空内容'
                }
            });
            if (!err)
                continue;
            if (!err.includes('不能')) {
                return null;
            }
            return {
                message: item.outOfRangeMessage
            };
        }
    }
}

class MatrixScroll extends Gravity {
    constructor(data) {
        super(data);
        let minValue = parseInt(data.labels[0].num);
        let value = parseInt(data.default_value);
        let defaultValue = isNaN(value) ? minValue : value;
        this.items = this.transformScrollItems(data.items, data.is_rand, defaultValue);
        this.labels = data.labels || [];
    }
    transformScrollItems(items = [], isRand, defaultValue) {
        let results = items.map(item => {
            return Object.assign(item, { value: defaultValue });
        });
        if (isRand) {
            results = shuffle(results);
        }
        return results;
    }
    // @ts-ignore
    checkValue() { }
}

class Compose {
    constructor(data) {
        this.items = this.initItems(data.items, data.is_col_rand, data.colRandList || []);
        this.cells = this.initCells(data.cells);
        this.rows = [];
        this.value = [];
        this.widths = data.widths || [];
    }
    initItems(items = [], isRand = false, list) {
        items = items.map(item => {
            return Object.assign({}, item, {});
        });
        if (isRand) {
            items = randList(items, list);
        }
        return items;
    }
    initCells(cells = []) {
        return cells.map(cell => {
            return Object.assign({}, cell, {});
        });
    }
    getCellByItemId(id) {
        return this.cells.find(c => c.col_id === id);
    }
    addValue(value = []) {
        let values = this.value.slice();
        while (value.length) {
            let val = value.shift();
            values = values.filter(v => {
                return !(v.colId === val.colId && v.rowId === val.rowId);
            });
            values.push(val);
        }
        this.value = values;
    }
    getValueByRowAndCol(row, col) {
        return this.value.find(v => v.rowId === row.row_id && v.colId === col.id);
    }
    getValue() {
        return this.value.filter(v => {
            return this.rows.find(row => row.row_id === v.rowId);
        });
    }
    setValue(data) {
        this.value = data;
        // 有可能文案一样但是id不一致 （重复修改题目导致的）
        this.value.forEach(item => {
            if (!item.optionId)
                return;
            const cell = this.cells.find(cell => cell.col_id === item.colId);
            if (!cell || !cell.items)
                return;
            const it = cell.items.find((it) => it.id === item.optionId);
            if (it)
                return;
            const i = cell.items.find((it) => it.content.text === item.value);
            if (!i)
                return;
            item.optionId = i.id;
        });
    }
    checkValue(required) {
        // if (!required) return
        let items = this.getValue();
        // if (items.length !== this.cells.length * this.rows.length) {
        //   return {
        //     success: false,
        //     message: '每个子项都为必选项'
        //   }
        // }
        let flag = false;
        const cols = this.items;
        for (const row of this.rows) {
            cols.forEach(col => {
                let cell = items.find(i => i.colId === col.id && row.row_id === i.rowId);
                row.errMap[col.id] = '';
                if ((!cell || !cell.value) && col.required) {
                    row.errMap[col.id] = '内容不能为空';
                    flag = true;
                }
            });
        }
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            let cell = this.getCellByItemId(item.colId);
            if (cell && cell.cell_type === questionType.SINGLE_TEXT_FILL) {
                let err = checkValidateValue(item.value, {
                    max: cell.max_length,
                    min: cell.min_length,
                    validate: cell.validate,
                    digit: cell.digit
                });
                let row = this.rows.find(i => i.row_id === item.rowId);
                if (err) {
                    row.errMap[item.colId] = err;
                    flag = true;
                }
            }
        }
        if (!flag)
            return;
        return {
            success: false,
            message: ''
        };
    }
}
class MatrixCompose extends Compose {
    constructor(data) {
        super(data);
        this.rows = this.initRows(data.rows, data.is_row_rand, data.rowRandList || []);
        this.rowDesc = data.rowDesc;
    }
    initRows(rows = [], isRand = false, list) {
        rows = rows.map(row => {
            let ids = this.items.map(item => item.id);
            let errMap = {};
            ids.forEach(id => {
                errMap[id] = '';
            });
            return Object.assign({}, row, { errMap });
        });
        if (isRand) {
            rows = rowRandList(rows, list);
        }
        return rows;
    }
}
class MatrixAuto extends Compose {
    constructor(data) {
        super(data);
        const default_row_num = data.default_row_num || 2;
        this.can_add_row = data.can_add_row || false;
        this.max_row_num = data.max_row_num || default_row_num;
        this.min_row_num = data.min_row_num || default_row_num;
        this.rows = this.initRows(Math.max(default_row_num, this.min_row_num));
    }
    initRows(default_row_num) {
        let res = [];
        let n = 1;
        let itemIds = this.items.map(i => i.id);
        while (n <= default_row_num) {
            let errMap = {};
            itemIds.forEach(id => {
                errMap[id] = '';
            });
            res.push({
                row_id: n.toString(),
                content: {
                    text: n,
                    richText: n
                },
                errMap
            });
            n++;
        }
        return res;
    }
    addRow() {
        let n = this.rows.length + 1;
        let itemIds = this.items.map(i => i.id);
        let errMap = {};
        itemIds.forEach(id => {
            errMap[id] = '';
        });
        this.rows.push({
            row_id: n.toString(),
            content: {
                text: n,
                richText: n
            },
            errMap
        });
    }
    deleteRow(index) {
        let item = this.rows[index];
        if (!item)
            return;
        this.value = this.value.filter(v => v.rowId !== item.row_id);
        this.rows.splice(index, 1);
    }
    setValue(data) {
        super.setValue(data);
        let set = new Set();
        data.forEach(d => {
            set.add(d.rowId);
        });
        this.rows = this.initRows(Math.min(set.size, this.max_row_num));
    }
}

class HandWriting {
    constructor() {
        this.url = '';
    }
    setSignature(signature) {
        this.signature = signature;
    }
    toUrl() {
        let signature = this.signature;
        if (!signature)
            return Promise.reject();
        if (signature.isEmpty())
            return Promise.resolve({
                optionId: '',
                colId: '',
                rowId: '',
                value: ''
            });
        let dataURL = signature.toDataURL('image/png');
        let blob = dataURLToBlob(dataURL);
        const f = new File([blob], Date.now() + '.png');
        let fd = new FormData();
        fd.append('file', f);
        return upload(fd).then(res => {
            let data = res.data;
            return {
                optionId: '',
                colId: '',
                rowId: '',
                value: data.url
            };
        });
    }
    getValue(type) {
        if (type === 'submit') {
            if (this.signature) {
                if (this.signature.isEmpty()) {
                    return [
                        {
                            colId: "",
                            rowId: "",
                            optionId: "",
                            value: this.url
                        }
                    ];
                }
                return this.toUrl();
            }
            else {
                return [
                    {
                        colId: "",
                        rowId: "",
                        optionId: "",
                        value: this.url
                    }
                ];
            }
        }
        else {
            return [];
        }
    }
    setValue(data) {
        if (data.length) {
            this.url = data[0].value;
        }
    }
    checkValue(required) {
        var _a;
        if (required && ((_a = this.signature) === null || _a === void 0 ? void 0 : _a.isEmpty()) && !this.url) {
            return {
                success: false,
                message: '不能为空'
            };
        }
    }
}

class CascadeRegion {
    constructor() {
        this.answerValue = [];
    }
    getCascade(pid) {
        return new Promise((resolve, reject) => {
            getCascaderRegion(pid).then(res => {
                let data = res.data;
                data.forEach((item) => {
                    if (item.next) ;
                    else {
                        item.leaf = true;
                    }
                });
                resolve(data);
            });
        });
    }
    getValue() {
        return this.answerValue;
    }
    setValue(data) {
        this.answerValue = data;
    }
    checkValue() { }
}

class Downloadable {
    checkValue(required) { }
    getValue(type) {
        return [];
    }
    setValue(data) { }
}

class MapQ {
    constructor(data) {
        this.disallowUpdateLocation = data.disallowUpdateLocation;
        this.disallowInput = data.disallowInput;
        this.displayType = data.displayType;
        this.value = '';
        this.inputValue = '';
        this.list = [];
    }
    changeValue(val) {
        this.value = val.name + '|' + val.entr_location;
    }
    getPoiList(val) {
        return new Promise((resolve, reject) => {
            getPositionList(val)
                .then((res) => {
                let pois = res.pois || [];
                let list = pois.map((item) => ({
                    id: item.id,
                    name: item.name,
                    entr_location: item.location,
                    location: item.location
                }));
                this.list = list;
                resolve(list);
            })
                .catch(reject);
        });
    }
    checkValue(required) {
        if ((this.disallowInput && this.displayType === 0) ||
            (this.displayType === 1 && this.disallowInput && !this.disallowUpdateLocation)) {
            let values = this.value.split('|');
            values.pop();
            let value = values.join('|');
            let val = this.list.find(item => item.name === value);
            if (!val) {
                return {
                    success: false,
                    message: '请输入内容'
                };
            }
        }
    }
    getValue(type) {
        let val = this.value;
        if (!val && this.inputValue) {
            val = this.inputValue + '| , ';
        }
        if (!val)
            return [];
        return [
            {
                colId: '',
                rowId: '',
                optionId: '',
                value: val
            }
        ];
    }
    setValue(data) {
        if (data.length) {
            let val = data[0].value;
            this.value = val;
            this.inputValue = val.split('|')[0];
        }
    }
}

function convertItems$1(items = [], rangeType, min, max) {
    return items.map((item) => {
        const res = Object.assign({ value: 0, selectUnknown: false }, item);
        if (rangeType === 1) {
            res.min = min;
            res.max = max;
        }
        res.value = res.min || 0;
        return res;
    });
}
class Total {
    constructor(data) {
        this.items = convertItems$1(data.items || [], data.rangeType, data.min, data.max);
        this.openDifferentRange = data.openDifferentRange || false;
        this.showUnknown = data.showUnknown || false;
        this.unknownText = data.unknownText || '';
        this.showGraticule = data.showGraticule || false; // 是否显示刻度线
        this.graticule = data.graticule || 10; //刻度值
        this.showSum = data.showSum || false; // 是否显示加总项
        this.validate = Object.assign({}, {
            open: false,
            operator: '',
            value: 0
        }, data.validate || {});
    }
    getSum() {
        return this.items.reduce((res, item) => {
            if (item.selectUnknown)
                return res;
            return res + item.value;
        }, 0);
    }
    checkValue(required, opt) {
        if (this.showUnknown)
            return;
        if (!this.validate.open)
            return;
        if (!this.validate.operator)
            return;
        const sum = this.getSum();
        const value = this.validate.value;
        let message = '';
        switch (this.validate.operator) {
            case SelectType.GT:
                if (sum <= value) {
                    message = `加总值需要大于${value}`;
                }
                break;
            case SelectType.LT:
                if (sum >= value) {
                    message = `加总值需要小于${value}`;
                }
                break;
            case SelectType.Equal:
                if (value !== sum) {
                    message = `加总值需要等于${value}`;
                }
                break;
            case SelectType.NotEqual:
                if (value === sum) {
                    message = `加总值需要不等于${value}`;
                }
                break;
            case SelectType.GTEqual:
                if (sum < value) {
                    message = `加总值需要大于等于${value}`;
                }
                break;
            case SelectType.LTEqual:
                if (sum > value) {
                    message = `加总值需要小于等于${value}`;
                }
                break;
        }
        if (message) {
            return {
                message,
                success: false
            };
        }
    }
    getValue(type) {
        return this.items.map(item => {
            const value = item.selectUnknown ? '' : item.value;
            return {
                optionId: item.id,
                rowId: '',
                colId: '',
                value
            };
        });
    }
    setValue(data) {
        data.forEach(({ value, optionId }) => {
            let find = this.items.find(i => i.id === optionId);
            if (find) {
                if (value === '') {
                    find.selectUnknown = true;
                    find.value = 0;
                }
                else {
                    find.value = value;
                }
            }
        });
    }
}

class MaxDiff {
    constructor(data) {
        this.items = data.items || [];
        this.labelBest = data.labelBest || '最重要';
        this.labelItem = data.labelItem || '';
        this.labelWorst = data.labelWorst || '最不重要';
        this.taskNum = data.taskNum || 0;
        this.numPerTask = data.numPerTask || 0;
        this.align = hasValue(data.align) ? data.align : 0; // 0=左对齐，1=居中，2=右对齐
        this.allowReset = hasValue(data.allowReset) ? data.allowReset : true;
        this.fixedTask = data.fixedTask || false;
        this.extraQue = data.extraQue || { content: null };
        this.tasks = this.initialTask(data.tasks || []);
        if (!this.tasks.length) {
            this.initTasks();
        }
        this.results = this.initialResults();
    }
    initialTask(tasks) {
        return tasks.map(ids => {
            return ids.map(id => {
                return this.items.find(item => item.id === id);
            });
        });
    }
    initialResults() {
        let results = [];
        this.tasks.forEach((task, index) => {
            results.push({
                taskId: (index + 1).toString(),
                bestId: '',
                worstId: '',
                ids: task.map(t => t.id)
            });
        });
        return results;
    }
    initTasks() {
        const { taskNum, numPerTask, items } = this;
        let tasks = [];
        let n = 0;
        for (let i = 0; i < taskNum; i++) {
            let step = n + numPerTask;
            let list = items.slice(n, step);
            if (list.length < numPerTask) {
                let temp = items.filter(item => !list.find(l => l.id === item.id));
                list.push(...temp.slice(0, numPerTask - list.length));
            }
            const task = shuffle(list);
            n = step % items.length;
            tasks.push(task);
        }
        this.tasks = tasks;
    }
    checkValue(required, opt) {
        let isCheckAll;
        if (this.numPerTask === 1) {
            isCheckAll = this.results.every(res => res.bestId || res.worstId);
        }
        else {
            isCheckAll = this.results.every(res => res.bestId && res.worstId);
        }
        if (isCheckAll) {
            return;
        }
        if (!required)
            return;
        return {
            success: false,
            message: '请填写全部内容'
        };
    }
    getValue(type) {
        // colId "0=最好，1=最差，2=所有选项，3=后续问题答案"
        return this.results.reduce((results, result) => {
            let worstItem = this.items.find(item => item.id === result.worstId);
            let bestItem = this.items.find(item => item.id === result.bestId);
            if (worstItem) {
                results.push({
                    optionId: worstItem.id,
                    value: worstItem.content.text,
                    rowId: result.taskId,
                    colId: '1'
                });
            }
            if (bestItem) {
                results.push({
                    optionId: bestItem.id,
                    value: bestItem.content.text,
                    rowId: result.taskId,
                    colId: '0'
                });
            }
            results.push({
                optionId: result.ids.join(','),
                rowId: result.taskId,
                colId: '2',
                value: result.ids.map(id => { var _a; return (_a = this.items.find(item => item.id === id)) === null || _a === void 0 ? void 0 : _a.content.text; }).join(',')
            });
            return results;
        }, []);
    }
    setValue(data) {
        const taskIdMap = {};
        data.forEach(item => {
            if (item.colId === '2')
                return;
            if (!taskIdMap[item.rowId]) {
                taskIdMap[item.rowId] = [];
            }
            taskIdMap[item.rowId].push(item);
        });
        for (const taskId in taskIdMap) {
            let result = this.results.find(r => r.taskId === taskId);
            if (result) {
                let val = taskIdMap[taskId];
                val.forEach(item => {
                    if (item.colId === '0') {
                        result.bestId = item.optionId;
                    }
                    else if (item.colId === '1') {
                        result.worstId = item.optionId;
                    }
                });
            }
        }
    }
    getCurrentIndex() {
        if (this.numPerTask === 1) {
            return this.results.findIndex(result => !(result.worstId || result.bestId));
        }
        else {
            return this.results.findIndex(result => !(result.worstId && result.bestId));
        }
    }
}

const issueMap = new Map();
singleTypes.forEach(type => {
    issueMap.set(type, SingleChoice);
});
textTypes.forEach(t => {
    issueMap.set(t, TextFill);
});
issueMap.set(questionType.SINGLE_CHOICE, SingleChoice);
issueMap.set(questionType.MULTIPLE_CHOICE, MutChoice);
issueMap.set(questionType.SINGLE_SELECT, SingleChoice);
issueMap.set(questionType.MULTIPLE_SELECT, MutChoice);
issueMap.set(questionType.LINKAGE, Cascader);
issueMap.set(questionType.MATRIX_SINGLE_CHOICE, MatrixSingleChoice);
issueMap.set(questionType.MATRIX_MULTIPLE_CHOICE, MatrixMultipleChoice);
issueMap.set(questionType.MATRIX_SELECT_CHOICE, MatrixSelectChoice);
issueMap.set(questionType.BLANKS, Blanks);
issueMap.set(questionType.SINGLE_TEXT_FILL, TextFill);
issueMap.set(questionType.MULTIPLE_TEXT_FILL, TextFill);
issueMap.set(questionType.SCALE, Scale);
issueMap.set(questionType.MATRIX_SCALE, MatrixScale);
issueMap.set(questionType.NPS_SCALE, NPSScale);
issueMap.set(questionType.CUSTOM_SINGLE_SCALE, CustomScale);
issueMap.set(questionType.UPLOAD_FILE, UploadFile);
issueMap.set(questionType.DATE, DateTime);
issueMap.set(questionType.DATE_OF_BIRTH, DateTime);
issueMap.set(questionType.MATRIX_GRAVITY, Gravity);
issueMap.set(questionType.PHONE_VALIDATE, TextFill);
issueMap.set(questionType.IMAGE_CHOICE, SingleImageChoice);
issueMap.set(questionType.IMAGE_MULTIPLE_CHOICE, MultipleImageChoice);
issueMap.set(questionType.CLASSIFICATION, Classification);
issueMap.set(questionType.MATRIX_FILL, MatrixFill);
issueMap.set(questionType.MULTIPLE_BLANKS, MultipleBlanks);
issueMap.set(questionType.SORT, Sort);
issueMap.set(questionType.MATRIX_SCROLL, MatrixScroll);
issueMap.set(questionType.CUSTOM_MULTIPLE_SCALE, MatrixCustomScale);
issueMap.set(questionType.MATRIX_COMPOSE, MatrixCompose);
issueMap.set(questionType.MATRIX_AUTO, MatrixAuto);
issueMap.set(questionType.HANDWRITING, HandWriting);
issueMap.set(questionType.CITY_ADDRESS, Cascader);
issueMap.set(questionType.PERMANENT_ADDRESS, Cascader);
issueMap.set(questionType.DOMICILE, Cascader);
issueMap.set(questionType.SPECIALITY, Cascader);
issueMap.set(questionType.SCHOOL, Cascader);
issueMap.set(questionType.CASCADE_REGION, CascadeRegion);
issueMap.set(questionType.ONLY_TEXT, OnlyText);
issueMap.set(questionType.DOWNLOADABLE, Downloadable);
issueMap.set(questionType.MAP, MapQ);
issueMap.set(questionType.TOTAL, Total);
issueMap.set(questionType.MAX_DIFF, MaxDiff);

function createQuestionFactory(data, isAnswer = false, option = {}) {
    if (!isAnswer) {
        // 做一些非答卷的处理
        if (data.issue.autoFillEnable) {
            // 只有在答题时 自动填充/填空状态才有效
            data.issue.autoFillEnable = false;
        }
    }
    const question = new Question(data.id, data.content, data.note, data.questionType, !!data.required, data.type, createIssueFactory(data.issue, data.questionType, option));
    question.issue.catchData = data;
    question.answerScore = data.answerScore || {};
    if (!data.setting || Object.keys(data.setting).length === 0) {
        // 如果没有 问题设置 或者 问题设置 为空对象 说明是旧版创建的 （旧版 默认是开启问题描述的）
        data.setting = {
            enableNote: true,
            enableFold: false,
        };
    }
    question.setting = Object.assign({ requiredType: RequiredType.All }, data.setting || {});
    question.setGroupInfo(data.groupQuestionId, data.groupQuestionKey);
    if (data.isNullQuestion) {
        question.required = false;
        question.isNoopAnswer = true;
    }
    return question;
}
function createIssueFactory(data, type, option) {
    let IssueCtor = issueMap.get(type);
    if (IssueCtor) {
        return new IssueCtor(data, option);
    }
    else {
        throw new Error(`未找到 questionType 为 ${type} 的类型, ${typeMapping.get(type)}`);
    }
}

function convertQuestionList(list, num, cacheAnswerContent, option) {
    const questions = [];
    for (let i = 0, len = list.length; i < len; i++) {
        const item = list[i];
        let cache = cacheAnswerContent.find(i => i.questonId === item.id);
        let question = createQuestionFactory(item, true, option);
        if (cache) {
            let isMounted = false;
            if (!question.setting.autoFillLastAnswer && cache.items.length && cache.items.every((item) => item.value)) {
                question.hasValue = true;
            }
            question.setHook('mounted', () => {
                if (isMounted)
                    return;
                isMounted = true;
                question.setValue(cache);
            });
        }
        if (question.questionType !== questionType.ONLY_TEXT) {
            question.num = num++;
        }
        questions.push(question);
        question.runHooks('created');
    }
    return questions;
}
function appendQuotaText(el, count, disabled) {
    const span = document.createElement('span');
    if (count === 0) {
        span.innerText = `(配额已满)`;
    }
    else {
        span.innerText = `(剩余${count})`;
    }
    if (disabled) {
        span.style.color = 'rgba(0,0,0,.45)';
    }
    else {
        span.style.color = 'rgba(0,0,0,.65)';
    }
    span.style.marginLeft = '8px';
    el.append(span);
}
function sendMessage(data) {
    if (window.wx) {
        wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
                wx.miniProgram.postMessage({ data });
            }
        });
    }
    if (window.top && window.top !== window) {
        window.top.postMessage(JSON.stringify(data), '*');
        return;
    }
}
function isSameArray(arr1, arr2) {
    if (arr1.length !== arr2.length)
        return false;
    return arr1.every(item => arr2.includes(item));
}
/**
 * 计算数学表达式
 * @param val1
 * @param val2
 * @param operator
 */
function calcNumExpress(val1, val2, operator) {
    const [min, max] = val1;
    switch (operator) {
        case 'eq':
            return min === val2;
        case 'ne':
            return min !== val2;
        case 'gt':
            return val2 > min;
        case 'ge':
            return val2 >= min;
        case 'lt':
            return val2 < min;
        case 'le':
            return val2 <= min;
        case 'between':
            return val2 >= min && val2 <= max;
        case 'not_between':
            return val2 < min || val2 > max;
    }
}
/**
 * 获取满足条件的逻辑
 * @param conditions
 * @param values
 */
function getMeetConditionsByValue(conditions, values) {
    return conditions.filter(condition => {
        if (condition.subCode === 'chooseNum') {
            const value = Number(condition.rightOptions[0]);
            if (isNaN(value)) {
                return false;
            }
            return calcNumExpress(condition.rightOptions.map(Number), values.length, condition.operator);
        }
        else if (condition.subCode === 'num') {
            const v2 = values[0] ? Number(values[0].value) : 0;
            return calcNumExpress(condition.rightOptions.map(Number), v2, condition.operator);
        }
        else {
            return isSameArray(condition.rightOptions, values.map(item => item.optionId));
        }
    });
}
function resetQuestionListNum(questionList, startNum = 0) {
    let num = startNum;
    for (let i = 0; i < questionList.length; i++) {
        const q = questionList[i];
        if (q.questionType !== questionType.ONLY_TEXT) {
            q.num = num++;
        }
    }
}
function loopList(list, callbackFn, endFn) {
    const step = (index) => {
        callbackFn(list[index], (f = true) => {
            if (f === false) {
                index--;
            }
            if (index !== list.length - 1) {
                step(index + 1);
            }
            else {
                endFn();
            }
        });
    };
    step(0);
}

class DB {
    constructor(name, key, version) {
        this.ignoreKeys = [];
        this.name = name;
        this.key = key || 'id';
        this.version = version || 1;
    }
    read(key) {
        return new Promise((resolve, reject) => {
            if (!this.idb) {
                // @ts-ignore
                return resolve(null);
            }
            const db = this.idb;
            const transaction = db.transaction([this.name]);
            let store = transaction.objectStore(this.name);
            let request = store.get(key);
            request.onsuccess = function (ev) {
                const result = request.result;
                if (result) {
                    const updateTime = result.updateTime;
                    const now = Date.now();
                    if (now - updateTime > DB.cacheTime) {
                        // @ts-ignore
                        return resolve({ expire: true });
                    }
                    resolve(result.content);
                }
                else {
                    // @ts-ignore
                    resolve(null);
                    // console.log('未获得数据记录')
                }
            };
            request.onerror = reject;
        });
    }
    add(id, content, time) {
        return new Promise((resolve, reject) => {
            const db = this.idb;
            if (!db) {
                return;
            }
            let store = db.transaction([this.name], 'readwrite').objectStore(this.name);
            let request = store.add({
                id: id,
                updateTime: time ? time : Date.now(),
                content: content
            });
            request.onsuccess = resolve;
            request.onerror = reject;
        });
    }
    update(key, content) {
        return new Promise((resolve, reject) => {
            let db = this.idb;
            if (!db) {
                return resolve(null);
            }
            const request = db
                .transaction([this.name], 'readwrite')
                .objectStore(this.name)
                .put({ id: key, content, updateTime: Date.now() });
            request.onsuccess = resolve;
            request.onerror = reject;
        });
    }
    readAll(cb) {
        const db = this.idb;
        if (!db)
            return;
        let objectStore = db.transaction(this.name).objectStore(this.name);
        const expires = [];
        objectStore.openCursor().onsuccess = function (ev) {
            const result = ev.target.result;
            if (result) {
                const val = result.value;
                if (Date.now() - val.updateTime > DB.cacheTime) {
                    expires.push(val);
                }
                result.continue();
            }
            else {
                cb && cb(expires);
            }
        };
    }
    clearExpireByTime() {
        this.readAll((expires) => {
            expires.forEach((item) => {
                if (!this.ignoreKeys.includes(item.id))
                    this.remove(item.id);
            });
        });
    }
    remove(key, cb) {
        let db = this.idb;
        if (!db)
            return;
        const request = db.transaction(this.name, 'readwrite').objectStore(this.name).delete(key);
        request.onsuccess = function (event) {
            // console.log('数据删除成功')
            cb && cb();
        };
    }
}
DB.cacheTime = 1000 * 60 * 60 * 2;
function openIDB(d) {
    return new Promise((resolve, reject) => {
        const request = window.indexedDB.open('CACHE_ANSWER', 2);
        request.onerror = function (event) {
            reject({
                msg: 'indexDB 打开失败',
                success: false
            });
        };
        request.onsuccess = function (ev) {
            try {
                let db = request.result;
                d.idb = db;
                d.clearExpireByTime();
                resolve(db);
            }
            catch (e) {
                reject({
                    msg: 'indexDB 打开失败',
                    success: false
                });
            }
        };
    });
}
function createAnswerTable(version) {
    // 如果在本库下建表 必须升级版本 ！！！
    const request = window.indexedDB.open('CACHE_ANSWER', version);
    const tables = ['answer', 'finger_survey'];
    request.onupgradeneeded = function () {
        let db = request.result;
        tables.forEach(name => {
            if (!db.objectStoreNames.contains(name)) {
                db.createObjectStore(name, { keyPath: 'id' });
            }
        });
    };
}
function mergeAnswerContent(cacheContent, answerContent) {
    if (!cacheContent.length)
        return answerContent;
    if (!answerContent.length)
        return cacheContent;
    let mainContent = answerContent;
    let subContent = cacheContent;
    const results = mainContent.slice();
    subContent.forEach(content => {
        if (!results.find(r => r.questonId === content.questonId)) {
            results.push(content);
        }
    });
    return results;
}

var AnswerStatus;
(function (AnswerStatus) {
    AnswerStatus[AnswerStatus["OK"] = 0] = "OK";
    AnswerStatus[AnswerStatus["PASS"] = 1] = "PASS";
    AnswerStatus[AnswerStatus["QUALITY"] = 2] = "QUALITY";
    AnswerStatus[AnswerStatus["SCREEN"] = 4] = "SCREEN";
    AnswerStatus[AnswerStatus["INVALID"] = 5] = "INVALID";
    AnswerStatus[AnswerStatus["EXCESS"] = 6] = "EXCESS";
    AnswerStatus[AnswerStatus["AGAIN"] = 3] = "AGAIN";
    AnswerStatus[AnswerStatus["CLOSE"] = -10000] = "CLOSE";
    AnswerStatus[AnswerStatus["ERR1"] = -10001] = "ERR1";
    AnswerStatus[AnswerStatus["REPEAT"] = -10002] = "REPEAT";
    AnswerStatus[AnswerStatus["ERROR"] = 13] = "ERROR";
    AnswerStatus[AnswerStatus["SAMPLE_ANSWER"] = 14] = "SAMPLE_ANSWER";
    AnswerStatus[AnswerStatus["REPEAT_ERROR"] = 15] = "REPEAT_ERROR";
    AnswerStatus[AnswerStatus["SURVEY_ERROR"] = -10003] = "SURVEY_ERROR";
    AnswerStatus[AnswerStatus["SURVEY_DELETE"] = -10004] = "SURVEY_DELETE";
    AnswerStatus[AnswerStatus["UNKNOWN"] = -999999] = "UNKNOWN";
    AnswerStatus[AnswerStatus["IP_REPEAT"] = -10005] = "IP_REPEAT";
    AnswerStatus[AnswerStatus["SURVEY_UN_PUBLISH"] = -10006] = "SURVEY_UN_PUBLISH";
    AnswerStatus[AnswerStatus["SURVEY_OFF"] = -10007] = "SURVEY_OFF";
    AnswerStatus[AnswerStatus["CHANNEL_ERROR"] = -10008] = "CHANNEL_ERROR";
    AnswerStatus[AnswerStatus["NOT_AGREE"] = -10009] = "NOT_AGREE";
})(AnswerStatus || (AnswerStatus = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["ONLY_WEIXIN"] = -1000] = "ONLY_WEIXIN";
    ErrorCode[ErrorCode["AWARD_ERROR"] = -1001] = "AWARD_ERROR";
    ErrorCode[ErrorCode["AUTHORIZATION"] = -1002] = "AUTHORIZATION";
    ErrorCode[ErrorCode["FOLLOW"] = -1003] = "FOLLOW";
    ErrorCode[ErrorCode["BREAKPOINT"] = -1004] = "BREAKPOINT";
    ErrorCode[ErrorCode["RESTART"] = -1005] = "RESTART";
    ErrorCode[ErrorCode["PASSWORD"] = 2] = "PASSWORD";
    ErrorCode[ErrorCode["FansNormal"] = 4] = "FansNormal";
    ErrorCode[ErrorCode["FansQr"] = 5] = "FansQr";
    ErrorCode[ErrorCode["FORCE_LOCATION"] = 6] = "FORCE_LOCATION";
    ErrorCode[ErrorCode["SURVEY_CLOSE"] = 8] = "SURVEY_CLOSE";
    ErrorCode[ErrorCode["SURVEY_OFF"] = 9] = "SURVEY_OFF";
    ErrorCode[ErrorCode["SURVEY_UN_PUBLISH"] = 102] = "SURVEY_UN_PUBLISH";
    ErrorCode[ErrorCode["UNKNOWN"] = 1] = "UNKNOWN";
    ErrorCode[ErrorCode["ERROR_MESSAGE_OVERLAY"] = -20000] = "ERROR_MESSAGE_OVERLAY";
    ErrorCode[ErrorCode["AGREE_INFO"] = -30000] = "AGREE_INFO";
})(ErrorCode || (ErrorCode = {}));
var SubmitErrorCode;
(function (SubmitErrorCode) {
    SubmitErrorCode[SubmitErrorCode["ERROR"] = 1] = "ERROR";
    SubmitErrorCode[SubmitErrorCode["SURVEY_ERROR"] = 7] = "SURVEY_ERROR";
    SubmitErrorCode[SubmitErrorCode["SURVEY_DELETE"] = 101] = "SURVEY_DELETE";
    SubmitErrorCode[SubmitErrorCode["ANSWER_DELETE"] = 201] = "ANSWER_DELETE";
})(SubmitErrorCode || (SubmitErrorCode = {}));
var MessageType;
(function (MessageType) {
    MessageType[MessageType["SUCCESS"] = 0] = "SUCCESS";
    MessageType[MessageType["ERROR"] = 1] = "ERROR";
    MessageType[MessageType["WARNING"] = 2] = "WARNING";
})(MessageType || (MessageType = {}));
const textMap = {
    [AnswerStatus.OK]: ['您已完成本次问卷，感谢您的帮助与支持！'],
    [AnswerStatus.PASS]: ['您已完成本次问卷，感谢您的帮助与支持！'],
    [AnswerStatus.CLOSE]: ['抱歉，问卷暂时已关闭。'],
    [AnswerStatus.REPEAT]: ['提交重复内容，答卷无效'],
    [AnswerStatus.EXCESS]: ['问卷暂时已收满，感谢您的参与'],
    [AnswerStatus.ERR1]: ['您已回答过此问卷'],
    [AnswerStatus.SCREEN]: ['对不起，您不属于本次调查的范围。谢谢您的参与！'],
    [AnswerStatus.QUALITY]: ['您不符合该问卷回收条件'],
    [AnswerStatus.INVALID]: ['您不符合该问卷回收条件'],
    [AnswerStatus.ERROR]: ['您不符合该问卷回收条件'],
    [AnswerStatus.UNKNOWN]: ['未知错误'],
    [AnswerStatus.SURVEY_ERROR]: ['非常抱歉，发布者刚刚更新了该问卷，麻烦您刷新后重新回答。'],
    [AnswerStatus.SURVEY_DELETE]: ['非常抱歉，该问卷已被发布者删除'],
    [AnswerStatus.IP_REPEAT]: ['发布人已开启同一 IP 限答一次，您当前所在的 IP 已经回答过该问卷'],
    [AnswerStatus.SAMPLE_ANSWER]: ['抱歉 您的问卷不符合回收条件'],
    [AnswerStatus.REPEAT_ERROR]: ['本问卷已设置重复陷阱题，由于同一道题您前后回答不一致，很遗憾，您不符合回收要求'],
    [AnswerStatus.SURVEY_UN_PUBLISH]: ['当前问卷未发布'],
    [AnswerStatus.SURVEY_OFF]: ['抱歉，问卷已被下架，停止访问。'],
    [AnswerStatus.CHANNEL_ERROR]: ['地址错误，请联系您的发布人'],
    [AnswerStatus.NOT_AGREE]: ['答题已终止，谢谢！'],
};
var BoundFailedType;
(function (BoundFailedType) {
    // 超时
    BoundFailedType[BoundFailedType["OVERTIME"] = 1] = "OVERTIME";
    // 未抽中
    BoundFailedType[BoundFailedType["MISS"] = 2] = "MISS";
    // 本答卷已领取过奖励
    BoundFailedType[BoundFailedType["EXCESS"] = 3] = "EXCESS";
    // 此问卷其他答卷已领取过
    BoundFailedType[BoundFailedType["OTHER_EXCESS"] = 4] = "OTHER_EXCESS";
})(BoundFailedType || (BoundFailedType = {}));
var BoundStatus;
(function (BoundStatus) {
    /**
     * 未绑定/未扫码
     */
    BoundStatus[BoundStatus["UNBOUND"] = 0] = "UNBOUND";
    /**
     * 已绑定/已扫码
     */
    BoundStatus[BoundStatus["BOUNDED"] = 1] = "BOUNDED";
    /**
     * 发放成功
     */
    BoundStatus[BoundStatus["SUCCESS2"] = 2] = "SUCCESS2";
    /**
     * 发送失败（超时/基础模块发送失败）
     */
    BoundStatus[BoundStatus["FAILED"] = 3] = "FAILED";
})(BoundStatus || (BoundStatus = {}));

/**
 * TODO 待优化
 */
const cascadeTypes = [
    questionType.LINKAGE,
    questionType.SCHOOL,
    questionType.CITY_ADDRESS,
    questionType.DOMICILE,
    questionType.SPECIALITY,
    questionType.PERMANENT_ADDRESS //常住地
];
const singleChoiceTypes = [
    // questionTypeEnum.SINGLE_SELECT, // 下拉单选
    questionType.SINGLE_CHOICE,
    questionType.IMAGE_CHOICE,
    questionType.AGE_RANGE,
    questionType.JOB,
    questionType.MONTHLY_INCOME_RANGE,
    questionType.MARITAL_STATUS,
    questionType.EDUCATIONAL_ATTAINMENT,
    questionType.GENDER,
    questionType.INDUSTRY //行业
];
let disOrHide = {};
let singleChoiceHandler = function (qs, hide, qsId) {
    qs.issue.items = qs.issue.items.filter((answer) => {
        return !hide[qsId].includes(answer.id);
    });
    if (!qs.issue.items.length) {
        qs.isNullQuestion = true;
    }
};
let cascaderHandler = function (qs, hide, qsId) {
    let groups = qs.issue.groups;
    let ids = hide[qsId];
    function delOpt(groups = [], ids = []) {
        let delArr = [];
        for (let i = 0; i < groups.length; i++) {
            let group = groups[i];
            if (group.isNextLevel) {
                let results = delOpt(group.nextLevelOptions, ids);
                if (results) {
                    let { flag, delIds } = results;
                    if (flag) {
                        delIds.forEach(id => {
                            let idx = group.nextLevelOptions.findIndex((n) => n.id === id);
                            group.nextLevelOptions.splice(idx, 1);
                        });
                    }
                    if (!group.nextLevelOptions.length) {
                        delArr.push(group.id);
                    }
                }
            }
            else {
                if (ids.includes(group.id)) {
                    delArr.push(group.id);
                }
            }
        }
        return {
            delIds: delArr,
            flag: true
        };
    }
    let { delIds } = delOpt(groups, ids);
    delIds.forEach(id => {
        let idx = groups.findIndex((n) => n.id === id);
        groups.splice(idx, 1);
    });
};
singleChoiceTypes.forEach(type => {
    disOrHide[type] = singleChoiceHandler;
});
cascadeTypes.forEach(type => {
    disOrHide[type] = cascaderHandler;
});
const itemTypes = [
    questionType.SINGLE_CHOICE,
    questionType.SINGLE_SELECT,
    questionType.MULTIPLE_CHOICE,
    questionType.MULTIPLE_SELECT,
    questionType.IMAGE_MULTIPLE_CHOICE,
    questionType.IMAGE_CHOICE,
    questionType.SORT,
    questionType.TOTAL,
    questionType.MATRIX_SCALE,
    questionType.MATRIX_AUTO
];
itemTypes.forEach(type => {
    disOrHide[type] = singleChoiceHandler;
});
disOrHide[questionType.MATRIX_SINGLE_CHOICE] = function (qs, hide, qsId) {
    qs.issue.rows = qs.issue.rows.filter((row) => {
        return !hide[qsId].includes(row.row_id);
    });
    qs.issue.items = qs.issue.items.filter((col) => {
        return !hide[qsId].includes(col.id);
    });
    if (qs.issue.cells) {
        const colIds = qs.issue.items.map((item) => item.id);
        const rowIds = qs.issue.rows.map((item) => item.row_id);
        qs.issue.cells = qs.issue.cells.filter((cell) => {
            if (!cell.row_id) {
                return colIds.includes(cell.col_id);
            }
            return rowIds.includes(cell.row_id) && colIds.includes(cell.col_id);
        });
    }
};
disOrHide[questionType.MATRIX_MULTIPLE_CHOICE] = disOrHide[questionType.MATRIX_SINGLE_CHOICE];
const rowColTypes = [questionType.MATRIX_FILL, questionType.MATRIX_COMPOSE, questionType.CLASSIFICATION];
rowColTypes.forEach(type => {
    disOrHide[type] = disOrHide[questionType.MATRIX_SINGLE_CHOICE];
});
disOrHide[questionType.MULTIPLE_BLANKS] = function (qs, hide, qsId) {
    qs.issue.fillContext = qs.issue.fillContext.filter((answer) => {
        return !hide[qsId].includes(answer.id);
    });
    if (!qs.issue.fillContext.length) {
        qs.isNullQuestion = true;
    }
};
/**
 *
 * @param t
 * @param hide
 */
function getCurrentAnswerHide(t, hide) {
    Object.keys(hide).forEach(qsId => {
        if (t.id === qsId) {
            disOrHide[t.questionType](t, hide, qsId);
        }
    });
}

function convertScoreData(data, bus) {
    if (!data || !data.hasReward)
        return Promise.resolve(data);
    return new Promise((resolve, reject) => {
        var _a;
        getAwardV2BySurveyId(bus.survey.id, (_a = bus.channel) === null || _a === void 0 ? void 0 : _a.id).then((res) => {
            const moneyAwards = (res.data.moneyAwards || []).filter((award) => {
                return (data.hasSurplusAwardIds || []).includes(award.id);
            });
            if (moneyAwards.length) {
                data.hasReward = moneyAwards.some((award) => {
                    const sendLimit = award.sendLimit || {};
                    const scoreGe = sendLimit.scoreGe;
                    if (!scoreGe)
                        return true;
                    return data.score >= scoreGe;
                });
            }
            resolve(data);
        }).catch(reject);
    });
}

function sendMessage$1(vm, endData, params, answerContent) {
    let data;
    if (!vm.survey) {
        data = {
            message: 'answerOver',
            payload: {
                success: false,
                code: 30003 // 未知问卷
            }
        };
    }
    else if (vm.overData.status === AnswerStatus.CLOSE) {
        data = {
            message: 'answerOver',
            payload: {
                success: false,
                code: 30002 // 当前问卷已关闭
            }
        };
    }
    else if (vm.overData.status < 0) {
        data = {
            message: 'answerOver',
            payload: {
                success: false,
                code: vm.overData.status
            }
        };
    }
    else {
        if (window.top && window.top !== window) {
            try {
                vm.saveErrorLog('答题结束页面调试', JSON.stringify({ data: endData, params, answerContent }));
            }
            catch (e) {
            }
        }
        data = {
            message: 'answerOver',
            payload: {
                success: true,
                code: vm.overData.status,
                answerId: vm.answerId,
                surveyId: vm.survey.id,
                params: params,
                viewUrl: `${window.location.origin}/mobile?surveyId=${vm.survey.id}&answerChannelId=${vm.channel.id}#/preview/${vm.answerId}`,
                score: endData === null || endData === void 0 ? void 0 : endData.score
            }
        };
    }
    if (window.wx) {
        wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
                wx.miniProgram.postMessage({ data });
                if (vm.params.miniprogramType === '1') {
                    wx.miniProgram.navigateBack({ delta: 1 });
                }
            }
        });
    }
    if (window.top && window.top !== window) {
        window.top.postMessage(JSON.stringify(data), '*');
        return;
    }
}
function setScore(vm, data) {
    if (!vm.isScoreSurvey && !hasValue(data === null || data === void 0 ? void 0 : data.score))
        return;
    const closing = vm.closing;
    const score = data.score || 0;
    vm.score = score;
    let scoreEnds = (closing === null || closing === void 0 ? void 0 : closing.otherEnds) || [];
    if (vm.survey.otherSetting.enableInterestingAnswer) {
        scoreEnds = (closing === null || closing === void 0 ? void 0 : closing.funAnswerEnds) || [];
    }
    if (closing && scoreEnds) {
        scoreEnds.forEach(item => {
            if (item.defaults) {
                item.matchRule = Object.assign(Object.assign({}, item.matchRule), { min: -Infinity, max: Infinity });
            }
        });
        scoreEnds.forEach(rawItem => {
            const item = Object.assign({}, rawItem);
            let { min, max } = item.matchRule;
            // min = Number(min)
            // max = Number(max)
            if (min <= score && score <= max && !vm.scoreEnd) {
                vm.scoreEnd = item;
            }
            item.richText = (item.richText || '').replaceAll('[Score]', score);
        });
    }
    if (!vm.scoreEnd) {
        vm.scoreEnd = {
            richText: `<p>提交成功，感谢您的参与！您的得分为：${score}</p>`,
            defaults: true
        };
    }
    else {
        if (vm.survey.otherSetting.enableInterestingAnswer) {
            if (vm.scoreEnd.testResult && vm.scoreEnd.testResult.trim()) {
                vm.hook.run('resetShare', {
                    title: vm.scoreEnd.testResult + '，' + vm.survey.title
                });
            }
        }
        let rawText = vm.scoreEnd.richText;
        let richText = vm.scoreEnd.richText;
        let exp = new RegExp('\\[Score([^\\[.]*)]', 'gi');
        let res = null;
        let results = [];
        while ((res = exp.exec(richText))) {
            let g = res[1];
            let raw = res[0];
            results.push({
                group: g,
                raw
            });
        }
        if (!results.length)
            return;
        let promises = results.map(item => {
            let { group, raw } = item;
            let ids = group.split('+');
            richText = richText.replace(raw, '');
            return getAnswerScore(vm.answerId, ids).then(res => {
                return {
                    data: res.data,
                    raw
                };
            });
        });
        vm.scoreEnd.richText = richText;
        Promise.all(promises).then(res => {
            res.forEach(item => {
                let score = item.data.totalScore;
                let raw = item.raw;
                rawText = rawText.replace(raw, score);
            });
            vm.scoreEnd.richText = rawText;
        });
    }
}
function checkAgain(vm) {
    if (!vm.survey)
        return;
    if (vm.isClosed)
        return;
    checkAnswer(filterParams({
        surveyId: vm.survey.id,
        accountUserFingerprint: vm.accountUserFingerprint,
        accountUserId: vm.params.accountUserId,
        accountUserOpenId: vm.params.accountUserOpenId
    })).then((res) => {
        vm.canAnswerAgain = res.code === 0;
    });
}
function initTextTips(vm, isScoreSurvey) {
    let { status, success, tips } = vm.overData;
    let closing = vm.closing || {};
    let textTips = [];
    if (success) {
        if (isScoreSurvey) {
            //
            if (!vm.enableDimensionScore) {
                vm.$watch('scoreEnd', val => {
                    if (!val)
                        return;
                    textTips = vm.answerTextTips = [val.richText];
                }, { deep: true, immediate: true });
            }
        }
        else {
            if (closing.normalEnd) {
                textTips = [closing.normalEnd.richText];
            }
            else {
                textTips = tips || textMap[AnswerStatus.OK];
            }
        }
    }
    else if (status === AnswerStatus.SCREEN || status === AnswerStatus.QUALITY) {
        if (closing.earlyEnd) {
            textTips = [closing.earlyEnd.richText];
        }
        else {
            textTips = tips || textMap[status];
        }
    }
    else {
        const otherSettingTips = vm.survey.otherSetting.otherSettingTips || {};
        const getOtherSettingTip = (status) => {
            const res = otherSettingTips[status];
            if (!res)
                return null;
            return Array.isArray(res) ? res : [res];
        };
        textTips = tips || getOtherSettingTip(status) || textMap[status] || [];
    }
    vm.answerTextTips = textTips;
}
function getAnswerVote(votes) {
    let n = 1;
    return votes.map(vote => {
        let question = createQuestionFactory(vote.question, true);
        question.num = n++;
        if (vote.answerContentDto.items.length) {
            question.setValue(vote.answerContentDto);
            if (question.setting.enableVoteAnswerFilter) {
                if (question.issue.convertVoteAnswer) {
                    question.issue.convertVoteAnswer();
                }
            }
        }
        question.showVote = true;
        question.setVote(vote);
        return question;
    });
}
function answerOver(vm) {
    const params = Object.assign({}, vm.params);
    return function (data, isNormalEnd, answerContent) {
        vm.busOption.scroll.scrollTo(0);
        console.log('答题结束');
        if ((!data || !isNormalEnd) && vm.answerId) {
            getAwardInfoByAnswerId(vm.answerId).then(res => {
                var _a;
                // const award =
                // if (!award.lotteryAward && award.otherLotteryAward) {
                //   award.lotteryAward = award.otherLotteryAward
                // }
                // if(data.hasReward) {
                //   award.hasReward = true
                // }
                // if(data.needAccountUserId) {
                //   award.needAccountUserId = true
                // }
                // if(data.awardIsLottery) {
                //   award.awardIsLottery = true
                // }
                if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.bindAward) {
                    res.data.bindAward.boundFailedType = res.data.boundFailedType;
                }
                convertScoreData(Object.assign({ score: data.score }, res.data), vm).then((data) => {
                    vm.currentAwardData = data;
                });
            });
        }
        else if (data) {
            convertScoreData({
                awardIsLottery: data.awardIsLottery,
                needAccountUserId: data.needAccountUserId,
                hasReward: data.hasReward,
                bindAward: null,
                hasSurplusAwardIds: data.hasSurplusAwardIds,
                score: data.score
            }, vm).then((data) => {
                vm.currentAwardData = data;
            });
        }
        if (data && (data.voteCounts || []).length) {
            vm.voteQuestions = getAnswerVote(data.voteCounts);
        }
        // initTextTips(vm)
        const fn = once(() => {
            if ([AnswerStatus.OK, AnswerStatus.PASS].includes(vm.overData.status)) {
                setScore(vm, data);
            }
            if (!vm.isClosed && vm.overData.status >= 0) {
                checkAgain(vm);
            }
        });
        if (vm.overData) {
            fn();
        }
        vm.$watch('overData', (val) => {
            if (val) {
                initTextTips(vm, vm.isScoreSurvey || (data === null || data === void 0 ? void 0 : data.score));
                fn();
            }
        }, { immediate: true });
        if (vm.enableLuck) {
            getCanLuck().then(res => {
                vm.showLuck = !!res.data;
            });
        }
        if (vm.enableMoreSurvey) {
            vm.$answerUtil.getEnv().then((res) => {
                var _a;
                let data = {
                    displaySize: 5,
                    customerId: undefined
                };
                if (!res.miniprogram) {
                    data.customerId = (_a = vm.params) === null || _a === void 0 ? void 0 : _a.accountUserId;
                }
                getMoreSurveyList(filterParams(data))
                    .then(res => {
                    const list = res.data.records;
                    vm.moreSurveyList = list.reduce((res, item) => {
                        let price = '';
                        const award = item;
                        if (award && award.quantity && award.totalAmount) {
                            if (award.rdMin && award.rdMax) {
                                price = `¥${award.rdMin} - ${award.rdMax}`;
                            }
                            else if (award.amount) {
                                price = `¥${award.amount}`;
                            }
                        }
                        else if (award && award.amount) {
                            price = `${award.amount}积分`;
                        }
                        if ((!item.releaseChannel || !item.surveyId) && !item.gmourl)
                            return res;
                        res.push({
                            title: item.title,
                            surveyId: item.surveyId,
                            channelId: item.releaseChannel,
                            price,
                            gmourl: item.gmourl,
                            isThirdParty: item.isThirdParty,
                            amount: item.amount,
                            partakeAmount: item.partakeAmount
                        });
                        return res;
                    }, []);
                })
                    .catch(err => {
                    console.log(err);
                });
            });
        }
        // @ts-ignore
        vm.$answerUtil.getCurrentAwardCount();
        // vm.refreshAward()
        //是否显示维度分析报告
        if (vm.isScoreSurvey) {
            showReportAfterAnswer(vm.survey.id)
                .then(res => {
                // 查询不到代表无维度
                if (res) {
                    vm.enableDimensionScore = res.showReportAfterAnswer;
                    vm.openStandardScore = res.openStandardScore;
                    if (vm.enableDimensionScore) {
                        getAnswerDimensionScore(vm.answerId).then(res => {
                            vm.answerDimensionScore = res.data;
                        });
                    }
                }
                vm.isWait = false;
            })
                .catch(() => {
                vm.isWait = false;
            });
        }
        else {
            vm.isWait = false;
        }
        if (vm.surveyPoint || (vm.params.pageType || '').toString() === '3') {
            vm.answerPoint.pending = true;
            getAnswerPoint(vm.answerId).then(res => {
                vm.answerPoint.pending = false;
                vm.answerPoint.value = res;
            });
        }
        sendMessage$1(vm, data, params, answerContent);
    };
}

function surveyLoad(vm) {
    return function () {
        function getLocationHandler() {
            if (hasValue(vm.userLocationType)) {
                if (vm.userLocationType !== 0) {
                    getLocation(vm);
                }
            }
            else if (vm.enableUserLocation) {
                getLocation(vm);
            }
        }
        console.log('问卷加载完成');
        if (!vm.params.isTest) {
            if (vm.platformSdkFinished) {
                getLocationHandler();
            }
            else {
                vm.hook.on('platformSdkLoad', getLocationHandler);
            }
        }
        window.addEventListener('message', evt => {
            const data = evt.data;
            if (typeof data !== 'object')
                return;
            if (data.type !== 'otherSetting')
                return;
            vm.survey.otherSetting = Object.assign({}, vm.survey.otherSetting, data.value || {});
            // mergeOtherSetting(vm.survey.otherSetting,data.value || {})
        });
    };
}
function refreshAddress(answerId, address, errMessage) {
    if (!address || errMessage) {
        const errMsg = errMessage ? `定位失败-${errMessage}` : '定位失败';
        address = {
            IS_OK: false,
            address: errMsg,
            lng: '0',
            lat: '0',
            adds: errMsg
        };
    }
    refreshAnswerAddress({
        id: answerId,
        surveyRegion: address.adds,
        surveyLon: address.lng,
        surveyLat: address.lat,
        answerAddress: address.address
    });
}
function getLocation(vm) {
    getAddress(vm.currentBrowserInfo)
        .then(res => {
        vm.address = res;
        if (vm.answerId && vm.isStart) {
            if (res.IS_OK) {
                refreshAddress(vm.answerId, res);
            }
            else {
                if (res.lat && res.lng) {
                    refreshAddress(vm.answerId, res);
                }
                else {
                    refreshAddress(vm.answerId, null);
                }
                if (res.convertErrorCode) {
                    addErrLog(vm, {
                        errTitle: '定位失败',
                        errInfo: JSON.stringify({ infocode: res.convertErrorCode, info: res.convertError })
                    });
                }
            }
        }
    })
        .catch(err => {
        var _a, _b;
        if (err.userRefuse && vm.userLocationType === 2 && vm.currentBrowserInfo.isWeixin) {
            (_b = (_a = vm.busOption).overlay) === null || _b === void 0 ? void 0 : _b.call(_a, { code: ErrorCode.FORCE_LOCATION });
        }
        addErrLog(vm, {
            errTitle: '定位失败',
            errInfo: JSON.stringify(err)
        });
        if (vm.answerId && vm.isStart) {
            refreshAddress(vm.answerId, null, err.message);
        }
    });
}
function addErrLog(vm, data) {
    const handler = () => {
        addErrorLog(Object.assign({ surveyId: vm.survey.id, answerId: vm.answerId, accountUserFingerprint: vm.accountUserFingerprint, accountUserId: vm.params.accountUserId, answerUrl: window.location.href }, data));
    };
    if (vm.answerId) {
        handler();
    }
    else {
        vm.errorLogTask.push(handler);
    }
}

function sendMessage$2(vm, data) {
    if (!window.top || window.top === window) {
        return;
    }
    window.top.postMessage(JSON.stringify(data), '*');
    if (vm.currentBrowserInfo.isWeixin) {
        try {
            wx.miniProgram.postMessage(data);
        }
        catch (e) {
            console.log(e);
        }
    }
}
function answerStart(vm) {
    return function () {
        console.log('开始答题');
        vm.customStartData = {};
        if (vm.errorLogTask.length) {
            vm.errorLogTask.forEach(t => t());
            vm.errorLogTask = [];
        }
        sendMessage$2(vm, {
            message: 'answerStart',
            payload: {
                answerId: vm.answerId,
                surveyId: vm.survey.id,
                params: vm.params,
                code: 0,
                success: true
            }
        });
        if (vm.params.disableSubmit) {
            if (window.top === window) {
                vm.params.disableSubmit = false;
                return;
            }
            // 读取不到window.top!.origin.indexOf('localhost') 暂时注释
            // if (window.top!.origin.indexOf('localhost') < 0) {
            //   if (window.top!.origin !== window.origin) {
            //     vm.params.disableSubmit = false
            //     return
            //   }
            // }
            window.addEventListener('message', evt => {
                if (typeof evt.data !== 'object')
                    return;
                if (evt.data.type !== 'setAnswerContent')
                    return;
                const answerContent = evt.data.answerContent;
                vm.pageList.forEach(q => {
                    const answer = answerContent.find((a) => a.questonId === q.id);
                    if (answer) {
                        q.setValue(answer);
                    }
                });
            });
            window.addEventListener('message', evt => {
                if (evt.data === 'submit') {
                    // @ts-ignore
                    vm.submitOrNextPage();
                }
                else if (evt.data === 'getAnswerContent') {
                    // @ts-ignore
                    vm.getAnswerContent().then(list => {
                        sendMessage$2(vm, {
                            message: 'answerContent',
                            payload: {
                                answerId: vm.answerId,
                                surveyId: vm.survey.id,
                                answerContent: list,
                                success: true
                            }
                        });
                    });
                }
            });
        }
    };
}

function initAnswerUtil(Vue, bus) {
    // @ts-ignore
    Vue.prototype.$answerUtil = new Vue({
        data() {
            return {
                currentAward: null
            };
        },
        methods: {
            onStartMoreSurvey(survey) {
                if (survey.gmourl) {
                    // 用于计算答题时间
                    answeringThirdSurvey({
                        thirdSurveyId: survey.surveyId,
                        customerId: bus.params.accountUserId
                    });
                    window.open(survey.gmourl);
                    return;
                }
                const origin = window.location.origin;
                const pathname = window.location.pathname;
                const data = Object.assign(Object.assign({}, bus.params), { surveyId: survey.surveyId, answerChannelId: survey.channelId });
                window.location.replace(`${origin}${pathname}?${objectToQuery(data)}`);
            },
            getCurrentAwardCount() {
                const vm = this;
                if (!bus.survey)
                    return;
                getAwardCountBySurveyId(bus.survey.id).then(res => {
                    vm.currentAward = res.data;
                });
            },
            getShareText(bus) {
                const vm = this;
                if (!vm.currentAward)
                    return;
                if (!bus.hadShare) {
                    if (vm.currentAward.countForRed) {
                        return '分享问卷给好友答题，一起领红包';
                    }
                    else {
                        return '分享问卷';
                    }
                }
                else {
                    if (vm.currentAward.countForShare) {
                        if (bus.enableNetManualAudit) {
                            //问卷还剩 ${bus.share.quantity} 个分享红包待领取，
                            return `问卷还剩 ${vm.currentAward.countForShare} 个分享红包待领取，将问卷分享给好友，好友完成答题且审核通过后，您可收到分享红包~`;
                        }
                        else {
                            return `问卷还剩 ${vm.currentAward.countForShare} 个分享红包待领取，将问卷分享给好友，好友完成答题后，您可收到分享红包~`;
                        }
                    }
                    else {
                        if (vm.currentAward.countForRed) {
                            return '分享问卷给好友答题，一起领红包';
                        }
                        else {
                            return '分享红包已领完，您可继续分享问卷，邀请好友答题';
                        }
                    }
                }
            },
            wxAuthorization(pageType) {
                const origin = `${location.origin}/mobile`; //'https://testcloud.treeyee.com/mobile'
                const searchParams = {
                    surveyId: bus.survey.id,
                    answerChannelId: bus.channel.id,
                    companyid: bus.params.companyid,
                    checkTimestamp: Date.now().toString(),
                    answerId: bus.answerId,
                    pageType
                };
                const redirectUri = `${origin}?${objectToQuery(searchParams)}`;
                // @ts-ignore
                const appid = this.$wxAppId || 'wx338f55c8b5822937';
                const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
                location.href = url;
            },
            getShareUrl() {
                const urlParam = {
                    surveyId: bus.survey.id,
                    answerChannelId: bus.channel.id,
                    shareAnswerId: bus.answerId,
                    pageType: '1',
                    companyid: bus.params.companyid,
                    shareAccountUserId: bus.params.accountUserId
                };
                const origin = window.origin;
                const returnUrl = `${origin}/mobile?${convertObjToUrlSearch(urlParam)}`;
                return `${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(returnUrl)}`;
            },
            getEnv() {
                if (bus.currentBrowserInfo.isWeixin) {
                    return new Promise(resolve => {
                        if (window.wx && wx.miniProgram) {
                            wx.miniProgram.getEnv(res => {
                                resolve({ miniprogram: res.miniprogram });
                            });
                        }
                        else {
                            resolve({ miniprogram: false });
                        }
                    });
                }
                else {
                    return Promise.resolve({ miniprogram: false });
                }
            },
            postMessage(data) {
                document.addEventListener('UniAppJSBridgeReady', function () {
                    uni.postMessage({ data });
                });
                if (window.uni) {
                    uni.postMessage({ data });
                }
                if (window.top && window.top !== window) {
                    window.top.postMessage(JSON.stringify(data), '*');
                }
            }
        }
    });
}

function choice(question, value) {
    const items = question.issue.items;
    items.forEach((item) => {
        if (Reflect.has(value, item.id)) {
            item.showQuotaCount = true;
            item.count = Math.max(0, value[item.id]);
            if (item.count === 0) {
                item.disabled = true;
            }
        }
    });
}
function initQuotaCount(question, quotaRemainderNumMap) {
    const qid = question.id;
    const value = quotaRemainderNumMap[qid];
    if (!value)
        return;
    const choiceTypes = [
        ...singleTypes,
        questionType.MULTIPLE_CHOICE,
        questionType.MULTIPLE_SELECT,
        questionType.IMAGE_MULTIPLE_CHOICE
    ];
    if (choiceTypes.includes(question.questionType)) {
        choice(question, value);
    }
}

function choice$1(question) {
    const items = question.issue.items;
    return items.every((item) => {
        if (!item.showQuotaCount)
            return false;
        return item.count === 0;
    });
}
function checkQuotaIsFull(question) {
    const choiceTypes = [
        ...singleTypes,
        questionType.MULTIPLE_CHOICE,
        questionType.MULTIPLE_SELECT,
        questionType.IMAGE_MULTIPLE_CHOICE
    ];
    if (choiceTypes.includes(question.questionType)) {
        return choice$1(question);
    }
    return false;
}

/**
 * 自动填空功能
 */
function initAutoFillWatcher(list, answerContent, cacheAnswerContent) {
    const operate = ['+', '-', '*', '/', '(', ')', 'X', '&'];
    const ids = list.map(q => q.id);
    list.forEach(q => {
        if (!q.issue.autoFillEnable)
            return;
        const fills = q.issue.autoFill;
        fills.forEach(item => {
            if (item.conditions) {
                if (item.matched === false && item.conditions.length)
                    return;
            }
            else {
                if (item.matched === false)
                    return;
            }
            // if (item.matched === false && item.conditions?.length) return
            item.fillRules.forEach((rule) => {
                if (!rule.expression)
                    return;
                const expression = rule.expression.map(expr => {
                    if (expr === 'X')
                        return '*';
                    if (expr === '&')
                        return '';
                    return expr;
                }).filter(hasValue);
                const watcher = (content) => {
                    var _a, _b;
                    const c = mergeAnswerContent(cacheAnswerContent, (answerContent || []).filter((c) => !ids.includes(c.questonId)));
                    let value;
                    switch (rule.calcMethod) {
                        case 1:
                        case 3:
                            value = expression.map(expr => {
                                const item = getAnswerItemByExpr(c, expr.toString());
                                if (!item)
                                    return '';
                                return item.value;
                            }).join('');
                            break;
                        case 2:
                            const res = getExprValueByAnswer(expression, c);
                            if (isNaN(res) || res === Infinity) {
                                value = '';
                            }
                            else {
                                value = res.toFixed(rule.scale).toString();
                            }
                            break;
                        case 4:
                            const qid = expression[0];
                            const i = c.find(i => {
                                return i.questonId === qid;
                            });
                            if (!i) {
                                value = 0;
                            }
                            else {
                                value = i.items.length;
                            }
                            break;
                    }
                    (_b = (_a = q.issue).setValueByRule) === null || _b === void 0 ? void 0 : _b.call(_a, rule, value);
                };
                rule.expression.forEach(expr => {
                    if (typeof expr === 'number')
                        return;
                    if (operate.includes(expr))
                        return;
                    const [qid] = expr.split('.');
                    const question = list.find(q => q.id === qid);
                    if (question) {
                        question.pushAnswerWatcher(watcher);
                    }
                });
                q.setHook('mounted', () => {
                    watcher();
                });
            });
        });
    });
}
function initAutoFill(q) {
    if (!q.issue.autoFillEnable)
        return;
    const fills = q.issue.autoFill;
    if (fills.every(f => f.matched === false)) {
        q.issue.autoFillEditable = true;
    }
}

function initAutoValidate(list, answerContent, cacheAnswerContent) {
    const operate = ['+', '-', '*', '/', '(', ')'];
    const ids = list.map(q => q.id);
    list.forEach(q => {
        var _a;
        if (!q.issue.complexValidateEnable || !((_a = q.issue.complexValidate) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        const rules = q.issue.complexValidate;
        const handler = () => {
            q.questionErrorList = [];
            const content = mergeAnswerContent(cacheAnswerContent, (answerContent || []).filter((c) => !ids.includes(c.questonId)));
            if (!q.issue.runComplexValidate)
                return;
            const c = content.find(c => c.questonId === q.id);
            if (!c || !c.items.length)
                return;
            const res = q.issue.runComplexValidate(content, c);
            if (res.success)
                return;
            const subCode = [q.id, res.rule.conditions[0].subCode].filter(Boolean).join('.');
            q.questionErrorList.push({
                key: subCode,
                message: res.message
            });
        };
        q.setHook('updated', handler);
        rules.forEach(rule => {
            rule.conditions.forEach(c => {
                const expression = c.rightOptions.map(s => {
                    if (s === 'X')
                        return '*';
                    return s;
                });
                expression.forEach(s => {
                    if (typeof s === 'number')
                        return;
                    if (operate.includes(s))
                        return;
                    const [qid] = s.split('.');
                    const question = list.find(q => q.id === qid);
                    if (!question)
                        return;
                    question.setHook('updated', handler);
                });
            });
        });
    });
}

function jumpToPage(vm, data) {
    const jumpViewMap = vm.survey.otherSetting.jumpViewMap;
    if (!jumpViewMap)
        return;
    const status = data.status;
    const s = Object.keys(jumpViewMap).find(s => String(s) === String(status)) || 'default';
    const url = jumpViewMap[s];
    if (!url)
        return;
    let args = (jumpViewMap.args || []).map((arg) => `${arg}=${vm.params[arg]}`).join('&');
    let query = args ? `${url.indexOf('?') > -1 ? '&' : '?'}${args}` : '';
    const src = url + query;
    window.location.replace(src);
}
function beforeAnswerOver(vm) {
    return function (data, isNormalEnd) {
        jumpToPage(vm, data);
    };
}

class Hook {
    constructor() {
        this.hookMap = new Map();
    }
    run(key, ...args) {
        let hooks = this.hookMap.get(key);
        if (!hooks)
            return;
        const handlers = hooks.slice();
        handlers.forEach(handler => handler(...args));
    }
    on(key, handler) {
        let hooks = this.hookMap.get(key);
        if (!hooks) {
            hooks = [];
        }
        hooks.push(handler);
        this.hookMap.set(key, hooks);
    }
    off(key, handler) {
        if (!handler) {
            this.hookMap.set(key, []);
        }
        else {
            let hooks = this.hookMap.get(key);
            if (!hooks) {
                hooks = [];
            }
            let index = hooks.findIndex(h => h === handler);
            if (index !== -1) {
                hooks.splice(index, 1);
            }
        }
    }
    clearAll() {
        this.hookMap.clear();
    }
}

const createBaseBusData = (urlParams) => {
    return {
        // 用户信息
        user: null,
        // 开始答题时会拼接的参数
        customStartData: {},
        closing: null,
        isStart: false,
        isEnd: false,
        isSurveyLoad: false,
        isClosed: false,
        // 路径参数
        params: urlParams,
        // 是否显示上一页按钮
        enablePrePage: false,
        // 是否显示更多按钮
        enableMoreSurvey: false,
        enableMoreShare: true,
        // 是否需要手机号
        enablePhoneAnswer: false,
        // 是否显示开始答题按钮
        enableHomePage: false,
        // 允许提交答卷后预览答卷
        viewableAfterSubmit: false,
        // 是否需要审核
        enableNetManualAudit: false,
        // 滑块验证
        enableVerification: false,
        // 是否显示维度与评分
        enableDimensionScore: false,
        //是否处于获取显示维度与评分的状态
        isWait: true,
        // 答卷维度与评分报告
        answerDimensionScore: {},
        // 是否显示抽奖
        enableLuck: false,
        enableQuestionIndex: false,
        enableQuestionType: false,
        showLuck: false,
        // 有密码时有用
        isCheckPassword: false,
        // 是否可以修改答卷
        editSubmit: false,
        verificationCheck: false,
        showVerification: false,
        // verification
        // 当前答卷信息
        currentAnswerData: null,
        // 当前奖励信息
        currentAwardData: null,
        survey: null,
        answerId: '',
        award: null,
        share: null,
        surveyPoint: null,
        answerPoint: {
            pending: false,
            value: null
        },
        hadAward: false,
        hadShare: false,
        // 红包 || 抽奖 信息
        lottery: null,
        channel: null,
        // 是否是考试问卷
        isScoreSurvey: false,
        scoreEnd: null,
        pageList: [],
        cacheAnswerContent: [],
        answerContent: [],
        loading: false,
        currentCount: 0,
        totalCount: 0,
        isLastPage: false,
        isSoftPage: false,
        currentPageNum: 0,
        overData: null,
        maxAnswerTime: 0,
        minAnswerTime: 0,
        minPageAnswerTime: 0,
        maxPageAnswerTime: 0,
        nextPageBtnDisabled: false,
        submitBtnDisabled: false,
        innerHeight: window.innerHeight,
        address: {},
        currentBrowserInfo: {
            isWeixin: isWeixin(),
            isPc: isPC()
        },
        hook: new Hook(),
        accountUserFingerprint: null,
        // 能否再次答题
        canAnswerAgain: false,
        errorLogTask: [],
        // 是否已经答过
        isAnswering: false,
        // 是否显示答题历史
        hasHistory: false,
        // 是否点击了拆红包（没有啥实质作用 只是看的）
        isOpenReward: false,
        // 是否领取奖励
        isReceive: false,
        // 领奖信息
        receiveInfo: null,
        // 审核失败原因
        auditDescription: '',
        // 答题结束页面的提示语
        answerTextTips: [],
        moreSurveyList: null,
        // 答题的时候是否显示预览
        showPreview: false,
        // 是否已经分享
        currentPageIsShare: false,
        // 是否为软分页
        isSofgPageStart: false,
        // 答题结束页面对 投票题
        voteQuestions: [],
        // 是否为用户切换故事
        isChangeUserStory: false
    };
};

function convertAddress2params(address) {
    return {
        surveyRegion: address.adds,
        surveyLon: address.lng,
        surveyLat: address.lat,
        answerAddress: address.address
    };
}
function initInterceptors(urlParams) {
    const { token, tenantId } = urlParams;
    if (token === 'tenantId' && tenantId === 'token')
        return;
    if (token && tenantId) {
        setRequestInterceptors(config => {
            config.headers['TENANT-ID'] = tenantId;
            config.headers['Authorization'] = 'Bearer ' + token;
            return config;
        });
    }
}
function Bus(Vue, option) {
    let preDuration = 0;
    let closeLoading = null;
    const urlParams = normalizeUrlParams();
    const queue = new Queue();
    createAnswerTable(2);
    initInterceptors(urlParams);
    setResponseInterceptors(r => r, err => {
        if (!Vue.prototype.$bus.isEnd) {
            if (err.code === "ECONNABORTED" || err.response.status >= 500) {
                option.message(MessageType.WARNING, '请稍后刷新页面重试');
            }
        }
        if (Vue.prototype.$bus.isEnd) {
            const vm = Vue.prototype.$bus;
            addErrorLog({
                surveyId: vm.survey.id,
                answerId: vm.answerId,
                accountUserFingerprint: vm.accountUserFingerprint,
                accountUserId: vm.params.accountUserId,
                answerUrl: window.location.href,
                errTitle: '答题结束页面错误',
                // @ts-ignore
                errInfo: `${err} `
            });
        }
        if (err.response.status === 413 && err.config.url === "/fill/api/v1/upload") {
            option.message(MessageType.WARNING, '上传文件过大，请检查文件重新上传');
        }
        // return Promise.reject(err)
    });
    const bus = (Vue.prototype.$bus = new Vue({
        data() {
            return createBaseBusData(urlParams);
        },
        computed: {
            currentPageHasScore() {
                const vm = this;
                return vm.pageList.some(q => {
                    return q.setting.enableAnswerScore;
                });
            },
            showAnswerScoreInAnswering() {
                const vm = this;
                return vm.survey.otherSetting.showAnswerScoreInAnswering === 1;
            },
            buttonOption() {
                const vm = this;
                const option = vm.survey.otherSetting.buttonOption;
                const res = {
                    startText: '开始答题',
                    nextText: '下一页',
                    prevText: '上一页',
                    submitText: '提交'
                };
                if (vm.showAnswerScoreInAnswering) {
                    if (vm.currentPageHasScore) {
                        if (!vm.showPreview) {
                            res.nextText = res.submitText = '确认';
                        }
                    }
                }
                copyProperty(res, option || {});
                return res;
            },
            percent() {
                const vm = this;
                if (!vm.totalCount) {
                    return 0;
                }
                return Math.ceil((vm.currentCount / vm.totalCount) * 100);
            },
            showCopyright() {
                const vm = this;
                const otherSetting = vm.survey.otherSetting || {};
                // if (!Reflect.has(otherSetting, 'disabledCopyright')) return true
                return !otherSetting.disabledCopyright;
            },
            needLogin() {
                const vm = this;
                if (vm.params.answerType === '1') {
                    return false;
                }
                else if (vm.params.accountUserId) {
                    return false;
                }
                return true;
            }
        },
        methods: {
            initial(params) {
                const vm = this;
                vm.hook.clearAll();
                const data = createBaseBusData(params);
                Object.keys(data).forEach(key => {
                    // @ts-ignore
                    vm[key] = data[key];
                });
            },
            initSurvey(data) {
                const vm = this;
                vm.survey = data.survey;
                vm.channel = data.channel;
                // vm.share = data.share
                // vm.hadAward = data.hadAward
                // vm.hadShare = data.hadShare
                // vm.award = data.award
                vm.lottery = data.lottery;
                if (!data.lottery.enableLottery) {
                    // 主要是兼容之前红包的写法
                    vm.share = data.lottery.share;
                    vm.hadAward = data.lottery.hadAward;
                    vm.hadShare = data.lottery.hadShare;
                    vm.award = data.lottery.award;
                }
                else {
                    if (data.lottery.lotteryAwards.length) {
                        // 如果是抽奖 并且有奖品 就不显示 默认抽奖
                        vm.enableLuck = vm.survey.otherSetting.enableLuck = false;
                    }
                }
                if (data.surveyPoint && data.surveyPoint.limit > 0) {
                    vm.surveyPoint = data.surveyPoint;
                }
                this.transformOtherSetting(data.survey.otherSetting);
                if (vm.enableMoreSurvey) {
                    getMoreSurveyStatus().then(status => {
                        vm.survey.otherSetting.enableMoreSurvey = vm.enableMoreSurvey = status === '1';
                    });
                }
            },
            init(data, urlParams) {
                const vm = this;
                this.initSurvey(data);
                getFinger().then((finger) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d;
                    if (vm.params.accountUserFingerprint) {
                        vm.accountUserFingerprint = vm.params.accountUserFingerprint;
                    }
                    else if (vm.params.smsMessageId) {
                        vm.accountUserFingerprint = vm.params.smsMessageId;
                    }
                    else {
                        vm.accountUserFingerprint = finger;
                    }
                    this.initHook();
                    vm.closing = data.survey.closing;
                    if (data.channel.activeFlag === 0) {
                        vm.isEnd = true;
                        this.setOverData({
                            success: false,
                            overText: textMap[AnswerStatus.CLOSE],
                            status: AnswerStatus.CLOSE
                        });
                        vm.isClosed = true;
                        vm.isSurveyLoad = true;
                        this.closeLoading();
                        vm.hook.run('answerOver');
                        return;
                    }
                    if (!vm.params.isTest) {
                        if ((vm.survey.otherSetting.isOnlyWeixin ||
                            vm.survey.otherSetting.enableInterestingAnswer ||
                            vm.survey.otherSetting.enableForceWxAuthorization ||
                            ((_a = data.informedConsent) === null || _a === void 0 ? void 0 : _a.needWechatAuth)) &&
                            !vm.currentBrowserInfo.isWeixin) {
                            (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, {
                                code: ErrorCode.ONLY_WEIXIN,
                                data: '您需要在微信中打开才能参与'
                            });
                            this.closeLoading();
                            return;
                        }
                    }
                    if (hasValue(vm.params.shareAccountUserId) && hasValue(vm.params.accountUserId) && vm.params.shareAccountUserId === vm.params.accountUserId) {
                        if (vm.params.shareAnswerId) {
                            vm.params.answerId = vm.params.shareAnswerId;
                            vm.params.shareAnswerId = null;
                            vm.params.shareAccountUserId = null;
                        }
                    }
                    if (data.informedConsent) {
                        this.closeLoading();
                        const isOK = yield this.agreeInfo(data.informedConsent);
                        if (!isOK) {
                            document.title = data.survey.title;
                            vm.isSurveyLoad = true;
                            vm.hook.run('surveyLoad');
                            vm.isEnd = true;
                            this.setOverData({
                                success: false,
                                overText: textMap[AnswerStatus.NOT_AGREE],
                                status: AnswerStatus.NOT_AGREE
                            });
                            vm.hook.run('answerOver', {});
                            return;
                        }
                        this.openLoading();
                    }
                    if ((vm.params.pageType === '1' || vm.params.pageType === '2' || vm.params.shareAccountUserId === vm.params.accountUserId) && vm.params.answerId) {
                        getAnswerRes(vm.params.answerId).then((res) => {
                            vm.answerId = vm.params.answerId;
                            let data = res.data;
                            this.closeLoading();
                            this.transformEndPage(data, false);
                            vm.isSurveyLoad = true;
                        });
                    }
                    else if (vm.survey.otherSetting.enableInterestingAnswer &&
                        (!vm.params.accountUserId || !vm.user) &&
                        !vm.params.isTest) {
                        (_c = option.overlay) === null || _c === void 0 ? void 0 : _c.call(option, {
                            code: ErrorCode.AUTHORIZATION
                        });
                        this.closeLoading();
                    }
                    else if (vm.survey.otherSetting.enableForceWxAuthorization &&
                        !vm.params.accountUserId &&
                        !vm.params.isTest) {
                        (_d = option.overlay) === null || _d === void 0 ? void 0 : _d.call(option, {
                            code: ErrorCode.AUTHORIZATION
                        });
                        this.closeLoading();
                    }
                    else if (!vm.enableHomePage) {
                        this.onStart();
                    }
                    else {
                        this.checkAnswer();
                        this.closeLoading();
                        vm.isSurveyLoad = true;
                    }
                    if (data.survey.surveyCategory.toString() === '1') {
                        vm.isScoreSurvey = true;
                    }
                    document.title = data.survey.title;
                    vm.hook.run('surveyLoad');
                }));
            },
            agreeInfo(informedConsent) {
                const data = this;
                return new Promise((resolve, reject) => {
                    getUserInformedConsentSign({
                        surveyId: data.params.surveyId,
                        accountUserFingerprint: data.accountUserFingerprint,
                        accountUserId: data.params.accountUserId,
                        accountUserOpenId: data.params.accountUserOpenId
                    }).then((r) => __awaiter(this, void 0, void 0, function* () {
                        var _a;
                        data.customStartData.informedConsentId = informedConsent.id;
                        // 同一用户显示频次。1=提交答卷前仅显示一次，提交答卷后重新显示；2=每次打开均显示；3= 仅显示一次
                        if ((informedConsent === null || informedConsent === void 0 ? void 0 : informedConsent.displayFrequencyType) === 3) {
                            if (r.data) {
                                return resolve(true);
                            }
                        }
                        //
                        if ((informedConsent === null || informedConsent === void 0 ? void 0 : informedConsent.displayFrequencyType) === 1) {
                            // if (r.data?.relatedAnswerIds) {
                            //
                            // }
                            const finger = this.getLocalCacheKey();
                            const answerId = yield this.getLocalCacheAnswerId(data.params.surveyId, finger);
                            if (answerId) {
                                return resolve(true);
                            }
                        }
                        const vm = (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
                            code: ErrorCode.AGREE_INFO,
                            data: informedConsent
                        });
                        if (vm) {
                            vm.$on('confirm', (fd, snap) => {
                                const promises = [];
                                if (fd) {
                                    promises.push(upload(fd).then(res => {
                                        data.customStartData.signUrl = res.data.url;
                                    }));
                                }
                                if (snap) {
                                    promises.push(upload(snap).then(res => {
                                        data.customStartData.informedConsentShotUrl = res.data.url;
                                    }));
                                }
                                if (promises.length) {
                                    this.openLoading();
                                    Promise.all(promises).then(() => {
                                        vm.$emit('close');
                                        resolve(true);
                                    });
                                }
                                else {
                                    vm.$emit('close');
                                    resolve(true);
                                }
                            });
                            vm.$on('cancel', () => {
                                vm.$emit('close');
                                resolve(false);
                            });
                        }
                    }));
                });
            },
            initError(err) {
                this.initHook();
                const vm = this;
                getFinger().then(finger => {
                    var _a;
                    if (vm.params.accountUserFingerprint) {
                        vm.accountUserFingerprint = vm.params.accountUserFingerprint;
                    }
                    else {
                        vm.accountUserFingerprint = finger;
                    }
                    const surveyErrorCode = err.survey.code;
                    if (surveyErrorCode === SubmitErrorCode.SURVEY_DELETE) {
                        // this.transformEndPage({})
                        // this.setOverData({
                        //   status: AnswerStatus.UNKNOWN,
                        //   success: false,
                        //   overText: textMap[AnswerStatus.UNKNOWN]
                        // })
                        // vm.enableMoreShare = false
                        // this.closeLoading()
                        // vm.hook.run('answerOver')
                        (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
                            code: ErrorCode.ERROR_MESSAGE_OVERLAY,
                            data: { message: "未找到相关问卷信息" }
                        });
                        this.closeLoading();
                        return;
                    }
                    vm.isSurveyLoad = true;
                    vm.isEnd = true;
                    vm.canAnswerAgain = false;
                    this.initSurvey(err);
                    if (!err.channel) {
                        this.setOverData({
                            status: AnswerStatus.CHANNEL_ERROR,
                            success: false,
                            overText: textMap[AnswerStatus.CHANNEL_ERROR]
                        });
                        vm.enableMoreShare = false;
                        this.closeLoading();
                        vm.hook.run('answerOver');
                    }
                });
            },
            transformOtherSetting(otherSetting) {
                const vm = this;
                if (!otherSetting) {
                    otherSetting = {};
                }
                if (vm.params.isTest) {
                    //测试连接【包括电脑、手机、扫码答题】不显示任何广告
                    otherSetting.enableLuck = false;
                    otherSetting.enableAdsense = vm.survey.otherSetting.enableAdsense = false;
                    otherSetting.enableMoreSurvey = false;
                }
                // 没有值的情况下为true
                const defaultsTrue = [
                    // 获取地理位置
                    'enableUserLocation',
                    //结束页是否显示 `更多问卷` 按钮
                    'enableMoreSurvey',
                    'enableQuestionIndex',
                    'enableQuestionType'
                ];
                defaultsTrue.forEach(key => {
                    if (!Reflect.has(otherSetting, key) || otherSetting[key]) {
                        vm[key] = true;
                    }
                });
                // 值为bool
                const valueIsBools = [
                    'enableNetManualAudit',
                    'viewableAfterSubmit',
                    'enablePrePage',
                    'enablePhoneAnswer',
                    'enableVerification',
                    'enableLuck',
                    'editSubmit',
                    'enableHomePage'
                ];
                valueIsBools.forEach(key => {
                    vm[key] = !!otherSetting[key];
                });
                if (!('progressStatus' in otherSetting)) {
                    otherSetting.progressStatus = 1;
                }
                if (otherSetting.themeHeader) {
                    const defaults = {
                        align: 'left',
                        type: 'image'
                    };
                    otherSetting.themeHeader = Object.assign({}, defaults, otherSetting.themeHeader);
                }
                // 直接赋值
                const assignments = ['maxAnswerTime', 'userLocationType', 'minAnswerTime'];
                assignments.forEach(key => {
                    vm[key] = otherSetting[key];
                });
                // @ts-ignore
                vm.$answerUtil.getEnv().then(res => {
                    if (res.miniprogram) {
                        otherSetting.enableAdsense = vm.survey.otherSetting.enableAdsense = false;
                    }
                });
                if (vm.params.from === "app") {
                    vm.survey.otherSetting.isOnlyWeixin = false;
                    vm.customStartData.skipFansCheck = true;
                }
            },
            onStart(isRestart = false) {
                var _a;
                const vm = this;
                if (vm.enableVerification) {
                    if (!vm.verificationCheck) {
                        vm.showVerification = true;
                        this.closeLoading();
                        return;
                    }
                }
                const otherSetting = vm.survey.otherSetting || {};
                const passwordType = otherSetting.passwordType;
                if (!vm.isCheckPassword) {
                    if (passwordType) {
                        (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
                            code: ErrorCode.PASSWORD,
                            data: passwordType
                        });
                        this.closeLoading();
                        return;
                    }
                }
                this.startAnswer(isRestart);
            },
            getAnswerRes() {
                const vm = this;
                return getAnswerRes(vm.answerId).then((res) => {
                    let data = res.data;
                    if (!data) {
                        vm.isEnd = true;
                        this.setOverData({
                            success: false,
                            overText: textMap[AnswerStatus.SCREEN],
                            status: AnswerStatus.SCREEN
                        });
                        vm.hook.run('answerOver');
                        return;
                    }
                    if (!this.jumpToEndUrl(true))
                        return;
                    if (!vm.isSurveyLoad) {
                        vm.isSurveyLoad = true;
                    }
                    this.closeLoading();
                    vm.auditDescription = data.auditDescription;
                    this.transformEndPage(data);
                });
            },
            onStartAnswerByPWD(pwd, property, cb) {
                const vm = this;
                // const passwordType = vm.survey.otherSetting.passwordType
                // if ([3, 4].includes(passwordType)) {
                //   this.openLoading()
                //
                //   checkPassword(
                //     filterParams({
                //       type: passwordType,
                //       surveyId: vm.survey.id,
                //       password: pwd,
                //       property
                //     })
                //   ).then((res: any) => {
                //     if (res.code === 0) {
                //       const handler = () => {
                //         vm.hook.off('answerStart', handler)
                //         vm.hook.off('answerOver', handler)
                //         if (vm.isCheckPassword) return
                //         cb && cb()
                //         if (!vm.isEnd && !vm.params.isTest) {
                //           bindingPassword({
                //             id: res.data,
                //             answerId: vm.answerId
                //           })
                //         }
                //       }
                //       vm.hook.on('answerStart', handler)
                //       vm.hook.on('answerOver', handler)
                //       this.startAnswer()
                //     } else {
                //       this.closeLoading()
                //       option.overlay?.({
                //         code: ErrorCode.PASSWORD,
                //         message:
                //           passwordType === 3
                //             ? '该密码已被使用，请使用其他密码或联系问卷发布者'
                //             : '输入的信息不正确，请确认无误后重新输入或联系问卷发布者'
                //       })
                //       return
                //     }
                //   })
                // } else {
                vm.customStartData.answerPassword = pwd;
                vm.customStartData.answerPasswordProperty = property;
                const handler = () => {
                    vm.hook.off('answerStart', handler);
                    vm.hook.off('answerOver', handler);
                    cb && cb();
                    if (vm.isCheckPassword)
                        return;
                    // vm.isCheckPassword = true
                };
                vm.hook.on('answerOver', handler);
                vm.hook.on('answerStart', handler);
                this.startAnswer();
                // }
            },
            refreshSurvey() {
                const vm = this;
                this.transformOtherSetting(vm.survey.otherSetting);
                return Promise.all([this.refreshSurveyPoint(), this.refreshAward()]);
            },
            refreshSurveyPoint() {
                var _a;
                const vm = this;
                if ((((_a = vm.channel) === null || _a === void 0 ? void 0 : _a.channelType) || "").toString() !== "2") {
                    return Promise.resolve();
                }
                return getSurveyPoint(vm.survey.id).then((surveyPoint) => {
                    if (surveyPoint && surveyPoint.limit > 0) {
                        vm.surveyPoint = surveyPoint;
                    }
                    else {
                        vm.surveyPoint = undefined;
                    }
                });
            },
            refreshAward() {
                const vm = this;
                return getAwardV2BySurveyId(vm.survey.id, vm.params.answerChannelId).then(r => {
                    // let data = r.data
                    // vm.award = data.award
                    // vm.hadAward = data.hadAward
                    // vm.share = data.share
                    // vm.hadShare = data.hadShare
                    const lottery = r.data;
                    vm.lottery = lottery;
                    if (!lottery.enableLottery) {
                        // 主要是兼容之前红包的写法
                        vm.share = lottery.share;
                        vm.hadAward = lottery.hadAward;
                        vm.hadShare = lottery.hadShare;
                        vm.award = lottery.award;
                    }
                });
            },
            onOverlayCheck(data, body) {
                var _a, _b;
                const bus = this;
                const currentVersionId = hasValue(data.versionId) ? data.versionId : bus.survey.lastReleasedVersionId;
                if (bus.survey.lastReleasedVersionId > currentVersionId) {
                    const restart = (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
                        code: ErrorCode.RESTART
                    });
                    if (restart) {
                        restart.$on('restart', () => {
                            this.openLoading();
                            invalidMine(filterParams({
                                id: bus.answerId,
                                accountUserFingerprint: bus.accountUserFingerprint,
                                accountUserId: bus.params.accountUserId,
                                accountUserOpenId: bus.params.accountUserOpenId,
                                openId: bus.params.openId
                            })).then(res => {
                                var _a;
                                (_a = bus.answerDB) === null || _a === void 0 ? void 0 : _a.remove(bus.answerId);
                                this.onStart();
                                restart.$emit('close');
                            });
                        });
                    }
                    return;
                }
                if (!body.id && (data === null || data === void 0 ? void 0 : data.currentPageNum) === 0)
                    return;
                const count = bus.pageList.reduce((c, q) => {
                    if (q.hasValue) {
                        c += 1;
                    }
                    return c;
                }, data.answeredCount || 0);
                if (count <= 0)
                    return;
                const vm = (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, {
                    code: ErrorCode.BREAKPOINT,
                    data: count
                });
                if (vm) {
                    vm.$on('restart', () => {
                        this.openLoading();
                        invalidMine(filterParams({
                            id: bus.answerId,
                            accountUserFingerprint: bus.accountUserFingerprint,
                            accountUserId: bus.params.accountUserId,
                            openId: bus.params.openId
                        })).then(res => {
                            var _a;
                            (_a = bus.answerDB) === null || _a === void 0 ? void 0 : _a.remove(bus.answerId);
                            this.onStart();
                            vm.$emit('close');
                        });
                    });
                    vm.$on('continue', () => {
                        vm.$emit('close');
                    });
                }
            },
            getLocalCacheKey() {
                const vm = this;
                return vm.params.dbKey || vm.params.accountUserId || vm.accountUserFingerprint;
            },
            getLocalCacheAnswerId(surveyId, key) {
                return new Promise((resolve, reject) => {
                    const fingerSurveyDB = new DB('finger_survey');
                    openIDB(fingerSurveyDB).then(() => {
                        fingerSurveyDB.read(surveyId).then((surveyAnswer) => {
                            if (surveyAnswer && !surveyAnswer.expire) {
                                resolve(surveyAnswer[key]);
                            }
                            else {
                                resolve(null);
                            }
                        });
                    });
                });
            },
            startAnswer(isRestart = false) {
                const vm = this;
                vm.isEnd = false;
                const answerType = vm.params.answerType;
                this.openLoading();
                const fingerSurveyDB = new DB('finger_survey');
                const surveyId = vm.survey.id;
                let startRequest = startAnswering;
                if (vm.params.isTest) {
                    startRequest = startTestAnswering;
                }
                const params = {};
                if (vm.params.isTest && vm.params.initiateQuestionId) {
                    params.initiateQuestionId = vm.params.initiateQuestionId;
                }
                const finger = this.getLocalCacheKey();
                openIDB(fingerSurveyDB)
                    .then(() => {
                    vm.surveyAnswerDB = fingerSurveyDB;
                    fingerSurveyDB.read(surveyId).then(surveyAnswer => {
                        let answerId = undefined;
                        if (surveyAnswer && !surveyAnswer.expire) {
                            answerId = surveyAnswer[finger];
                        }
                        let data = Object.assign(Object.assign(Object.assign(Object.assign({ surveyId: vm.survey.id, channel: "0", answerChannelId: vm.channel.id, accountUserFingerprint: vm.accountUserFingerprint, id: answerId, answerUrl: window.location.href.split('#')[0] + `&ua=${encodeURIComponent(navigator.userAgent)}` }, convertAddress2params(vm.address)), vm.params), vm.customStartData), { ua: undefined // 写死就行 用不到 作用是防止分享链接上携带 后端没有多余字段存储 ua 信息 所以 ua 信息存到了 answerUrl 上
                         });
                        if (!params.isTest && data.versionId) {
                            data.versionId = '';
                        }
                        if (!vm.currentBrowserInfo.isWeixin) {
                            data.token = '';
                            if (vm.params.answerType !== '1' && !vm.currentBrowserInfo.isPc) {
                                data.accountUserId = '';
                            }
                            data.accountUsername = '';
                            data.accountUserWxNickname = '';
                        }
                        if (answerType === 'investigator') {
                            data.channel = '14';
                            delete data.id;
                        }
                        else if (answerType === 'investigatorAdd') {
                            data.channel = '13';
                            delete data.id;
                        }
                        else if (answerType === 'customer') {
                            data.channel = '20';
                            delete data.id;
                        }
                        else if (answerType === 'customerAdd') {
                            data.channel = '19';
                            delete data.id;
                        }
                        startRequest(filterParams(data), params)
                            .then((res) => {
                            const answerDB = new DB('answer');
                            // answerDB.clearExpireByTime()
                            // fingerSurveyDB.clearExpireByTime()
                            const flag = this.transformStartResponse(res);
                            if (!flag)
                                return;
                            if (!res.data) {
                                this.transformEndPage({});
                                this.setOverData({
                                    success: false,
                                    overText: textMap[AnswerStatus.ERROR],
                                    status: AnswerStatus.ERROR
                                });
                                this.closeLoading();
                                return;
                            }
                            vm.overData = {
                                answerCertificate: res.data.answerCertificate,
                                score: res.data.score
                            };
                            openIDB(answerDB).then(() => {
                                this.initAnswerList(res, answerId);
                                if (!vm.answerId || vm.isEnd || vm.isAnswering) {
                                    this.closeLoading();
                                    return;
                                }
                                answerDB
                                    .read(vm.answerId)
                                    .then(content => {
                                    if (content) {
                                        vm.cacheAnswerContent = content;
                                    }
                                    else {
                                        answerDB.add(vm.answerId, []);
                                        vm.cacheAnswerContent = [];
                                    }
                                    this.transformNextPage(res.data);
                                    if (!isRestart) {
                                        this.onOverlayCheck(res.data, filterParams(data));
                                    }
                                })
                                    .catch(err => {
                                    this.transformNextPage(res.data);
                                    if (!isRestart) {
                                        this.onOverlayCheck(res.data, filterParams(data));
                                    }
                                });
                                this.closeLoading();
                                if (!surveyAnswer) {
                                    fingerSurveyDB.add(surveyId, {
                                        [finger]: vm.answerId
                                    });
                                }
                                else if (surveyAnswer.expire) {
                                    fingerSurveyDB.ignoreKeys.push(surveyId);
                                    fingerSurveyDB.update(surveyId, {
                                        [finger]: vm.answerId
                                    });
                                }
                                else if (answerId !== res.data.id) {
                                    fingerSurveyDB.update(surveyId, {
                                        [finger]: vm.answerId
                                    });
                                }
                                vm.answerDB = answerDB;
                            });
                        })
                            .catch(err => {
                            this.saveErrorLog('开始答题接口错误', JSON.stringify(err.message));
                            this.closeLoading();
                            return Promise.reject(err);
                        });
                    });
                })
                    .catch(() => {
                    let data = Object.assign(Object.assign(Object.assign({ surveyId: vm.survey.id, channel: '0', answerChannelId: vm.channel.id, accountUserFingerprint: vm.accountUserFingerprint, answerUrl: window.location.href.split('#')[0] }, convertAddress2params(vm.address)), vm.params), vm.customStartData);
                    if (answerType === 'investigator') {
                        data.channel = '14';
                        delete data.id;
                    }
                    else if (answerType === 'investigatorAdd') {
                        data.channel = '13';
                        delete data.id;
                    }
                    else if (answerType === 'customer') {
                        data.channel = '20';
                        delete data.id;
                    }
                    else if (answerType === 'customerAdd') {
                        data.channel = '19';
                        delete data.id;
                    }
                    startRequest(filterParams(data), params)
                        .then(res => {
                        const flag = this.transformStartResponse(res);
                        if (!flag)
                            return;
                        this.initAnswerList(res);
                        this.transformNextPage(res.data);
                        if (!isRestart) {
                            this.onOverlayCheck(res.data, filterParams(data));
                        }
                        this.closeLoading();
                    })
                        .catch(err => {
                        this.closeLoading();
                        return Promise.reject(err);
                    });
                });
            },
            setOverData(data, sync = false) {
                const vm = this;
                if (sync) {
                    vm.overData = data;
                }
                else {
                    vm.$nextTick(() => {
                        vm.overData = data;
                    });
                }
            },
            transformStartResponse(res) {
                const vm = this;
                if (!res) {
                    vm.busOption.message(MessageType.WARNING, '请稍后刷新页面重试');
                    return;
                }
                if (res.code === 0)
                    return true;
                this.closeLoading();
                if (res.code === AnswerStatus.SAMPLE_ANSWER) {
                    this.transformEndPage(res.data);
                    this.setOverData({
                        success: false,
                        overText: textMap[AnswerStatus.SAMPLE_ANSWER],
                        status: AnswerStatus.SAMPLE_ANSWER
                    });
                }
                else if (res.code === ErrorCode.SURVEY_UN_PUBLISH) {
                    this.transformEndPage({});
                    this.setOverData({
                        success: false,
                        overText: textMap[AnswerStatus.SURVEY_UN_PUBLISH],
                        status: AnswerStatus.SURVEY_UN_PUBLISH
                    });
                }
                else if (res.code === ErrorCode.SURVEY_CLOSE) {
                    this.transformEndPage({});
                    this.setOverData({
                        success: false,
                        overText: textMap[AnswerStatus.CLOSE],
                        status: AnswerStatus.CLOSE
                    });
                }
                else if (res.code === ErrorCode.SURVEY_OFF) {
                    this.transformEndPage({});
                    this.setOverData({
                        success: false,
                        overText: textMap[AnswerStatus.SURVEY_OFF],
                        status: AnswerStatus.SURVEY_OFF
                    });
                }
                else if (res.code === ErrorCode.UNKNOWN) {
                    if (res.data && res.data.id) {
                        return true;
                    }
                    this.transformEndPage({});
                    this.setOverData({
                        success: false,
                        status: AnswerStatus.UNKNOWN,
                        tips: res.msg ? [res.msg] : null
                    });
                }
                else {
                    return true;
                }
                vm.isStart = true;
                vm.isSurveyLoad = true;
                return;
            },
            initAnswerList(res, answerId) {
                var _a, _b, _c;
                let vm = this;
                const { code, msg } = res;
                if (code === ErrorCode.FansNormal) {
                    const popupTip = {
                        code: ErrorCode.FansNormal,
                        message: '只允许在微信中作答，分享链接到微信中打开'
                    };
                    (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, popupTip);
                    return;
                }
                else if (code === ErrorCode.FansQr) {
                    const popupTip = {
                        code: ErrorCode.FansQr,
                        message: vm.currentBrowserInfo.isWeixin ? (vm.survey.otherSetting.enabledUserStory ? '扫码关注后生成故事' : '只有公众号粉丝可作答') : '只允许在微信中作答，分享链接到微信中打开',
                        data: res.data.id,
                        showClose: true
                    };
                    const fansVm = (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, popupTip);
                    fansVm.$on('close', () => {
                        vm.customStartData.skipFansCheck = true;
                        this.startAnswer();
                    });
                    return;
                }
                else if (code === ErrorCode.PASSWORD) {
                    (_c = option.overlay) === null || _c === void 0 ? void 0 : _c.call(option, {
                        code: ErrorCode.PASSWORD,
                        message: '输入的信息不正确，请确认无误后重新输入或联系问卷发布者'
                    });
                    return;
                }
                else if (code !== 0) {
                    if (msg === '此答卷已完成答题或被甄别，请勿重复提交' || code === SubmitErrorCode.ANSWER_DELETE) {
                        this.removeCache(answerId, vm.survey.id);
                        this.startAnswer();
                        return;
                    }
                    else {
                        // const answerId = res.data?.id
                        if (code === 3) {
                            vm.isAnswering = true;
                            // vm.isOpenReward = true
                            if (!vm.isSurveyLoad) {
                                vm.isSurveyLoad = true;
                            }
                            // vm.canAnswerAgain = false
                            this.closeLoading();
                            vm.isEnd = true;
                            this.setOverData({
                                success: false,
                                overText: textMap[AnswerStatus.IP_REPEAT],
                                status: AnswerStatus.IP_REPEAT
                            });
                            // vm.overData =
                            vm.hook.run('answerOver');
                        }
                        else if (code === 1 && res.data && res.data.id) {
                            vm.answerId = res.data.id;
                            vm.isAnswering = true;
                            // vm.isOpenReward = true
                            this.getAnswerRes();
                            const voteCounts = res.data.voteCounts || [];
                            if (voteCounts.length > 0) {
                                vm.voteQuestions = getAnswerVote(voteCounts);
                            }
                            this.removeCache();
                        }
                        else if (code === SubmitErrorCode.SURVEY_ERROR) {
                            vm.isEnd = true;
                            this.setOverData({
                                success: false,
                                overText: textMap[AnswerStatus.SURVEY_ERROR],
                                status: AnswerStatus.SURVEY_ERROR
                            });
                            if (!vm.isSurveyLoad) {
                                vm.isSurveyLoad = true;
                            }
                            vm.hook.run('answerOver');
                        }
                        else if (code === SubmitErrorCode.SURVEY_DELETE) {
                            vm.isEnd = true;
                            this.setOverData({
                                success: false,
                                overText: textMap[AnswerStatus.SURVEY_DELETE],
                                status: AnswerStatus.SURVEY_DELETE
                            });
                            if (!vm.isSurveyLoad) {
                                vm.isSurveyLoad = true;
                            }
                            vm.hook.run('answerOver');
                        }
                        else if (code === SubmitErrorCode.SURVEY_DELETE) {
                            vm.isEnd = true;
                            this.setOverData({
                                success: false,
                                overText: textMap[AnswerStatus.SURVEY_DELETE],
                                status: AnswerStatus.SURVEY_DELETE
                            });
                            if (!vm.isSurveyLoad) {
                                vm.isSurveyLoad = true;
                            }
                            vm.hook.run('answerOver');
                        }
                        else {
                            vm.isEnd = true;
                            this.setOverData({
                                success: false,
                                overText: textMap[AnswerStatus.UNKNOWN],
                                status: AnswerStatus.UNKNOWN
                            });
                            if (!vm.isSurveyLoad) {
                                vm.isSurveyLoad = true;
                            }
                            vm.hook.run('answerOver');
                        }
                        return;
                    }
                }
                if (!vm.isSurveyLoad) {
                    vm.isSurveyLoad = true;
                }
                vm.loading = false;
                vm.answerId = res.data.id;
                vm.isStart = true;
                vm.verificationCheck = false; // 重置回去 方便以后其他验证
                if (res.data.isFinished) {
                    vm.isEnd = true;
                    this.removeCache();
                    this.transformEndPage(res.data);
                    return;
                }
                vm.hook.run('answerStart');
                this.initAnswerTimer(res.data.surveyStartTime, res.data.currentSystemTime || Date.now());
                preDuration = Date.now();
            },
            onVerificationSuccess() {
                let vm = this;
                vm.verificationCheck = true;
                vm.showVerification = false;
                this.onStart();
            },
            onVerificationClose() {
                let vm = this;
                vm.showVerification = false;
            },
            getAnswerContent() {
                const vm = this;
                let promises = [];
                let answerList = [];
                for (let i = 0, len = vm.pageList.length; i < len; i++) {
                    let q = vm.pageList[i];
                    let content = q.getAnswerContent('submit');
                    if (content.items instanceof Promise) {
                        promises.push(content.items.then((res) => {
                            content.items = [res];
                        }));
                    }
                    answerList.push(content);
                }
                if (promises.length) {
                    return Promise.all(promises).then(() => {
                        return answerList;
                    });
                }
                else {
                    return Promise.resolve(answerList);
                }
            },
            checkAnswerContent(answerContent = []) {
                const vm = this;
                vm.pageList.forEach(q => {
                    if (q.issue.ignoreItems) {
                        q.issue.ignoreItems = [];
                    }
                });
                return new Promise((resolve, reject) => {
                    if (!answerContent.length) {
                        return resolve(null);
                    }
                    loopList(answerContent, (content, d) => {
                        var _a, _b;
                        const q_id = content.questonId;
                        const q = vm.pageList.find(q => q.id === q_id);
                        const checkResult = q.checkAnswer(content, {
                            browserInfo: vm.currentBrowserInfo,
                            enableQuestionIndex: vm.enableQuestionIndex
                        });
                        if (!checkResult.success) {
                            const confirmInfo = q.issue.getValueConfirm ? checkResult.item ? q.issue.getValueConfirm(checkResult.item) : null : null;
                            if (!confirmInfo) {
                                return resolve(Object.assign({ question: q }, checkResult));
                            }
                            else {
                                vm.busOption.scroll.scrollToQuestion(q);
                                vm.busOption.confirm(confirmInfo.message, {
                                    confirm() {
                                        if (checkResult.item) {
                                            q.issue.ignoreItems.push(checkResult.item);
                                            d(false);
                                        }
                                        else {
                                            d();
                                        }
                                        q.runHooks('confirm', true);
                                    },
                                    close() {
                                        vm.busOption.scroll.scrollToQuestion(q);
                                        q.runHooks('confirm', false);
                                    }
                                });
                                return;
                            }
                        }
                        if (q.issue.complexValidateEnable && q.issue.complexValidate.length) {
                            const res = (_b = (_a = q.issue).runComplexValidate) === null || _b === void 0 ? void 0 : _b.call(_a, mergeAnswerContent(vm.answerContent || [], answerContent), content);
                            if (!res.success) {
                                return resolve(Object.assign({ question: q }, res));
                            }
                        }
                        d();
                    }, () => {
                        resolve(null);
                    });
                });
            },
            submitOrNextPage() {
                const vm = this;
                if (vm.loading)
                    return;
                console.log("提交答案----submitOrNextPage");
                // 答题时长超时字段 overallOvertime
                // 强制提交字段 forceSubmit
                let overallOvertime = vm.overallOvertime || false;
                let forceSubmit = vm.forceSubmit || overallOvertime;
                this.getAnswerContent().then((list) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    const result = yield this.checkAnswerContent(list);
                    if (!overallOvertime && !forceSubmit) {
                        if (result && !result.success) {
                            (_a = result.question) === null || _a === void 0 ? void 0 : _a.runHooks('submitError');
                            if (result.message) {
                                option.message(MessageType.WARNING, result.message, this);
                                if (vm.params.answerType !== 'investigatorAdd') {
                                    (_b = option.scroll) === null || _b === void 0 ? void 0 : _b.scrollToQuestion(result.question);
                                }
                            }
                            return;
                        }
                    }
                    if (!vm.forceSubmit) {
                        if (vm.showAnswerScoreInAnswering) {
                            if (vm.currentPageHasScore) {
                                if (!vm.showPreview) {
                                    vm.showPreview = true;
                                    return;
                                }
                                else {
                                    vm.showPreview = false;
                                }
                            }
                        }
                    }
                    this.openLoading();
                    vm.overallOvertime = vm.forceSubmit = false;
                    queue.use(() => {
                        return this.onSubmitAnswer(list, forceSubmit, overallOvertime);
                    });
                    queue.run();
                }));
                // let promises: Promise<any>[] = []
                // let answerList: any = []
                // let error: { success: boolean; message: string } | null = null
                // let errorQuestion: any = null
                // for (let i = 0, len = vm.pageList.length; i < len; i++) {
                //   let q = vm.pageList[i]
                //   let content = q.getAnswerContent('submit')
                //   if (content.items instanceof Promise) {
                //     promises.push(
                //       content.items.then((res: any) => {
                //         content.items = [res]
                //       })
                //     )
                //   }
                //   answerList.push(content)
                //   let flag = q.checkAnswer(content, {
                //     browserInfo: vm.currentBrowserInfo,
                //     enableQuestionIndex: vm.enableQuestionIndex
                //   })
                //   if (!flag.success) {
                //     error = flag
                //     errorQuestion = q
                //     break
                //   } else {
                //     q.runHooks('submitSuccess')
                //   }
                // }
                // if (!overallOvertime && !forceSubmit) {
                //   if (error && !error.success) {
                //     // this.closeLoading()
                //     errorQuestion?.runHooks('submitError')
                //     if (error.message) {
                //       option.message(MessageType.WARNING, error.message, this)
                //       if (vm.params.answerType !== 'investigatorAdd') {
                //         option.scroll?.scrollToQuestion(errorQuestion)
                //       }
                //     }
                //     return
                //   }
                // }
                // if (!vm.forceSubmit) {
                //   if (vm.showAnswerScoreInAnswering) {
                //     if (vm.currentPageHasScore) {
                //       if (!vm.showPreview) {
                //         vm.showPreview = true
                //         return
                //       } else {
                //         vm.showPreview = false
                //       }
                //     }
                //   }
                // }
                // this.openLoading()
                // vm.overallOvertime = vm.forceSubmit = false
                // if (promises.length) {
                //   Promise.all(promises).then(res => {
                //     this.onSubmitAnswer(answerList, forceSubmit, overallOvertime)
                //   })
                // } else {
                //   this.onSubmitAnswer(answerList, forceSubmit, overallOvertime)
                // }
            },
            showPrevPage() {
                const vm = this;
                if (vm.showAnswerScoreInAnswering) {
                    vm.showPreview = true;
                }
                if (!vm.params.disableClearAnswer) {
                    vm.cacheAnswerContent = vm.cacheAnswerContent.filter(item => {
                        return !vm.pageList.find(q => q.id === item.questonId);
                    });
                    if (vm.answerDB) {
                        vm.answerDB.update(vm.answerId, vm.cacheAnswerContent);
                    }
                }
                vm.currentPageNum--;
                this.openLoading();
                this.onSubmitAnswer(null, false, false, true);
            },
            onOnlySave() {
                const vm = this;
                if (vm.loading)
                    return;
                this.getAnswerContent().then(list => {
                    queue.use(() => {
                        return this.onSubmitAnswer(list, false, false, false, true);
                    });
                    queue.run();
                });
                // let promises: Promise<any>[] = []
                // let answerList: any = []
                // for (let i = 0, len = vm.pageList.length; i < len; i++) {
                //   let q = vm.pageList[i]
                //   let content = q.getAnswerContent('submit')
                //   if (content.items instanceof Promise) {
                //     promises.push(
                //       content.items.then((res: any) => {
                //         content.items = [res]
                //       })
                //     )
                //   }
                //   answerList.push(content)
                // }
                // if (promises.length) {
                //   Promise.all(promises).then(res => {
                //     this.onSubmitAnswer(answerList, false, false, false, true)
                //   })
                // } else {
                //   this.onSubmitAnswer(answerList, false, false, false, true)
                // }
            },
            onSubmitAnswer(data, forceSubmit, overallOvertime, isPrev = false, onlySave = false) {
                const vm = this;
                const answerContent = data;
                return submitAnswer(vm.answerId, answerContent, vm.currentPageNum, forceSubmit, overallOvertime, onlySave)
                    .then((res) => {
                    try {
                        if (res.code !== 0) {
                            switch (res.code) {
                                case SubmitErrorCode.ERROR:
                                    this.setOverData({
                                        status: AnswerStatus.UNKNOWN,
                                        success: false
                                    });
                                    break;
                                case SubmitErrorCode.SURVEY_ERROR:
                                    this.setOverData({
                                        status: AnswerStatus.SURVEY_ERROR,
                                        success: false
                                    });
                                    break;
                                case SubmitErrorCode.SURVEY_DELETE:
                                    this.setOverData({
                                        status: AnswerStatus.SURVEY_DELETE,
                                        success: false
                                    });
                                    break;
                                default:
                                    break;
                            }
                            {
                                // TODO 待优化
                                vm.isEnd = true;
                                vm.hook.run('answerOver');
                                this.closeLoading();
                                clearInterval(vm.overallOvertimer);
                                clearInterval(vm.maxPageTimer);
                            }
                            return;
                        }
                        if (onlySave) {
                            return;
                        }
                        const data = res.data;
                        const status = data.status;
                        if (status === AnswerStatus.AGAIN) {
                            option.message(MessageType.ERROR, '已开启智能质控，请认真答题。');
                            submitAnswer(vm.answerId, null).then(res => {
                                var _a;
                                (_a = vm.answerDB) === null || _a === void 0 ? void 0 : _a.remove(vm.answerId, () => {
                                    vm.cacheAnswerContent = [];
                                    const answerContent = res.data.answerContent || [];
                                    if (!answerContent.length && vm.showPreview) {
                                        vm.showPreview = false;
                                    }
                                    this.transformNextPage(res.data);
                                    this.closeLoading();
                                });
                            });
                            return;
                        }
                        else if (!data.isFinished) {
                            const answerContent = res.data.answerContent || [];
                            if (!answerContent.length && vm.showPreview) {
                                vm.showPreview = false;
                            }
                            this.transformNextPage(res.data, isPrev);
                            this.closeLoading();
                            return;
                        }
                        if (vm.overallOvertimer) {
                            clearInterval(vm.overallOvertimer);
                        }
                        this.removeCache();
                        this.transformEndPage(data, true, answerContent);
                    }
                    catch (e) {
                        // @ts-ignore
                        return Promise.reject({ res, err: e.message });
                    }
                })
                    .catch(res => {
                    this.closeLoading();
                    this.saveErrorLog("提交答案错误", JSON.stringify(res));
                    console.log(res);
                });
            },
            saveErrorLog(title, info) {
                const vm = this;
                addErrorLog({
                    surveyId: vm.survey.id,
                    answerId: vm.answerId,
                    accountUserFingerprint: vm.accountUserFingerprint,
                    accountUserId: vm.params.accountUserId,
                    answerUrl: window.location.href,
                    errTitle: title,
                    // @ts-ignore
                    errInfo: info
                });
            },
            transformNextPage(data, isPrev = false) {
                var _a;
                if (data.isFinished) {
                    this.removeCache();
                    return this.transformEndPage(data);
                }
                const vm = this;
                vm.currentCount = data.answeredCount;
                vm.totalCount = data.totalCount;
                vm.isLastPage = data.isLastPage;
                vm.isSoftPage = data.isSoftPage;
                vm.currentPageNum = data.currentPageNum;
                vm.answerContent = data.answerContent;
                this.removeCurrentListHook();
                if (vm.survey.otherSetting.enablePagePerQuestion) {
                    let pagePerMinTime = 0;
                    let pagePerMaxTime = 0;
                    if (vm.survey.otherSetting.enablePagePerMinTime) {
                        pagePerMinTime = vm.survey.otherSetting.pagePerMinTime;
                    }
                    if (vm.survey.otherSetting.enablePagePerMaxTime) {
                        pagePerMaxTime = vm.survey.otherSetting.pagePerMaxTime;
                    }
                    this.initPageAnswerTimer({
                        isSoftPage: false,
                        minPageAnswerTime: pagePerMinTime,
                        maxPageAnswerTime: pagePerMaxTime
                    });
                }
                else {
                    this.initPageAnswerTimer(data);
                }
                // console.log(data.partialHideMap)
                if (data.answerContent && data.answerContent.length) {
                    if (vm.showAnswerScoreInAnswering) {
                        if (vm.currentPageHasScore) {
                            vm.showPreview = true;
                        }
                    }
                }
                try {
                    if (!data || !data.nextPage.length) {
                        this.saveErrorLog("未返回题目信息", JSON.stringify({ res: data }));
                        vm.closeLoading();
                        this.submitOrNextPage();
                        return;
                    }
                    // vm.currentPageCacheContent = vm.cacheAnswerContent || []
                    // mergeAnswerContent(
                    //   (vm.cacheAnswerContent || []).filter(item=>item.questionType!==questionType.MAX_DIFF),
                    //   data.answerContent || []
                    // )
                    vm.pageList = convertQuestionList(data.nextPage.map((q) => {
                        getCurrentAnswerHide(q, data.partialHideMap);
                        initQuotaCount(q, data.quotaRemainderNumMap || {});
                        initAutoFill(q);
                        return q;
                    }), data.answeredCount + 1, mergeAnswerContent((vm.cacheAnswerContent || []).filter(item => item.questionType !== questionType.MAX_DIFF), data.answerContent || []), {
                        autoFill: (target, rule) => {
                            return valueByCalc(target, rule, () => {
                                return mergeAnswerContent((vm.cacheAnswerContent || []).filter(item => item.questionType !== questionType.MAX_DIFF), data.answerContent || []);
                            }, Vue);
                        }
                    }).map(q => {
                        if (isPrev) {
                            q.setHook('created', () => {
                                q.convertPrevData();
                            });
                        }
                        q.setHook('updated', (type) => {
                            if (type && type === 'file') {
                                return;
                            }
                            if (q.duration === 0) {
                                let currentDate = Date.now();
                                q.duration = currentDate - preDuration;
                                preDuration = currentDate;
                            }
                            if (!q.showVote) {
                                q.showVote = true;
                            }
                            console.log('updated');
                        });
                        if (q.setting.enableVoteNum) {
                            const votes = data.voteCounts || [];
                            let vote = votes.find((vote) => vote.questionId === q.id);
                            if (vote) {
                                q.setVote(vote);
                            }
                        }
                        if (vm.survey.otherSetting.uploadFileMaxSize) {
                            q.uploadFileMaxSize = vm.survey.otherSetting.uploadFileMaxSize;
                        }
                        return q;
                    });
                    initAutoFillWatcher(vm.pageList, data.answerContent, vm.cacheAnswerContent);
                    initAutoValidate(vm.pageList, data.answerContent, vm.cacheAnswerContent);
                    if (vm.params.updateAndSave) {
                        vm.pageList.forEach(q => {
                            let timer = null;
                            q.setHook('updated', () => {
                                if (timer != null) {
                                    clearTimeout(timer);
                                }
                                timer = setTimeout(() => {
                                    this.onOnlySave();
                                    timer = null;
                                });
                            });
                        });
                    }
                }
                catch (e) {
                    addErrorLog({
                        surveyId: vm.survey.id,
                        answerId: vm.answerId,
                        accountUserFingerprint: vm.accountUserFingerprint,
                        accountUserId: vm.params.accountUserId,
                        answerUrl: window.location.href,
                        errTitle: '问题解析失败',
                        // @ts-ignore
                        errInfo: `${JSON.stringify({ err: e.message, res: data })} `
                    });
                }
                (_a = option.scroll) === null || _a === void 0 ? void 0 : _a.scrollTo(0);
            },
            /**
             *
             * @param data
             * @param isNormalEnd 是否正常结束进入此方法
             * @param answerContent 答题结束时提交的答案（没啥用 就是存一下）
             */
            transformEndPage(data, isNormalEnd = false, answerContent) {
                let vm = this;
                const status = data.status;
                const isOk = status === AnswerStatus.OK || status === AnswerStatus.PASS;
                if (!this.jumpToEndUrl(isOk))
                    return;
                this.removeCurrentListHook();
                vm.pageList = [];
                this.closeLoading();
                vm.hook.run('beforeAnswerOver', data, isNormalEnd);
                vm.$nextTick(() => {
                    var _a;
                    vm.currentAnswerData = data;
                    let overData;
                    if (data.isDuplicateAnswer) {
                        overData = {
                            success: false,
                            overText: textMap[AnswerStatus.REPEAT],
                            status: AnswerStatus.REPEAT
                        };
                    }
                    else {
                        overData = {
                            success: isOk,
                            overText: textMap[status] || [],
                            hasReward: data.hasReward,
                            awardYuanAmount: data.awardYuanAmount,
                            allowAwardWithoutFollow: data.allowAwardWithoutFollow,
                            answerCertificate: data.answerCertificate || ((_a = vm.overData) === null || _a === void 0 ? void 0 : _a.answerCertificate),
                            score: data.score,
                            status
                        };
                    }
                    vm.hasHistory = !!data.hasHistory;
                    vm.overData = overData;
                    vm.isEnd = true;
                    if (vm.survey.otherSetting.enabledUserStory) {
                        vm.closeLoading();
                        vm.openLoading("调研ai正在努力为您生成故事…");
                        getUserStoryByAnswerId(vm.answerId, vm.isChangeUserStory).then(res => {
                            const users = (res.data.wxMessageVos || []).map((item) => {
                                return {
                                    weixinNickName: item.weixinNickName,
                                    answerContent: item.content,
                                    answerId: item.answerId,
                                    weixinHeadimgurl: item.photo
                                };
                            });
                            if (vm.closing) {
                                const list = vm.closing.funAnswerEnds || [];
                                if (res.data.story) {
                                    data.score = 50;
                                    list.forEach(item => {
                                        item.posterContent = res.data.story;
                                        item.users = users;
                                        item.posterContentInfo = {
                                            x: 25,
                                            y: 200,
                                            horizontal: 220,
                                            vertical: 240
                                        };
                                        item.usersInfo = {
                                            x: 10,
                                            y: 455,
                                            horizontal: 250,
                                            vertical: 170
                                        };
                                        item.nextAnswerId = res.data.answerId;
                                    });
                                    setTimeout(() => {
                                        vm.hook.run('resetShare', {
                                            desc: `一起脑洞大开，玩转三重奖励~`
                                        });
                                    }, 20);
                                }
                                else {
                                    list.forEach(item => {
                                        item.users = users;
                                        item.usersInfo = {
                                            x: 10,
                                            y: 170,
                                            horizontal: 250,
                                            vertical: 170
                                        };
                                        item.nextAnswerId = res.data.answerId;
                                        item.posterContent = '';
                                        item.posterContentInfo = null;
                                    });
                                    setTimeout(() => {
                                        vm.hook.run('resetShare', {
                                            desc: `我的故事元素：${users[0].answerContent}，请输入你的`
                                        });
                                    }, 20);
                                }
                            }
                            vm.scoreEnd = null;
                            vm.$nextTick(() => {
                                vm.closeLoading();
                                vm.hook.run('answerOver', data, isNormalEnd);
                            });
                        }).catch(() => {
                            vm.closeLoading();
                            vm.hook.run('answerOver', data, isNormalEnd);
                        });
                    }
                    else if (vm.survey.otherSetting.enabledChatGPT) {
                        vm.closeLoading();
                        vm.openLoading("调研ai正在努力为您撰写祝福语…");
                        getAnswerChatGPT(vm.answerId).then((res) => {
                            if (vm.closing) {
                                let result = res.data;
                                if (/\^https/.test(result)) {
                                    result = `<img src="${result}">`;
                                }
                                result = result.replaceAll("\n\n", "\n");
                                result = result.replaceAll('\n', '<br/>');
                                const list = vm.closing.funAnswerEnds || [];
                                list.forEach(item => {
                                    item.posterContent = result;
                                    item.posterContentInfo = {
                                        x: 55,
                                        y: 155,
                                        horizontal: 170,
                                        vertical: 170
                                    };
                                });
                            }
                            vm.closeLoading();
                            vm.hook.run('answerOver', data, isNormalEnd);
                        }).catch(() => {
                            vm.closeLoading();
                            vm.hook.run('answerOver', data, isNormalEnd);
                        });
                    }
                    else {
                        vm.hook.run('answerOver', data, isNormalEnd, answerContent);
                    }
                });
                clearInterval(vm.overallOvertimer);
                clearInterval(vm.maxPageTimer);
            },
            jumpToEndUrl(status = true) {
                var _a, _b, _c, _d;
                let vm = this;
                if (vm.survey.otherSetting.enableWebpageJump && ((_b = (_a = vm.closing) === null || _a === void 0 ? void 0 : _a.normalEnd) === null || _b === void 0 ? void 0 : _b.jumpUrl) && status) {
                    let reg = /^http[s]{0,1}:\/\/([\w.]+\/?)\S*/i;
                    let url = (_d = (_c = vm.closing) === null || _c === void 0 ? void 0 : _c.normalEnd) === null || _d === void 0 ? void 0 : _d.jumpUrl;
                    if (!reg.test(url))
                        url = 'https://' + url;
                    location.href = url;
                    return false;
                }
                return true;
            },
            removeCurrentListHook() {
                const vm = this;
                for (const q of vm.pageList) {
                    q.clearHook();
                }
            },
            removeCache(answerId, surveyId) {
                const vm = this;
                vm.cacheAnswerContent = [];
                const surveyAnswerDB = new DB('finger_survey');
                const answerDB = new DB('answer');
                openIDB(surveyAnswerDB).then(() => {
                    surveyAnswerDB.remove(surveyId || vm.survey.id);
                    surveyAnswerDB.clearExpireByTime();
                });
                openIDB(answerDB).then(() => {
                    answerDB.remove(answerId || vm.answerId);
                    answerDB.clearExpireByTime();
                });
            },
            convertAwardAmountText(data) {
                let randomRedEnvelope = !!data.randomRedEnvelope;
                if (!randomRedEnvelope)
                    return data.amount + '元';
                let min = data.rdMin;
                let max = data.rdMax;
                let text;
                if (max && min) {
                    text = `${min}~${max}元`;
                }
                else if (max) {
                    text = `${max}元及以下`;
                }
                else if (min) {
                    text = `${min}元及以上`;
                }
                else {
                    text = '随机金额';
                }
                return text;
            },
            convertTimeByStartTime(startTime, currentSystemTime, time) {
                if (!time)
                    return 0;
                const maxTime = 60 * 60 * 24 * 365;
                if (!startTime) {
                    if (time > maxTime)
                        return 0;
                    return time;
                }
                let d = new Date(startTime);
                let n = new Date(currentSystemTime);
                time = time - (((n.getTime() - d.getTime()) / 1000) | 0);
                if (time > maxTime)
                    return 0;
                return time;
            },
            initMinAnswerTimer(time) {
                let vm = this;
                vm.minAnswerTime = Math.min(time, vm.minAnswerTime);
                if (!time)
                    return;
                if (time <= 0) {
                    return;
                }
                vm.submitBtnDisabled = true;
                vm.minAnswerTimer = setInterval(() => {
                    if (--vm.minAnswerTime <= 0) {
                        vm.submitBtnDisabled = false;
                        clearInterval(vm.minAnswerTimer);
                    }
                }, 1000);
            },
            initMaxAnswerTimer(time) {
                let vm = this;
                vm.maxAnswerTime = Math.min(time, vm.maxAnswerTime);
                if (!time)
                    return;
                if (time <= 0) {
                    vm.overallOvertime = true;
                    this.submitOrNextPage();
                    return;
                }
                vm.overallOvertimer = setInterval(() => {
                    if (--vm.maxAnswerTime <= 0) {
                        // clearInterval(this.runMaxTime)
                        // clearInterval(this.runMinTime)
                        vm.overallOvertime = true;
                        this.submitOrNextPage();
                        clearInterval(vm.overallOvertimer);
                    }
                }, 1000);
                console.log(time);
            },
            initAnswerTimer(surveyStartTime, currentSystemTime) {
                let vm = this;
                this.initMaxAnswerTimer(this.convertTimeByStartTime(surveyStartTime, currentSystemTime, vm.maxAnswerTime));
                this.initMinAnswerTimer(this.convertTimeByStartTime(surveyStartTime, currentSystemTime, vm.minAnswerTime));
            },
            initPageAnswerTimer(data) {
                const vm = this;
                if (data.isSoftPage) {
                    vm.isSofgPageStart = true;
                }
                else {
                    if (vm.isSofgPageStart) {
                        vm.isSofgPageStart = false;
                        if (vm.minPageAnswerTime > 0) {
                            vm.nextPageBtnDisabled = true;
                        }
                        return;
                    }
                    vm.isSofgPageStart = false;
                }
                vm.minPageAnswerTime = Number(data.minPageAnswerTime);
                vm.maxPageAnswerTime = Number(data.maxPageAnswerTime);
                clearInterval(vm.minPageTimer);
                if (vm.minPageAnswerTime > 0) {
                    if (!vm.isSofgPageStart) {
                        vm.nextPageBtnDisabled = true;
                    }
                    vm.minPageTimer = setInterval(() => {
                        vm.minPageAnswerTime--;
                        if (vm.minPageAnswerTime <= 0) {
                            vm.nextPageBtnDisabled = false;
                            clearInterval(vm.minPageTimer);
                            vm.minPageTimer = null;
                        }
                    }, 1000);
                }
                clearInterval(vm.maxPageTimer);
                if (vm.maxPageAnswerTime > 0) {
                    vm.maxPageTimer = setInterval(() => {
                        vm.maxPageAnswerTime--;
                        if (vm.maxPageAnswerTime <= 0) {
                            vm.forceSubmit = true;
                            this.submitOrNextPage();
                            clearInterval(vm.maxPageTimer);
                            vm.maxPageTimer = null;
                        }
                    }, 1000);
                }
            },
            checkAnswer() {
                const vm = this;
                if (vm.params.isTest)
                    return;
                checkAnswer(filterParams({
                    surveyId: vm.params.surveyId,
                    id: vm.params.answerId,
                    accountUserFingerprint: vm.accountUserFingerprint,
                    accountUserId: vm.params.accountUserId,
                    answerUrl: window.location.href.split('#')[0],
                    accountUserOpenId: vm.params.accountUserOpenId
                }))
                    .then(res => {
                    var _a, _b;
                    let data = res;
                    const { code } = data;
                    if (code === 0) {
                        return;
                    }
                    else if (code === 3) {
                        vm.isAnswering = true;
                        // vm.isOpenReward = true
                        if (!vm.isSurveyLoad) {
                            vm.isSurveyLoad = true;
                        }
                        // vm.canAnswerAgain = false
                        this.closeLoading();
                        vm.isEnd = true;
                        this.setOverData({
                            success: false,
                            overText: textMap[AnswerStatus.IP_REPEAT],
                            status: AnswerStatus.IP_REPEAT
                        });
                        vm.hook.run('answerOver');
                        return;
                    }
                    else if (code === ErrorCode.FansNormal) {
                        (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
                            code: ErrorCode.FansNormal,
                            message: '只允许在微信中作答，分享链接到微信中打开'
                        });
                        return;
                    }
                    else if (code === ErrorCode.FansQr) {
                        (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, {
                            code: ErrorCode.FansQr,
                            message: vm.currentBrowserInfo.isWeixin ? '只有公众号粉丝可作答' : '只允许在微信中作答，分享链接到微信中打开',
                            data: data.data
                        });
                        return;
                    }
                    if (data.data) {
                        vm.isAnswering = true;
                        vm.answerId = res.data;
                        // vm.isOpenReward = true
                        this.getAnswerRes();
                    }
                    // vm.isEnd = true
                    // vm.overData = {
                    //   success: true,
                    //   overText: textMap[AnswerStatus.ERR1],
                    //   status: AnswerStatus.ERR1
                    // }
                })
                    .catch(err => {
                    if (err.message) ;
                });
            },
            initHook() {
                const vm = this;
                vm.hook.on('surveyLoad', surveyLoad(vm));
                vm.hook.on('answerStart', answerStart(vm));
                vm.hook.on('answerOver', answerOver(vm));
                vm.hook.on('beforeAnswerOver', beforeAnswerOver(vm));
            },
            openLoading(text = "loading") {
                const vm = this;
                if (vm.loading)
                    return;
                const load = option.loading(text);
                vm.loading = true;
                closeLoading = () => {
                    load.close();
                    vm.loading = false;
                    closeLoading = null;
                };
            },
            closeLoading() {
                if (closeLoading) {
                    closeLoading();
                }
            },
            getUrl(pageType) {
                const vm = this;
                /**
                 * pageType 1(分享) 2(领奖) 3(积分)
                 */
                const origin = window.location.origin;
                const params = vm.params;
                const survey = vm.survey;
                const answerId = vm.answerId;
                if (!survey || !answerId)
                    return;
                const answerChannelId = vm.channel.id;
                const url = `${origin}/mobile?surveyId=${survey.id}&answerId=${answerId}&answerChannelId=${answerChannelId}${params.companyid ? '&companyid=' + params.companyid : ''}&pageType=${pageType}&share=1&shareAnswerId=${answerId}&t=${Date.now()}`;
                return `${origin}/transfer?redirect_type=answer&redirect_url=${encodeURIComponent(url)}&pageType=${pageType}`;
            },
            receiveAward(data) {
                const vm = this;
                this.openLoading();
                let params = Object.assign(Object.assign({}, data), { accountUserId: vm.params.accountUserId, answerId: vm.answerId, id: vm.currentAwardData.bindAward.id });
                receiveAward(filterParams(params)).then((r) => {
                    if (r.code !== 0) {
                        return Promise.reject({ message: r.msg });
                    }
                    if (r.data.boundFailedType === BoundFailedType.OTHER_EXCESS) {
                        return Promise.reject({ message: "同一手机号码只允许领奖一次" });
                    }
                    // vm.isReceive = true
                    // vm.receiveInfo = data
                    vm.currentAwardData.bindAward = r.data;
                    // vm.busOption.message(MessageType.WARNING,"很遗憾，您没有在15分钟内领取奖品，奖品已失效。")
                    // vm.busOption.message(MessageType.WARNING,"此手机号码已经中过奖，无法重复使用!")
                }).catch(err => {
                    vm.busOption.message(MessageType.ERROR, err.message);
                }).finally(() => {
                    this.closeLoading();
                });
            },
            drawRewards() {
                const vm = this;
                return new Promise((resolve, reject) => {
                    answerGetAward(vm.answerId).then(res => {
                        if (res.data.boundFailedType === BoundFailedType.OVERTIME) {
                            vm.currentAwardData.hasReward = false;
                            return Promise.reject({ message: "很遗憾，您没有在15分钟内领取奖品，奖品已失效。" });
                        }
                        else {
                            resolve(res);
                        }
                    }).catch((err) => {
                        vm.busOption.message(MessageType.ERROR, err.message);
                        reject(err);
                    });
                });
            },
        },
        created() {
            const vm = this;
            vm.busOption = option;
            H5PlatformInit(() => {
                vm.platformSdkFinished = true;
                vm.hook.run('platformSdkLoad');
                //通过模板创建问卷(微信小程序)使用 uni
                loadScript(`${window.origin}/assets/js/uni.webview.js`).then(() => { });
            });
            // if (!vm.params.accountUserId) {
            // const userInfo = getStore({ name: 'ENTRANCE_USER_INFO' })
            // if (userInfo) {
            //   vm.params.accountUserId = userInfo.baseId
            // }
            // }
        }
    }));
    initAnswerUtil(Vue, bus);
    Vue.config.errorHandler = function (err, vm, info) {
        var _a;
        addErrorLog({
            surveyId: bus.survey.id,
            answerId: bus.answerId,
            accountUserFingerprint: bus.accountUserFingerprint,
            accountUserId: bus.params.accountUserId,
            answerUrl: window.location.href,
            errTitle: '未捕获错误',
            // @ts-ignore
            errInfo: `${(_a = vm === null || vm === void 0 ? void 0 : vm.$options) === null || _a === void 0 ? void 0 : _a.name}-${info || ''}-${err.message} `
        });
    };
}
function busGetters(args = []) {
    const res = {};
    args.forEach(key => {
        res[key] = function (vm) {
            return vm.$bus[key];
        };
    });
    return res;
}

function convertLocation(longitude, latitude) {
    return new Promise((resolve, reject) => {
        transFormPoint(longitude, latitude).then((res) => {
            let point = res;
            if (String(res.status) === '0') {
                return resolve({
                    lng: longitude,
                    lat: latitude,
                    address: '定位失败-坐标转换失败',
                    adds: '定位失败-坐标转换失败',
                    IS_OK: false,
                    convertError: res.info,
                    convertErrorCode: res.infocode
                });
            }
            getGeocode(point.locations).then((res) => {
                if (String(res.status) === '0') {
                    return resolve({
                        lng: longitude,
                        lat: latitude,
                        address: '定位失败-坐标转换失败',
                        adds: '定位失败-坐标转换失败',
                        IS_OK: false,
                        convertError: res.info,
                        convertErrorCode: res.infocode
                    });
                }
                let [lng, lat] = point.locations.split(',');
                let formattedAddress = res.regeocode.formatted_address;
                let address = Array.isArray(formattedAddress) ? '' : formattedAddress;
                let { country, province, district, city } = res.regeocode.addressComponent;
                let arr;
                if (city.toString().trim()) {
                    arr = [country, province, city, district];
                }
                else {
                    arr = [country, province, district];
                }
                let currentPoint = { adds: arr.join(';'), address, lng, lat, IS_OK: true };
                resolve(currentPoint);
            });
        });
    });
}
function defaultBrowser() {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            return reject({
                message: '未支持接口',
                err: {}
            });
        }
        navigator.geolocation.getCurrentPosition(function success(position) {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;
            convertLocation(longitude, latitude).then(resolve, reject);
        }, err => {
            console.log(err);
            let message = '';
            let userRefuse = false;
            if (err.code === 1) {
                message = '无权限';
                userRefuse = true;
            }
            else if (err.code === 3) {
                message = '获取位置超时';
            }
            else {
                message = '接口异常';
            }
            reject({
                message,
                userRefuse,
                err
            });
        }, {
            maximumAge: 10 * 1000,
            timeout: 60 * 1000,
            enableHighAccuracy: false
        });
    });
}
function getAddress(browserInfo) {
    return new Promise((resolve, reject) => {
        let platformSdk = getPlatformSdk();
        if (platformSdk) {
            platformSdk
                .getLocation()
                .then(res => {
                convertLocation(res.lng, res.lat).then(resolve, reject);
            })
                .catch(reject);
        }
        else {
            defaultBrowser().then(resolve, reject);
        }
    });
}

const componentMap = new Map();
singleTypes.forEach(type => {
    componentMap.set(type, 'SingleChoice');
});
textTypes.forEach(t => {
    componentMap.set(t, 'TextFill');
});
componentMap.set(questionType.ONLY_TEXT, '');
componentMap.set(questionType.SINGLE_CHOICE, 'SingleChoice');
componentMap.set(questionType.MULTIPLE_CHOICE, 'MultipleChoice');
componentMap.set(questionType.SINGLE_SELECT, 'SingleSelectChoice');
componentMap.set(questionType.MULTIPLE_SELECT, 'MultipleSelectChoice');
componentMap.set(questionType.LINKAGE, 'Cascader');
componentMap.set(questionType.MATRIX_SINGLE_CHOICE, 'MatrixSingleChoice');
componentMap.set(questionType.MATRIX_MULTIPLE_CHOICE, 'MatrixMultipleChoice');
componentMap.set(questionType.MATRIX_SELECT_CHOICE, 'MatrixSelectChoice');
componentMap.set(questionType.BLANKS, 'Blanks');
componentMap.set(questionType.SINGLE_TEXT_FILL, 'TextFill');
componentMap.set(questionType.MULTIPLE_TEXT_FILL, 'TextFill');
componentMap.set(questionType.SCALE, 'Scale');
componentMap.set(questionType.NPS_SCALE, 'NPSScale');
componentMap.set(questionType.CUSTOM_SINGLE_SCALE, 'CustomSingleScale');
componentMap.set(questionType.MATRIX_AUTO, 'MatrixAuto');
componentMap.set(questionType.MATRIX_COMPOSE, 'MatrixCompose');
componentMap.set(questionType.MATRIX_GRAVITY, 'MatrixGravity');
componentMap.set(questionType.MATRIX_SCROLL, 'MatrixScroll');
componentMap.set(questionType.MULTIPLE_BLANKS, 'MultipleBlanks');
componentMap.set(questionType.IMAGE_CHOICE, 'SingleImageChoice');
componentMap.set(questionType.IMAGE_MULTIPLE_CHOICE, 'MultipleImageChoice');
componentMap.set(questionType.MATRIX_FILL, 'MatrixFill');
componentMap.set(questionType.DATE, 'DateQ');
componentMap.set(questionType.DATE_OF_BIRTH, 'DateQ');
componentMap.set(questionType.UPLOAD_FILE, 'UploadFile');
componentMap.set(questionType.HANDWRITING, 'HandWriting');
componentMap.set(questionType.CITY_ADDRESS, 'CityAddress');
componentMap.set(questionType.PERMANENT_ADDRESS, 'CityAddress');
componentMap.set(questionType.DOMICILE, 'CityAddress');
componentMap.set(questionType.SPECIALITY, 'Cascader');
componentMap.set(questionType.SCHOOL, 'Cascader');
componentMap.set(questionType.MAP, 'MapQ');
componentMap.set(questionType.DOWNLOADABLE, 'Downloadable');
componentMap.set(questionType.PHONE_VALIDATE, 'TextFill');
componentMap.set(questionType.CASCADE_REGION, 'CascadeRegion');
componentMap.set(questionType.IMAGE_CHOICE, 'ImageChoice');
componentMap.set(questionType.CLASSIFICATION, 'Classification');
componentMap.set(questionType.SORT, 'Sort');
componentMap.set(questionType.MATRIX_SCALE, 'MatrixScale');
componentMap.set(questionType.CUSTOM_MULTIPLE_SCALE, 'MatrixScale');
componentMap.set(questionType.TOTAL, 'Total');
componentMap.set(questionType.MAX_DIFF, 'MaxDiff');

function answerMixin(option = {}) {
    const changeExpr = option.changeExpr;
    const changeDelay = option.changeDelay;
    return {
        props: {
            question: {
                type: Object,
                default: () => ({})
            },
            nested: {
                // 有可能是表格嵌套的组件
                type: Boolean,
                default: false
            },
            view: {
                // 是否是预览
                type: Boolean,
                default: false
            }
        },
        computed: {
            issue() {
                let vm = this;
                return vm.question.issue;
            },
            showVoteProgress() {
                let vm = this;
                if (vm.nested)
                    return false;
                const setting = vm.question.setting || {};
                if (!setting.enableVoteNum)
                    return false;
                return vm.question.showVote;
            },
        },
        created() {
            if (!changeExpr)
                return;
            let vm = this;
            if (vm.nested)
                return;
            if (!changeDelay) {
                if (vm.question.disabledProgress) {
                    return;
                }
                vm.initProgressWatcher();
            }
        },
        methods: {
            update() {
                let vm = this;
                const question = vm.question;
                if (question.groupQuestionId)
                    return; // 问题组不更新前端缓存
                const answerContent = vm.$bus.cacheAnswerContent;
                let index = answerContent.findIndex(item => item.questonId === question.id);
                if (index > -1) {
                    answerContent.splice(index, 1);
                }
                const content = question.getAnswerContent('update');
                answerContent.push(content);
                question.triggerAnswerWatcher(answerContent);
                if (vm.$bus.answerDB) {
                    if (vm.changeTimer)
                        clearTimeout(vm.changeTimer);
                    vm.changeTimer = setTimeout(() => {
                        vm.$bus.answerDB.update(vm.$bus.answerId, answerContent);
                        vm.changeTimer = null;
                    }, 300);
                }
            },
            initProgressWatcher() {
                let vm = this;
                if (vm.initWatcherFinished)
                    return;
                let question = vm.question;
                let unwatch;
                const changeHandler = () => {
                    const isPageProgress = vm.$bus.survey.otherSetting.progressStatus === 2;
                    if (isPageProgress) {
                        question._progress = true;
                        if (!vm.$bus.pageList.every(item => item._progress)) {
                            return;
                        }
                    }
                    unwatch && unwatch();
                    unwatch = null;
                    question.runChange = null;
                    // 修改进度条
                    vm.$bus.currentCount++;
                    this.runPreWatchers();
                    if (isPageProgress) {
                        vm.$bus.pageList.forEach(item => {
                            item.runChange && item.runChange();
                        });
                    }
                };
                unwatch = vm.$watch(changeExpr, changeHandler);
                question.runChange = changeHandler;
                vm.$watch(changeExpr, () => {
                    this.update();
                    const items = question.getIssueValue('update');
                    if (!items.length) {
                        vm.$bus.currentCount--;
                        unwatch = vm.$watch(changeExpr, changeHandler);
                    }
                    question.runHooks('updated');
                });
                vm.$watch('question.content.fileList', () => {
                    this.update();
                    question.runHooks('updated', 'file');
                });
                vm.initWatcherFinished = true;
            },
            runPreWatchers() {
                let vm = this;
                const pageList = vm.$bus.pageList;
                let index = pageList.findIndex(item => item.id === vm.question.id);
                if (index === -1)
                    return;
                index--; // 当前的不需要执行
                while (index > -1) {
                    const q = pageList[index];
                    // 已经执行过了 直接退出
                    if (q.runChange === null)
                        break;
                    if (!q.required) {
                        q.runChange && q.runChange();
                    }
                    index--;
                }
            }
        },
        mounted() {
            let vm = this;
            if (vm.nested)
                return;
            vm.question.runHooks('mounted');
        },
        beforeMount() {
            const vm = this;
            if (vm.question.disabledProgress) {
                vm.$watch(changeExpr, () => {
                    vm.question.runHooks('updated');
                });
                vm.$watch('question.content.fileList', () => {
                    vm.question.runHooks('updated', 'file');
                });
                return;
            }
            if (changeDelay) {
                vm.initProgressWatcher();
            }
        }
    };
}

var Blanks$1 = {
    changeExpr: 'changeExpr',
    name: 'Blanks',
    computed: {
        items() {
            // @ts-ignore
            const items = this.issue.items;
            return items.filter(i => i.content);
        },
        changeExpr() {
            // @ts-ignore
            return this.items.map(i => {
                return i.value;
            }).join('-');
        },
        questionErrorText() {
            // @ts-ignore
            return this.question.questionErrorList.map(i => i.message).join('');
        }
    },
    methods: {
        disableCopyMsg() {
            const bus = this.$bus;
            bus.busOption.message(MessageType.WARNING, '禁止复制粘贴');
        },
        onCopy(evt) {
            // @ts-ignore
            if (this.issue.disableCopy) {
                evt.preventDefault();
                this.disableCopyMsg();
                return false;
            }
        },
        onPaste(evt) {
            // @ts-ignore
            if (this.issue.disableCopy) {
                evt.preventDefault();
                this.disableCopyMsg();
                return false;
            }
        },
        onCut(evt) {
            // @ts-ignore
            if (this.issue.disableCopy) {
                evt.preventDefault();
                this.disableCopyMsg();
                return false;
            }
        }
    }
};

function getBus(vm) {
    return vm.$bus;
}
function getPreview(vm) {
    return vm;
}
function getEditSubmitAnswerFn(bus) {
    const params = bus.params;
    if (params.editType === 'agent')
        return editAnswerByAgent;
    return editAnswer;
}
var answerPreview = {
    data() {
        return {
            list: [],
            isView: true,
            isLastPage: true,
            currentPageNum: 0,
            answeredCount: 0,
            // surveyTitle: '',
            // survey: null,
            isScoreSurvey: false,
            isEditAnswer: false,
            answerId: '',
            pageError: false,
            pageErrorMsg: '页面错误'
        };
    },
    computed: Object.assign({ showPrevBtn() {
            const vm = getPreview(this);
            return vm.currentPageNum > 1;
        },
        showNextBtn() {
            const vm = getPreview(this);
            return !vm.isLastPage;
        },
        surveyTitle() {
            const vm = getPreview(this);
            const survey = vm.survey || {};
            return survey.titlex || survey.title;
        },
        disableSubmitButton() {
            return false;
        },
        enableQuestionIndex() {
            const vm = getBus(this);
            return vm.enableQuestionIndex;
        } }, busGetters(['editSubmit', 'survey', 'params'])),
    created() {
        const vm = this;
        // @ts-ignore
        vm.answerId = this.$route.params.id;
        vm.currentPageNum = 0;
        const bus = getBus(this);
        bus.openLoading();
        if (!bus.accountUserFingerprint) {
            getFinger().then(res => {
                if (bus.params.accountUserFingerprint) {
                    bus.accountUserFingerprint = bus.params.accountUserFingerprint;
                }
                else {
                    bus.accountUserFingerprint = res;
                }
                // @ts-ignore
                getSurvey(bus.params).then(res => {
                    bus.initSurvey(Object.assign({}, res));
                    // 编辑调查员时没有answerid，就去创建一个（调查员库）
                    if (vm.answerId === 'null') {
                        // @ts-ignore
                        this.createStartAnswering();
                    }
                    else {
                        // @ts-ignore
                        this.getNextPage();
                    }
                });
            });
        }
        else {
            // @ts-ignore
            this.getNextPage();
        }
    },
    methods: {
        onEditAnswer() {
            const vm = getPreview(this);
            vm.isEditAnswer = true;
        },
        getAnswerContent(list = []) {
            return new Promise((resolve, reject) => {
                const bus = getBus(this);
                const answerList = [];
                const promises = [];
                for (let i = 0, len = list.length; i < len; i++) {
                    let q = list[i];
                    let content = q.getAnswerContent('submit');
                    if (content.items instanceof Promise) {
                        promises.push(content.items.then((res) => {
                            content.items = [res];
                        }));
                    }
                    answerList.push(content);
                    let flag = q.checkAnswer(content, {
                        browserInfo: bus.currentBrowserInfo
                    });
                    if (!flag.success) {
                        return reject(Object.assign({ customError: true }, flag, { question: q }));
                    }
                }
                if (promises.length) {
                    Promise.all(promises).then(() => {
                        resolve(answerList);
                    });
                }
                else {
                    resolve(answerList);
                }
            });
        },
        onSubmitEdit() {
            const vm = getPreview(this);
            const bus = getBus(this);
            bus.openLoading();
            this.getAnswerContent(vm.list).then((answerContent) => {
                let data = {
                    accountUserFingerprint: bus.accountUserFingerprint,
                    accountUserId: bus.params.accountUserId,
                    id: vm.answerId,
                    answerContent
                };
                const fn = getEditSubmitAnswerFn(bus);
                fn(filterParams(data))
                    .then((res) => {
                    bus.closeLoading();
                    vm.isEditAnswer = false;
                    if (res.code !== 0) {
                        if (res.msg) {
                            bus.busOption.message(MessageType.ERROR, res.msg, this);
                        }
                        else {
                            bus.busOption.message(MessageType.ERROR, '未知错误', this);
                        }
                    }
                    vm.currentPageNum--;
                    sendMessage({
                        message: "previewSubmit",
                        payload: {
                            answerId: vm.answerId,
                            success: true
                        }
                    });
                    this.getNextPage();
                })
                    .catch(err => {
                    var _a;
                    bus.closeLoading();
                    if (err.customError) {
                        bus.busOption.message(MessageType.WARNING, err.message, this);
                        (_a = bus.busOption.scroll) === null || _a === void 0 ? void 0 : _a.scrollToQuestion(err.question);
                    }
                });
            }).catch(err => {
                var _a;
                bus.closeLoading();
                if (err.customError) {
                    bus.busOption.message(MessageType.WARNING, err.message, this);
                    (_a = bus.busOption.scroll) === null || _a === void 0 ? void 0 : _a.scrollToQuestion(err.question);
                }
            });
        },
        getPrevPage() {
            const vm = getPreview(this);
            vm.currentPageNum--;
            vm.currentPageNum--;
            this.getNextPage();
        },
        getNextPage() {
            const vm = getPreview(this);
            let answerId = vm.answerId;
            const bus = getBus(this);
            let urlParams = bus.params;
            bus.openLoading();
            getViewAnswer(answerId, vm.currentPageNum, {
                accountUserFingerprint: bus.accountUserFingerprint,
                accountUserId: urlParams.accountUserId,
                token: urlParams.token,
                tenantId: urlParams.tenantId,
                editType: urlParams.editType
            })
                .then((res) => {
                if (res.code !== 0) {
                    return Promise.reject(res);
                }
                bus.closeLoading();
                vm.currentPageNum++;
                let data = res.data;
                vm.answeredCount = data.answeredCount;
                vm.list = convertQuestionList(data.nextPage.map((q) => {
                    getCurrentAnswerHide(q, data.partialHideMap);
                    return q;
                }), data.answeredCount + 1, data.answerContent);
                vm.isLastPage = data.isLastPage;
            })
                .catch(err => {
                if (err.code) {
                    bus.closeLoading();
                    vm.pageErrorMsg = err.msg;
                    addErrorLog({
                        surveyId: vm.survey.id,
                        answerId: vm.answerId,
                        accountUserFingerprint: bus.accountUserFingerprint,
                        accountUserId: bus.params.accountUserId,
                        answerUrl: window.location.href,
                        errTitle: err.msg,
                        errInfo: JSON.stringify({
                            token: urlParams.token,
                            tenantId: urlParams.tenantId
                        })
                    });
                }
                vm.pageError = true;
            });
        }
    }
};

function getEdit(vm) {
    return vm;
}
function getBus$1(vm) {
    return vm.$bus;
}
function getAnswerContent(list = [], bus, vm) {
    return new Promise((resolve, reject) => {
        const answerList = [];
        const promises = [];
        for (let i = 0, len = list.length; i < len; i++) {
            let q = list[i];
            let content = q.getAnswerContent('submit');
            if (content.items instanceof Promise) {
                promises.push(content.items.then((res) => {
                    content.items = [res];
                }));
            }
            answerList.push(content);
            let flag = q.checkAnswer(content, {
                browserInfo: bus.currentBrowserInfo
            });
            if (!flag.success) {
                // 调查员修改，增加报错提示
                if (bus.params.editType === 'investigator') {
                    vm.sendMessage(flag);
                }
                return reject(Object.assign({ customError: true }, { flag }, { question: q }));
            }
        }
        if (promises.length) {
            Promise.all(promises).then(() => {
                resolve(answerList);
            });
        }
        else {
            resolve(answerList);
        }
    });
}
var investigatorMixin = {
    data() {
        return {
            againPhone: false,
            oldAnswerContent: []
        };
    },
    watch: {
        isEditAnswer(val) {
            const vm = getEdit(this);
            const bus = getBus$1(this);
            if (val)
                getAnswerContent(vm.list, bus, vm).then((oldAnswerContent) => {
                    vm.oldAnswerContent = oldAnswerContent;
                });
        }
    },
    methods: {
        // 发送报错提示信息
        sendMessage(flag) {
            const bus = getBus$1(this);
            bus.busOption.message(MessageType.WARNING, flag.message, this);
        },
        // 点击提交事件
        onSubmitEdit() {
            const vm = getEdit(this);
            // 调查员先判断手机号是否重复
            getAnswerIdByPhone({ investigatorPhone: vm.list[1].issue.value }).then(res => {
                if (res.data === null) {
                    this.investigatorEdit(1, 0);
                }
                else {
                    vm.againPhone = true;
                }
            });
        },
        // 编辑调查员
        investigatorEdit(nullValueRule, differentValueRule) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = getEdit(this);
                const bus = getBus$1(this);
                yield getAnswerContent(vm.list, bus, vm).then((answerContent) => __awaiter(this, void 0, void 0, function* () {
                    if (vm.againPhone) {
                        this.saveOldData(answerContent, nullValueRule, differentValueRule);
                    }
                    yield updateById({ id: bus.params.id, investigatorPhone: answerContent[1].items[0].value }).finally(() => {
                        let data = {
                            accountUserFingerprint: bus.accountUserFingerprint,
                            accountUserId: bus.params.accountUserId,
                            id: vm.answerId,
                            answerContent
                        };
                        editAnswer(filterParams(data))
                            .finally(() => {
                            let data = {
                                differentValueRule: differentValueRule,
                                nullValueRule: nullValueRule,
                                surveyId: vm.survey.id,
                                recordSource: 1,
                                answerId: vm.answerId,
                                investigatorName: answerContent[0].items[0].value,
                                investigatorPhone: answerContent[1].items[0].value
                            };
                            this.updateInvestigator(data, () => {
                                bus.busOption.message(MessageType.SUCCESS, '编辑成功', this);
                                if (window.top && window.top !== window) {
                                    window.top.postMessage(JSON.stringify({ message: 'closeEdit' }), '*');
                                }
                            });
                        });
                    });
                }));
            });
        },
        // 手机号重复时，根据设置保存数据
        saveOldData(answerContent, nullValueRule, differentValueRule) {
            const vm = getEdit(this);
            answerContent.forEach((item, index) => {
                if (item.items.length === 0 && nullValueRule === 1) {
                    // 编辑值为空，保留旧数据
                    answerContent[index] = vm.oldAnswerContent[index];
                }
                else if (vm.oldAnswerContent[index].items.length > 0 && differentValueRule === 1) {
                    // 更改数据后，保留旧数据
                    answerContent[index] = vm.oldAnswerContent[index];
                }
            });
        },
        // 将改动与调查员数据绑定
        updateInvestigator(data, fun) {
            const bus = getBus$1(this);
            addorUpdateWjInvestigator(data).then(() => {
                fun();
            })
                .catch(() => {
                bus.busOption.message(MessageType.ERROR, '编辑失败', this);
            });
        },
        // 调查员编辑没有答卷时，创建答卷（调查员库）
        createStartAnswering() {
            const bus = getBus$1(this);
            let data = {
                surveyId: bus.params.surveyId,
                channel: '13',
                answerChannelId: bus.params.answerChannelId,
                accountUserFingerprint: bus.accountUserFingerprint,
                answerUrl: window.location.href.split('#')[0],
                companyid: bus.params.companyid,
                tenantId: bus.params.tenantId
            };
            startAnswering(filterParams(data), {})
                .then((res) => {
                if (res.code !== 0)
                    return;
                let nextPage = res.data.nextPage;
                let answerContent = nextPage.map((item, index) => {
                    return {
                        activePhotoFiles: [],
                        duration: 200,
                        items: [
                            {
                                colId: '',
                                optionId: '',
                                rowId: '',
                                value: index === 0 ? decodeURI(bus.params.investigatorName) : index === 1 ? bus.params.investigatorPhone : ''
                            }
                        ],
                        questionType: item.questionType,
                        questonId: item.id
                    };
                });
                this.createSubmitAnswer(res.data.id, answerContent);
            })
                .catch(err => {
                console.log(err);
            });
        },
        // 调查员编辑没有答卷时的提交以及绑定（调查员库）
        createSubmitAnswer(answerId, data) {
            const bus = getBus$1(this);
            submitAnswer(answerId, data, 0, false, false)
                .then((res) => {
                if (res.code !== 0)
                    return;
                let data = {
                    answerId: res.data.id,
                    differentValueRule: 0,
                    nullValueRule: 1,
                    recordSource: 1,
                    investigatorName: decodeURI(bus.params.investigatorName),
                    investigatorPhone: bus.params.investigatorPhone,
                    surveyId: bus.params.surveyId
                };
                this.updateInvestigator(data, () => {
                    // 创建答卷后刷新页面
                    if (window.top && window.top !== window) {
                        window.top.postMessage(JSON.stringify({ message: 'reload' }), '*');
                    }
                });
            })
                .catch(err => {
                console.log(err);
            });
        }
    }
};

export { AnswerStatus, Blanks$1 as Blanks, BoundFailedType, BoundStatus, Bus, answerPreview as BusData, CascaderStyleType, ErrorCode, FileErrorCode, GD_KEY, H5PlatformInit, H5Platforms, MessageType, OAUTH_INFO_API_URL, PostMessage, Question, Queue, RequiredType, SEPARATOR, SelectType, SubmitErrorCode, UploadConfig, ValidateRule, ValidateType, addErrorLog, addEventListener, addLogStory, addorUpdateWjInvestigator, answerGetAward, answerMixin, answerPreview, answeringThirdSurvey, appendQuotaText, audioFiles, batchProcess, bindExtraAward, bindingPassword, bingAnswerAndGetUser, busGetters, calcNumExpress, cascaderTypes, checkAnswer, checkContent, checkFile, checkFileType, checkPassword, checkQuotaIsFull, checkUrl, checkValidateValue, clearStore, compareDate, componentMap, convertDownloadUrl, convertInputType, convertQuestionList, convertRequest, convertUrl, copyProperty, copyText, cost_settlement_available_companyIds, createIssueFactory, createQuestionFactory, createStyle, dataURLToBlob, dateTypes, defaultsSurveyAttr, defineFillValue, docFiles, downloadFileByStream, downloadFileByUrl, editAnswer, editAnswerByAgent, filterParams, formatSeconds, getAddress, getAllStore, getAnswerChatGPT, getAnswerDimensionScore, getAnswerHistory, getAnswerIdByPhone, getAnswerItemByExpr, getAnswerPoint, getAnswerRes, getAnswerScore, getAwardBySurveyId, getAwardCountBySurveyId, getAwardInfoByAnswerId, getAwardV2BySurveyId, getCanLuck, getCascaderRegion, getChannelById, getComponentFactory, getCurrentAnswerHide, getExprValueByAnswer, getFileStream, getFinger, getGeocode, getH5Platform, getHistoryQuestionAnswer, getImgCode, getInputPrefixIcon, getJsSDKSignature, getMeetConditionsByValue, getMiniProgramScheme, getMoreSurveyList, getMoreSurveyStatus, getOfficialAccountQrcode, getPageConfigByKeys, getPlatformSdk, getPositionList, getShareAnswer, getSpecialSettingStatus, getStatusConfig, getStore, getSurvey, getSurveyById, getSurveyInformedConsent, getSurveyPoint, getTextFillErrorTip, getUserById, getUserInformedConsentSign, getUserStoryByAnswerId, getViewAnswer, hasValue, html2text, imageFiles, initContent, initDefaultsTip, initQuotaCount, invalidMine, investigatorMixin, isOnlyImageType, isPC, isSameValue, isWeixin, jsonp, linkLogoSrc, loadScript, logoSrc, loopList, merge, normalMax, normalMin, normalizeUrlParams, normalizeUrlParamsDouble, objectToQuery, once, padLeft, questionSubType, questionType, randList, reRequest, receiveAward, refreshAnswerAddress, registerMixin, removeStore, request, resetQuestionListNum, rowRandList, secondToTime, sendMessage, sendSmsCode, serialize, setRequestInterceptors, setResponseInterceptors, setStore, showReportAfterAnswer, shuffle, singleTypes, startAnswering, startTestAnswering, submitAnswer, textMap, textTypes, transFormPoint, transformRichText2Text, typeMapping, updateById, updateUserByWxCode, upload, uploadFile, validateCode, validatenull, valueByCalc, videoFiles, zipFiles };
